// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Svg from "../../primitives/Svg.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Label from "../../primitives/Label.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Dialog from "../../resources/overlays/Dialog.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Popover from "../../resources/overlays/Popover.res.js";
import * as Request from "../../core/Request.res.js";
import * as Spinner from "../../resources/feedback-indicators/Spinner.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as CountBadge from "../../resources/feedback-indicators/CountBadge.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as LegacyIcon from "../../resources/images-and-icons/LegacyIcon.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as CatalogLabel from "../../modules/Catalog/CatalogLabel.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as ResourceList from "../../core/ResourceList.res.js";
import * as SpinnerModal from "../../resources/feedback-indicators/SpinnerModal.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as CatalogRoutes from "./CatalogRoutes.res.js";
import * as OpeningButton from "../../resources/actions/OpeningButton.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as StockQuantity from "../../core/StockQuantity.res.js";
import * as ReactStately from "react-stately";
import * as Client from "@apollo/client";
import * as CatalogProduct from "../../modules/Catalog/CatalogProduct.res.js";
import * as LabelTableCell from "../../modules/TableCell/LabelTableCell.res.js";
import * as RadioCardGroup from "../../resources/selection-and-input/RadioCardGroup.res.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as SupplierSelect from "../../modules/Supplier/SupplierSelect.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as PriceCalculator from "../../core/PriceCalculator.res.js";
import * as Primitive_float from "@rescript/runtime/lib/es6/Primitive_float.js";
import * as TriggerDownload from "../../primitives/TriggerDownload.res.js";
import * as UserPreferences from "../../core/UserPreferences.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ResourceListPage from "../../core/ResourceListPage.res.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as StockActivityKind from "../../modules/StockActivity/StockActivityKind.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as InputTextAreaField from "../../resources/selection-and-input/InputTextAreaField.res.js";
import * as CatalogTableActions from "../../modules/Catalog/CatalogTableActions.res.js";
import * as StockActivityReason from "../../modules/StockActivity/StockActivityReason.res.js";
import * as CatalogProducerSelect from "../../modules/Catalog/CatalogProducerSelect.res.js";
import * as ProductStockTableCell from "../../modules/Product/ProductStockTableCell.res.js";
import * as RequestOpenStorageUrl from "../../core/RequestOpenStorageUrl.res.js";
import * as CatalogCategoryEditCell from "../../modules/Catalog/CatalogCategoryEditCell.res.js";
import * as CatalogStockRangeSelect from "../../modules/Catalog/CatalogStockRangeSelect.res.js";
import * as InputOptionalNumberField from "../../resources/selection-and-input/InputOptionalNumberField.res.js";
import * as ProductReferenceTableCell from "../../modules/Product/ProductReferenceTableCell.res.js";
import * as CatalogCategorySelectFilter from "../../modules/Catalog/CatalogCategorySelectFilter.res.js";
import * as CatalogLabelQuickPrintButton from "../../modules/Catalog/CatalogLabelQuickPrintButton.res.js";
import * as CatalogProductEditUrlQueryString from "../../modules/Catalog/CatalogProductEditUrlQueryString.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";
let nonApplicableStringLiteral = "—";
let nonApplicableValueCellElement = JsxRuntime.jsx(Tooltip.make, {
  children: JsxRuntime.jsx(TextStyle.make, {
    children: nonApplicableStringLiteral,
    variation: "normal",
    size: "xsmall"
  }),
  placement: "top",
  content: JsxRuntime.jsx(Tooltip.Span.make, {
    text: I18n.t("Please select a shop beforehand.")
  }),
  delay: 350
});
let Raw = {};
let query = Client.gql(["query CatalogListMultiShopsQuery($search: String, $filterBy: InputVariantsDistinctOnCkuQueryFilter, $orderBy: [InputVariantsDistinctOnCkuOrderBy!], $before: String, $after: String, $first: Int, $last: Int)  {\nvariantsDistinctOnCku(search: $search, filterBy: $filterBy, orderBy: $orderBy, before: $before, after: $after, first: $first, last: $last)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \ncku  \nid  \ncreatedAt  \narchivedAt  \nname  \nproduct  {\n__typename  \nid  \nname  \nkind  \ncolor  \nwineType  \nwhiteWineType  \nbeerType  \nproducer  \ndesignation  \nfamily  \nregion  \ncountry  \ntax  {\n__typename  \nvalue  \n}\n\n}\n\nstockKeepingUnit  \ninternalCode  \npriceLookUpCode  \nsupplier  {\n__typename  \ncompanyName  \n}\n\nalcoholVolume  \npurchasedPrice  \nformattedCategory  \nbulk  \ncapacityUnit  \nmaxStockThreshold  \nminStockThreshold  \nstockOrderTriggerThreshold  \nstock  {\n__typename  \nformattedShopsNames  \nformattedQuantity  \nstate  \n}\n\nformattedStatus  \n}\n\n}\n\ntotalCount  \n}\n\n}\n"]);
function parse(value) {
  let value$1 = value.variantsDistinctOnCku;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    variantsDistinctOnCku: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.archivedAt;
        let value$3 = value$1.product;
        let value$4 = value$3.kind;
        let tmp;
        switch (value$4) {
          case "BEER":
            tmp = "BEER";
            break;
          case "SIMPLE":
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS":
            tmp = "SPIRITUOUS";
            break;
          case "WINE":
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$5 = value$3.color;
        let tmp$1;
        if (value$5 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$5) {
            case "AMBER":
              tmp$2 = "AMBER";
              break;
            case "BLACK":
              tmp$2 = "BLACK";
              break;
            case "BLOND":
              tmp$2 = "BLOND";
              break;
            case "DARK":
              tmp$2 = "DARK";
              break;
            case "ORANGE":
              tmp$2 = "ORANGE";
              break;
            case "RED":
              tmp$2 = "RED";
              break;
            case "ROSE":
              tmp$2 = "ROSE";
              break;
            case "WHITE":
              tmp$2 = "WHITE";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$6 = value$3.wineType;
        let tmp$3;
        if (value$6 == null) {
          tmp$3 = undefined;
        } else {
          let tmp$4;
          switch (value$6) {
            case "EFFERVESCENT":
              tmp$4 = "EFFERVESCENT";
              break;
            case "STILL":
              tmp$4 = "STILL";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$3 = tmp$4;
        }
        let value$7 = value$3.whiteWineType;
        let tmp$5;
        if (value$7 == null) {
          tmp$5 = undefined;
        } else {
          let tmp$6;
          switch (value$7) {
            case "DRY":
              tmp$6 = "DRY";
              break;
            case "SEMIDRY":
              tmp$6 = "SEMIDRY";
              break;
            case "SOFT":
              tmp$6 = "SOFT";
              break;
            case "SWEET":
              tmp$6 = "SWEET";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$5 = tmp$6;
        }
        let value$8 = value$3.beerType;
        let value$9 = value$3.producer;
        let value$10 = value$3.designation;
        let value$11 = value$3.family;
        let value$12 = value$3.region;
        let value$13 = value$3.country;
        let value$14 = value$3.tax;
        let value$15 = value$1.stockKeepingUnit;
        let value$16 = value$1.internalCode;
        let value$17 = value$1.priceLookUpCode;
        let value$18 = value$1.supplier;
        let value$19 = value$1.alcoholVolume;
        let value$20 = value$1.purchasedPrice;
        let value$21 = value$1.formattedCategory;
        let value$22 = value$1.bulk;
        let value$23 = value$1.capacityUnit;
        let value$24 = value$1.maxStockThreshold;
        let value$25 = value$1.minStockThreshold;
        let value$26 = value$1.stockOrderTriggerThreshold;
        let value$27 = value$1.stock;
        let value$28 = value$27.formattedShopsNames;
        let value$29 = value$27.formattedQuantity;
        let value$30 = value$27.state;
        let tmp$7;
        if (value$30 == null) {
          tmp$7 = undefined;
        } else {
          let tmp$8;
          switch (value$30) {
            case "ALERT":
              tmp$8 = "ALERT";
              break;
            case "DANGER":
              tmp$8 = "DANGER";
              break;
            case "OK":
              tmp$8 = "OK";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$7 = tmp$8;
        }
        let value$31 = value$1.formattedStatus;
        let tmp$9;
        switch (value$31) {
          case "ACTIVE":
            tmp$9 = "ACTIVE";
            break;
          case "ARCHIVED":
            tmp$9 = "ARCHIVED";
            break;
          case "INACTIVE":
            tmp$9 = "INACTIVE";
            break;
          case "VARIABLE":
            tmp$9 = "VARIABLE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            cku: Scalar.CKU.parse(value$1.cku),
            id: value$1.id,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
            name: value$1.name,
            product: {
              __typename: value$3.__typename,
              id: value$3.id,
              name: value$3.name,
              kind: tmp,
              color: tmp$1,
              wineType: tmp$3,
              whiteWineType: tmp$5,
              beerType: !(value$8 == null) ? value$8 : undefined,
              producer: !(value$9 == null) ? value$9 : undefined,
              designation: !(value$10 == null) ? value$10 : undefined,
              family: !(value$11 == null) ? value$11 : undefined,
              region: !(value$12 == null) ? value$12 : undefined,
              country: !(value$13 == null) ? value$13 : undefined,
              tax: {
                __typename: value$14.__typename,
                value: value$14.value
              }
            },
            stockKeepingUnit: !(value$15 == null) ? value$15 : undefined,
            internalCode: !(value$16 == null) ? value$16 : undefined,
            priceLookUpCode: !(value$17 == null) ? value$17 : undefined,
            supplier: !(value$18 == null) ? {
              __typename: value$18.__typename,
              companyName: value$18.companyName
            } : undefined,
            alcoholVolume: !(value$19 == null) ? value$19 : undefined,
            purchasedPrice: !(value$20 == null) ? value$20 : undefined,
            formattedCategory: !(value$21 == null) ? value$21 : undefined,
            bulk: !(value$22 == null) ? value$22 : undefined,
            capacityUnit: !(value$23 == null) ? value$23 : undefined,
            maxStockThreshold: !(value$24 == null) ? value$24 : undefined,
            minStockThreshold: !(value$25 == null) ? value$25 : undefined,
            stockOrderTriggerThreshold: !(value$26 == null) ? value$26 : undefined,
            stock: {
              __typename: value$27.__typename,
              formattedShopsNames: !(value$28 == null) ? value$28 : undefined,
              formattedQuantity: !(value$29 == null) ? value$29 : undefined,
              state: tmp$7
            },
            formattedStatus: tmp$9
          }
        };
      }),
      totalCount: value$1.totalCount
    }
  };
}
function serialize(value) {
  let value$1 = value.variantsDistinctOnCku;
  let value$2 = value$1.totalCount;
  let value$3 = value$1.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.formattedStatus;
    let formattedStatus = value$2 === "INACTIVE" ? "INACTIVE" : value$2 === "ARCHIVED" ? "ARCHIVED" : value$2 === "ACTIVE" ? "ACTIVE" : "VARIABLE";
    let value$3 = value$1.stock;
    let value$4 = value$3.state;
    let state = value$4 !== undefined ? value$4 === "OK" ? "OK" : value$4 === "ALERT" ? "ALERT" : "DANGER" : null;
    let value$5 = value$3.formattedQuantity;
    let formattedQuantity = value$5 !== undefined ? value$5 : null;
    let value$6 = value$3.formattedShopsNames;
    let formattedShopsNames = value$6 !== undefined ? value$6 : null;
    let value$7 = value$3.__typename;
    let stock = {
      __typename: value$7,
      formattedShopsNames: formattedShopsNames,
      formattedQuantity: formattedQuantity,
      state: state
    };
    let value$8 = value$1.stockOrderTriggerThreshold;
    let stockOrderTriggerThreshold = value$8 !== undefined ? value$8 : null;
    let value$9 = value$1.minStockThreshold;
    let minStockThreshold = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.maxStockThreshold;
    let maxStockThreshold = value$10 !== undefined ? value$10 : null;
    let value$11 = value$1.capacityUnit;
    let capacityUnit = value$11 !== undefined ? value$11 : null;
    let value$12 = value$1.bulk;
    let bulk = value$12 !== undefined ? value$12 : null;
    let value$13 = value$1.formattedCategory;
    let formattedCategory = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.purchasedPrice;
    let purchasedPrice = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.alcoholVolume;
    let alcoholVolume = value$15 !== undefined ? value$15 : null;
    let value$16 = value$1.supplier;
    let supplier;
    if (value$16 !== undefined) {
      let value$17 = value$16.companyName;
      let value$18 = value$16.__typename;
      supplier = {
        __typename: value$18,
        companyName: value$17
      };
    } else {
      supplier = null;
    }
    let value$19 = value$1.priceLookUpCode;
    let priceLookUpCode = value$19 !== undefined ? value$19 : null;
    let value$20 = value$1.internalCode;
    let internalCode = value$20 !== undefined ? value$20 : null;
    let value$21 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$21 !== undefined ? value$21 : null;
    let value$22 = value$1.product;
    let value$23 = value$22.tax;
    let value$24 = value$23.value;
    let value$25 = value$23.__typename;
    let tax = {
      __typename: value$25,
      value: value$24
    };
    let value$26 = value$22.country;
    let country = value$26 !== undefined ? value$26 : null;
    let value$27 = value$22.region;
    let region = value$27 !== undefined ? value$27 : null;
    let value$28 = value$22.family;
    let family = value$28 !== undefined ? value$28 : null;
    let value$29 = value$22.designation;
    let designation = value$29 !== undefined ? value$29 : null;
    let value$30 = value$22.producer;
    let producer = value$30 !== undefined ? value$30 : null;
    let value$31 = value$22.beerType;
    let beerType = value$31 !== undefined ? value$31 : null;
    let value$32 = value$22.whiteWineType;
    let whiteWineType = value$32 !== undefined ? value$32 === "SWEET" ? "SWEET" : value$32 === "SEMIDRY" ? "SEMIDRY" : value$32 === "SOFT" ? "SOFT" : "DRY" : null;
    let value$33 = value$22.wineType;
    let wineType = value$33 !== undefined ? value$33 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL" : null;
    let value$34 = value$22.color;
    let color = value$34 !== undefined ? value$34 === "ORANGE" ? "ORANGE" : value$34 === "RED" ? "RED" : value$34 === "AMBER" ? "AMBER" : value$34 === "DARK" ? "DARK" : value$34 === "BLACK" ? "BLACK" : value$34 === "BLOND" ? "BLOND" : value$34 === "ROSE" ? "ROSE" : "WHITE" : null;
    let value$35 = value$22.kind;
    let kind = value$35 === "SPIRITUOUS" ? "SPIRITUOUS" : value$35 === "BEER" ? "BEER" : value$35 === "WINE" ? "WINE" : "SIMPLE";
    let value$36 = value$22.name;
    let value$37 = value$22.id;
    let value$38 = value$22.__typename;
    let product = {
      __typename: value$38,
      id: value$37,
      name: value$36,
      kind: kind,
      color: color,
      wineType: wineType,
      whiteWineType: whiteWineType,
      beerType: beerType,
      producer: producer,
      designation: designation,
      family: family,
      region: region,
      country: country,
      tax: tax
    };
    let value$39 = value$1.name;
    let value$40 = value$1.archivedAt;
    let archivedAt = value$40 !== undefined ? Scalar.Datetime.serialize(value$40) : null;
    let value$41 = value$1.createdAt;
    let value$42 = Scalar.Datetime.serialize(value$41);
    let value$43 = value$1.id;
    let value$44 = value$1.cku;
    let value$45 = Scalar.CKU.serialize(value$44);
    let value$46 = value$1.__typename;
    let node = {
      __typename: value$46,
      cku: value$45,
      id: value$43,
      createdAt: value$42,
      archivedAt: archivedAt,
      name: value$39,
      product: product,
      stockKeepingUnit: stockKeepingUnit,
      internalCode: internalCode,
      priceLookUpCode: priceLookUpCode,
      supplier: supplier,
      alcoholVolume: alcoholVolume,
      purchasedPrice: purchasedPrice,
      formattedCategory: formattedCategory,
      bulk: bulk,
      capacityUnit: capacityUnit,
      maxStockThreshold: maxStockThreshold,
      minStockThreshold: minStockThreshold,
      stockOrderTriggerThreshold: stockOrderTriggerThreshold,
      stock: stock,
      formattedStatus: formattedStatus
    };
    let value$47 = value.__typename;
    return {
      __typename: value$47,
      node: node
    };
  });
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let variantsDistinctOnCku = {
    __typename: value$8,
    pageInfo: pageInfo,
    edges: edges,
    totalCount: value$2
  };
  return {
    variantsDistinctOnCku: variantsDistinctOnCku
  };
}
function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectBooleanEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}
function serializeInputObjectInputVariantsDistinctOnCkuQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.active;
  let a$2 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter(a) : undefined,
    active: a$1 !== undefined ? {
      _equals: a$1._equals
    } : undefined,
    archived: a$2 !== undefined ? a$2 === "ONLY" ? "ONLY" : a$2 === "INCLUDED" ? "INCLUDED" : "EXCLUDED" : undefined
  };
}
function serializeInputObjectInputVariantsDistinctOnCkuOrderBy(inp) {
  let a = inp.createdAt;
  let a$1 = inp.active;
  let a$2 = inp.name;
  let a$3 = inp.producer;
  let a$4 = inp.purchasedPrice;
  return {
    createdAt: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    active: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined,
    name: a$2 !== undefined ? a$2 === "DESC" ? "DESC" : "ASC" : undefined,
    producer: a$3 !== undefined ? a$3 === "DESC" ? "DESC" : "ASC" : undefined,
    purchasedPrice: a$4 !== undefined ? a$4 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.filterBy;
  let a$2 = inp.orderBy;
  let a$3 = inp.before;
  let a$4 = inp.after;
  let a$5 = inp.first;
  let a$6 = inp.last;
  return {
    search: a !== undefined ? a : undefined,
    filterBy: a$1 !== undefined ? serializeInputObjectInputVariantsDistinctOnCkuQueryFilter(a$1) : undefined,
    orderBy: a$2 !== undefined ? a$2.map(serializeInputObjectInputVariantsDistinctOnCkuOrderBy) : undefined,
    before: a$3 !== undefined ? a$3 : undefined,
    after: a$4 !== undefined ? a$4 : undefined,
    first: a$5 !== undefined ? a$5 : undefined,
    last: a$6 !== undefined ? a$6 : undefined
  };
}
function makeVariables(search, filterBy, orderBy, before, after, first, last) {
  return {
    search: search,
    filterBy: filterBy,
    orderBy: orderBy,
    before: before,
    after: after,
    first: first,
    last: last
  };
}
function makeInputObjectInputVariantsDistinctOnCkuQueryFilter(shopIds, active, archived, param) {
  return {
    shopIds: shopIds,
    active: active,
    archived: archived
  };
}
function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectBooleanEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}
function makeInputObjectInputVariantsDistinctOnCkuOrderBy(createdAt, active, name, producer, purchasedPrice, param) {
  return {
    createdAt: createdAt,
    active: active,
    name: name,
    producer: producer,
    purchasedPrice: purchasedPrice
  };
}
function makeDefaultVariables() {
  return {
    search: undefined,
    filterBy: undefined,
    orderBy: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined
  };
}
let CatalogListMultiShopsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsDistinctOnCkuQueryFilter: serializeInputObjectInputVariantsDistinctOnCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectInputVariantsDistinctOnCkuOrderBy: serializeInputObjectInputVariantsDistinctOnCkuOrderBy,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsDistinctOnCkuQueryFilter: makeInputObjectInputVariantsDistinctOnCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectInputVariantsDistinctOnCkuOrderBy: makeInputObjectInputVariantsDistinctOnCkuOrderBy,
  makeDefaultVariables: makeDefaultVariables
};
let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});
let use = include.use;
let CatalogListMultiShopsQuery_refetchQueryDescription = include.refetchQueryDescription;
let CatalogListMultiShopsQuery_useLazy = include.useLazy;
let CatalogListMultiShopsQuery_useLazyWithVariables = include.useLazyWithVariables;
let CatalogListMultiShopsQuery = {
  CatalogListMultiShopsQuery_inner: CatalogListMultiShopsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputVariantsDistinctOnCkuQueryFilter: serializeInputObjectInputVariantsDistinctOnCkuQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter,
  serializeInputObjectInputVariantsDistinctOnCkuOrderBy: serializeInputObjectInputVariantsDistinctOnCkuOrderBy,
  makeVariables: makeVariables,
  makeInputObjectInputVariantsDistinctOnCkuQueryFilter: makeInputObjectInputVariantsDistinctOnCkuQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter,
  makeInputObjectInputVariantsDistinctOnCkuOrderBy: makeInputObjectInputVariantsDistinctOnCkuOrderBy,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: CatalogListMultiShopsQuery_refetchQueryDescription,
  use: use,
  useLazy: CatalogListMultiShopsQuery_useLazy,
  useLazyWithVariables: CatalogListMultiShopsQuery_useLazyWithVariables
};
let Raw$1 = {};
let query$1 = Client.gql(["query CatalogListSingleShopQuery($search: String, $filterBy: InputVariantsQueryFilter, $orderBy: [InputVariantsOrderBy!], $orderByOrderProducts: [InputVariantOrderProductsOrderBy!], $before: String, $after: String, $first: Int, $last: Int)  {\nvariants(search: $search, filterBy: $filterBy, orderBy: $orderBy, before: $before, after: $after, first: $first, last: $last)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \ncku  \nid  \ncreatedAt  \nname  \nproduct  {\n__typename  \nid  \nname  \nkind  \ncolor  \nwineType  \nwhiteWineType  \nbeerType  \nproducer  \ndesignation  \nfamily  \nregion  \ncountry  \ntax  {\n__typename  \nvalue  \n}\n\n}\n\npurchasedPrice  \nvariantPrices  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nvalueIncludingTax  \nvalueExcludingTax  \nprice  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\norderProducts(first: 1, filterBy: {receptionFinishedAt: {_after: \"1970-01-01T00:00:00Z\"}}, orderBy: $orderByOrderProducts)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nquantity  \ntotalLocalDiscounts  \nfees  \n}\n\n}\n\n}\n\nstockKeepingUnit  \ninternalCode  \npriceLookUpCode  \narchivedAt  \nsupplier  {\n__typename  \ncompanyName  \n}\n\nalcoholVolume  \nformattedCategory  \nbulk  \ncapacityUnit  \nmaxStockThreshold  \nminStockThreshold  \nstockOrderTriggerThreshold  \nstock  {\n__typename  \nformattedShopsNames  \nformattedQuantity  \nstate  \n}\n\nformattedStatus  \n}\n\n}\n\n}\n\n}\n"]);
function parse$1(value) {
  let value$1 = value.variants;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    variants: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.product;
        let value$3 = value$2.kind;
        let tmp;
        switch (value$3) {
          case "BEER":
            tmp = "BEER";
            break;
          case "SIMPLE":
            tmp = "SIMPLE";
            break;
          case "SPIRITUOUS":
            tmp = "SPIRITUOUS";
            break;
          case "WINE":
            tmp = "WINE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$4 = value$2.color;
        let tmp$1;
        if (value$4 == null) {
          tmp$1 = undefined;
        } else {
          let tmp$2;
          switch (value$4) {
            case "AMBER":
              tmp$2 = "AMBER";
              break;
            case "BLACK":
              tmp$2 = "BLACK";
              break;
            case "BLOND":
              tmp$2 = "BLOND";
              break;
            case "DARK":
              tmp$2 = "DARK";
              break;
            case "ORANGE":
              tmp$2 = "ORANGE";
              break;
            case "RED":
              tmp$2 = "RED";
              break;
            case "ROSE":
              tmp$2 = "ROSE";
              break;
            case "WHITE":
              tmp$2 = "WHITE";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$1 = tmp$2;
        }
        let value$5 = value$2.wineType;
        let tmp$3;
        if (value$5 == null) {
          tmp$3 = undefined;
        } else {
          let tmp$4;
          switch (value$5) {
            case "EFFERVESCENT":
              tmp$4 = "EFFERVESCENT";
              break;
            case "STILL":
              tmp$4 = "STILL";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$3 = tmp$4;
        }
        let value$6 = value$2.whiteWineType;
        let tmp$5;
        if (value$6 == null) {
          tmp$5 = undefined;
        } else {
          let tmp$6;
          switch (value$6) {
            case "DRY":
              tmp$6 = "DRY";
              break;
            case "SEMIDRY":
              tmp$6 = "SEMIDRY";
              break;
            case "SOFT":
              tmp$6 = "SOFT";
              break;
            case "SWEET":
              tmp$6 = "SWEET";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$5 = tmp$6;
        }
        let value$7 = value$2.beerType;
        let value$8 = value$2.producer;
        let value$9 = value$2.designation;
        let value$10 = value$2.family;
        let value$11 = value$2.region;
        let value$12 = value$2.country;
        let value$13 = value$2.tax;
        let value$14 = value$1.purchasedPrice;
        let value$15 = value$1.variantPrices;
        let value$16 = value$15.edges;
        let value$17 = value$1.orderProducts;
        let value$18 = value$17.edges;
        let value$19 = value$1.stockKeepingUnit;
        let value$20 = value$1.internalCode;
        let value$21 = value$1.priceLookUpCode;
        let value$22 = value$1.archivedAt;
        let value$23 = value$1.supplier;
        let value$24 = value$1.alcoholVolume;
        let value$25 = value$1.formattedCategory;
        let value$26 = value$1.bulk;
        let value$27 = value$1.capacityUnit;
        let value$28 = value$1.maxStockThreshold;
        let value$29 = value$1.minStockThreshold;
        let value$30 = value$1.stockOrderTriggerThreshold;
        let value$31 = value$1.stock;
        let value$32 = value$31.formattedShopsNames;
        let value$33 = value$31.formattedQuantity;
        let value$34 = value$31.state;
        let tmp$7;
        if (value$34 == null) {
          tmp$7 = undefined;
        } else {
          let tmp$8;
          switch (value$34) {
            case "ALERT":
              tmp$8 = "ALERT";
              break;
            case "DANGER":
              tmp$8 = "DANGER";
              break;
            case "OK":
              tmp$8 = "OK";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$7 = tmp$8;
        }
        let value$35 = value$1.formattedStatus;
        let tmp$9;
        switch (value$35) {
          case "ACTIVE":
            tmp$9 = "ACTIVE";
            break;
          case "ARCHIVED":
            tmp$9 = "ARCHIVED";
            break;
          case "INACTIVE":
            tmp$9 = "INACTIVE";
            break;
          case "VARIABLE":
            tmp$9 = "VARIABLE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            cku: Scalar.CKU.parse(value$1.cku),
            id: value$1.id,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            name: value$1.name,
            product: {
              __typename: value$2.__typename,
              id: value$2.id,
              name: value$2.name,
              kind: tmp,
              color: tmp$1,
              wineType: tmp$3,
              whiteWineType: tmp$5,
              beerType: !(value$7 == null) ? value$7 : undefined,
              producer: !(value$8 == null) ? value$8 : undefined,
              designation: !(value$9 == null) ? value$9 : undefined,
              family: !(value$10 == null) ? value$10 : undefined,
              region: !(value$11 == null) ? value$11 : undefined,
              country: !(value$12 == null) ? value$12 : undefined,
              tax: {
                __typename: value$13.__typename,
                value: value$13.value
              }
            },
            purchasedPrice: !(value$14 == null) ? value$14 : undefined,
            variantPrices: {
              __typename: value$15.__typename,
              edges: value$16.map(value => {
                let value$1 = value.node;
                let value$2 = value$1.price;
                return {
                  __typename: value.__typename,
                  node: {
                    __typename: value$1.__typename,
                    id: value$1.id,
                    valueIncludingTax: value$1.valueIncludingTax,
                    valueExcludingTax: value$1.valueExcludingTax,
                    price: !(value$2 == null) ? {
                      __typename: value$2.__typename,
                      id: value$2.id
                    } : undefined
                  }
                };
              })
            },
            orderProducts: {
              __typename: value$17.__typename,
              edges: value$18.map(value => {
                let value$1 = value.node;
                return {
                  __typename: value.__typename,
                  node: {
                    __typename: value$1.__typename,
                    quantity: value$1.quantity,
                    totalLocalDiscounts: value$1.totalLocalDiscounts,
                    fees: value$1.fees
                  }
                };
              })
            },
            stockKeepingUnit: !(value$19 == null) ? value$19 : undefined,
            internalCode: !(value$20 == null) ? value$20 : undefined,
            priceLookUpCode: !(value$21 == null) ? value$21 : undefined,
            archivedAt: !(value$22 == null) ? Scalar.Datetime.parse(value$22) : undefined,
            supplier: !(value$23 == null) ? {
              __typename: value$23.__typename,
              companyName: value$23.companyName
            } : undefined,
            alcoholVolume: !(value$24 == null) ? value$24 : undefined,
            formattedCategory: !(value$25 == null) ? value$25 : undefined,
            bulk: !(value$26 == null) ? value$26 : undefined,
            capacityUnit: !(value$27 == null) ? value$27 : undefined,
            maxStockThreshold: !(value$28 == null) ? value$28 : undefined,
            minStockThreshold: !(value$29 == null) ? value$29 : undefined,
            stockOrderTriggerThreshold: !(value$30 == null) ? value$30 : undefined,
            stock: {
              __typename: value$31.__typename,
              formattedShopsNames: !(value$32 == null) ? value$32 : undefined,
              formattedQuantity: !(value$33 == null) ? value$33 : undefined,
              state: tmp$7
            },
            formattedStatus: tmp$9
          }
        };
      })
    }
  };
}
function serialize$1(value) {
  let value$1 = value.variants;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.formattedStatus;
    let formattedStatus = value$2 === "INACTIVE" ? "INACTIVE" : value$2 === "ARCHIVED" ? "ARCHIVED" : value$2 === "ACTIVE" ? "ACTIVE" : "VARIABLE";
    let value$3 = value$1.stock;
    let value$4 = value$3.state;
    let state = value$4 !== undefined ? value$4 === "OK" ? "OK" : value$4 === "ALERT" ? "ALERT" : "DANGER" : null;
    let value$5 = value$3.formattedQuantity;
    let formattedQuantity = value$5 !== undefined ? value$5 : null;
    let value$6 = value$3.formattedShopsNames;
    let formattedShopsNames = value$6 !== undefined ? value$6 : null;
    let value$7 = value$3.__typename;
    let stock = {
      __typename: value$7,
      formattedShopsNames: formattedShopsNames,
      formattedQuantity: formattedQuantity,
      state: state
    };
    let value$8 = value$1.stockOrderTriggerThreshold;
    let stockOrderTriggerThreshold = value$8 !== undefined ? value$8 : null;
    let value$9 = value$1.minStockThreshold;
    let minStockThreshold = value$9 !== undefined ? value$9 : null;
    let value$10 = value$1.maxStockThreshold;
    let maxStockThreshold = value$10 !== undefined ? value$10 : null;
    let value$11 = value$1.capacityUnit;
    let capacityUnit = value$11 !== undefined ? value$11 : null;
    let value$12 = value$1.bulk;
    let bulk = value$12 !== undefined ? value$12 : null;
    let value$13 = value$1.formattedCategory;
    let formattedCategory = value$13 !== undefined ? value$13 : null;
    let value$14 = value$1.alcoholVolume;
    let alcoholVolume = value$14 !== undefined ? value$14 : null;
    let value$15 = value$1.supplier;
    let supplier;
    if (value$15 !== undefined) {
      let value$16 = value$15.companyName;
      let value$17 = value$15.__typename;
      supplier = {
        __typename: value$17,
        companyName: value$16
      };
    } else {
      supplier = null;
    }
    let value$18 = value$1.archivedAt;
    let archivedAt = value$18 !== undefined ? Scalar.Datetime.serialize(value$18) : null;
    let value$19 = value$1.priceLookUpCode;
    let priceLookUpCode = value$19 !== undefined ? value$19 : null;
    let value$20 = value$1.internalCode;
    let internalCode = value$20 !== undefined ? value$20 : null;
    let value$21 = value$1.stockKeepingUnit;
    let stockKeepingUnit = value$21 !== undefined ? value$21 : null;
    let value$22 = value$1.orderProducts;
    let value$23 = value$22.edges;
    let edges = value$23.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.fees;
      let value$3 = value$1.totalLocalDiscounts;
      let value$4 = value$1.quantity;
      let value$5 = value$1.__typename;
      let node = {
        __typename: value$5,
        quantity: value$4,
        totalLocalDiscounts: value$3,
        fees: value$2
      };
      let value$6 = value.__typename;
      return {
        __typename: value$6,
        node: node
      };
    });
    let value$24 = value$22.__typename;
    let orderProducts = {
      __typename: value$24,
      edges: edges
    };
    let value$25 = value$1.variantPrices;
    let value$26 = value$25.edges;
    let edges$1 = value$26.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.price;
      let price;
      if (value$2 !== undefined) {
        let value$3 = value$2.id;
        let value$4 = value$2.__typename;
        price = {
          __typename: value$4,
          id: value$3
        };
      } else {
        price = null;
      }
      let value$5 = value$1.valueExcludingTax;
      let value$6 = value$1.valueIncludingTax;
      let value$7 = value$1.id;
      let value$8 = value$1.__typename;
      let node = {
        __typename: value$8,
        id: value$7,
        valueIncludingTax: value$6,
        valueExcludingTax: value$5,
        price: price
      };
      let value$9 = value.__typename;
      return {
        __typename: value$9,
        node: node
      };
    });
    let value$27 = value$25.__typename;
    let variantPrices = {
      __typename: value$27,
      edges: edges$1
    };
    let value$28 = value$1.purchasedPrice;
    let purchasedPrice = value$28 !== undefined ? value$28 : null;
    let value$29 = value$1.product;
    let value$30 = value$29.tax;
    let value$31 = value$30.value;
    let value$32 = value$30.__typename;
    let tax = {
      __typename: value$32,
      value: value$31
    };
    let value$33 = value$29.country;
    let country = value$33 !== undefined ? value$33 : null;
    let value$34 = value$29.region;
    let region = value$34 !== undefined ? value$34 : null;
    let value$35 = value$29.family;
    let family = value$35 !== undefined ? value$35 : null;
    let value$36 = value$29.designation;
    let designation = value$36 !== undefined ? value$36 : null;
    let value$37 = value$29.producer;
    let producer = value$37 !== undefined ? value$37 : null;
    let value$38 = value$29.beerType;
    let beerType = value$38 !== undefined ? value$38 : null;
    let value$39 = value$29.whiteWineType;
    let whiteWineType = value$39 !== undefined ? value$39 === "SWEET" ? "SWEET" : value$39 === "SEMIDRY" ? "SEMIDRY" : value$39 === "SOFT" ? "SOFT" : "DRY" : null;
    let value$40 = value$29.wineType;
    let wineType = value$40 !== undefined ? value$40 === "EFFERVESCENT" ? "EFFERVESCENT" : "STILL" : null;
    let value$41 = value$29.color;
    let color = value$41 !== undefined ? value$41 === "ORANGE" ? "ORANGE" : value$41 === "RED" ? "RED" : value$41 === "AMBER" ? "AMBER" : value$41 === "DARK" ? "DARK" : value$41 === "BLACK" ? "BLACK" : value$41 === "BLOND" ? "BLOND" : value$41 === "ROSE" ? "ROSE" : "WHITE" : null;
    let value$42 = value$29.kind;
    let kind = value$42 === "SPIRITUOUS" ? "SPIRITUOUS" : value$42 === "BEER" ? "BEER" : value$42 === "WINE" ? "WINE" : "SIMPLE";
    let value$43 = value$29.name;
    let value$44 = value$29.id;
    let value$45 = value$29.__typename;
    let product = {
      __typename: value$45,
      id: value$44,
      name: value$43,
      kind: kind,
      color: color,
      wineType: wineType,
      whiteWineType: whiteWineType,
      beerType: beerType,
      producer: producer,
      designation: designation,
      family: family,
      region: region,
      country: country,
      tax: tax
    };
    let value$46 = value$1.name;
    let value$47 = value$1.createdAt;
    let value$48 = Scalar.Datetime.serialize(value$47);
    let value$49 = value$1.id;
    let value$50 = value$1.cku;
    let value$51 = Scalar.CKU.serialize(value$50);
    let value$52 = value$1.__typename;
    let node = {
      __typename: value$52,
      cku: value$51,
      id: value$49,
      createdAt: value$48,
      name: value$46,
      product: product,
      purchasedPrice: purchasedPrice,
      variantPrices: variantPrices,
      orderProducts: orderProducts,
      stockKeepingUnit: stockKeepingUnit,
      internalCode: internalCode,
      priceLookUpCode: priceLookUpCode,
      archivedAt: archivedAt,
      supplier: supplier,
      alcoholVolume: alcoholVolume,
      formattedCategory: formattedCategory,
      bulk: bulk,
      capacityUnit: capacityUnit,
      maxStockThreshold: maxStockThreshold,
      minStockThreshold: minStockThreshold,
      stockOrderTriggerThreshold: stockOrderTriggerThreshold,
      stock: stock,
      formattedStatus: formattedStatus
    };
    let value$53 = value.__typename;
    return {
      __typename: value$53,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let variants = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    variants: variants
  };
}
function serializeInputObjectInFilter$1(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectNullableStringEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a !== undefined ? a : undefined
  };
}
function serializeInputObjectNumberRangeFilter(inp) {
  let a = inp._min;
  let a$1 = inp._max;
  let a$2 = inp._between;
  return {
    _min: a !== undefined ? a : undefined,
    _max: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}
function serializeInputObjectInputVariantOrderProductsOrderBy(inp) {
  let a = inp.createdAt;
  let a$1 = inp.receptionFinishedAt;
  return {
    createdAt: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    receptionFinishedAt: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeInputObjectInputVariantsOrderBy(inp) {
  let a = inp.createdAt;
  let a$1 = inp.active;
  let a$2 = inp.name;
  let a$3 = inp.producer;
  let a$4 = inp.purchasedPrice;
  return {
    createdAt: a !== undefined ? a === "DESC" ? "DESC" : "ASC" : undefined,
    active: a$1 !== undefined ? a$1 === "DESC" ? "DESC" : "ASC" : undefined,
    name: a$2 !== undefined ? a$2 === "DESC" ? "DESC" : "ASC" : undefined,
    producer: a$3 !== undefined ? a$3 === "DESC" ? "DESC" : "ASC" : undefined,
    purchasedPrice: a$4 !== undefined ? a$4 === "DESC" ? "DESC" : "ASC" : undefined
  };
}
function serializeInputObjectInputVariantsQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.stockKeepingUnit;
  let a$2 = inp.ean13;
  let a$3 = inp.active;
  let a$4 = inp.archived;
  let a$5 = inp.createdAt;
  let a$6 = inp.updatedAt;
  let a$7 = inp.categoryId;
  let a$8 = inp.supplierId;
  let a$9 = inp.stock;
  let a$10 = inp.producer;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$1(a) : undefined,
    stockKeepingUnit: a$1 !== undefined ? {
      _equals: a$1._equals
    } : undefined,
    ean13: a$2 !== undefined ? {
      _equals: a$2._equals
    } : undefined,
    active: a$3 !== undefined ? {
      _equals: a$3._equals
    } : undefined,
    archived: a$4 !== undefined ? a$4 === "ONLY" ? "ONLY" : a$4 === "INCLUDED" ? "INCLUDED" : "EXCLUDED" : undefined,
    createdAt: a$5 !== undefined ? serializeInputObjectDateFilter(a$5) : undefined,
    updatedAt: a$6 !== undefined ? serializeInputObjectDateFilter(a$6) : undefined,
    categoryId: a$7 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$7) : undefined,
    supplierId: a$8 !== undefined ? serializeInputObjectNullableStringEqualsFilter(a$8) : undefined,
    stock: a$9 !== undefined ? serializeInputObjectNumberRangeFilter(a$9) : undefined,
    producer: a$10 !== undefined ? {
      _equals: a$10._equals
    } : undefined
  };
}
function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}
function serializeInputObjectBooleanEqualsFilter$1(inp) {
  return {
    _equals: inp._equals
  };
}
function serializeVariables$1(inp) {
  let a = inp.search;
  let a$1 = inp.filterBy;
  let a$2 = inp.orderBy;
  let a$3 = inp.orderByOrderProducts;
  let a$4 = inp.before;
  let a$5 = inp.after;
  let a$6 = inp.first;
  let a$7 = inp.last;
  return {
    search: a !== undefined ? a : undefined,
    filterBy: a$1 !== undefined ? serializeInputObjectInputVariantsQueryFilter(a$1) : undefined,
    orderBy: a$2 !== undefined ? a$2.map(serializeInputObjectInputVariantsOrderBy) : undefined,
    orderByOrderProducts: a$3 !== undefined ? a$3.map(serializeInputObjectInputVariantOrderProductsOrderBy) : undefined,
    before: a$4 !== undefined ? a$4 : undefined,
    after: a$5 !== undefined ? a$5 : undefined,
    first: a$6 !== undefined ? a$6 : undefined,
    last: a$7 !== undefined ? a$7 : undefined
  };
}
function makeVariables$1(search, filterBy, orderBy, orderByOrderProducts, before, after, first, last) {
  return {
    search: search,
    filterBy: filterBy,
    orderBy: orderBy,
    orderByOrderProducts: orderByOrderProducts,
    before: before,
    after: after,
    first: first,
    last: last
  };
}
function makeInputObjectInputVariantsQueryFilter(shopIds, stockKeepingUnit, ean13, active, archived, createdAt, updatedAt, categoryId, supplierId, stock, producer, param) {
  return {
    shopIds: shopIds,
    stockKeepingUnit: stockKeepingUnit,
    ean13: ean13,
    active: active,
    archived: archived,
    createdAt: createdAt,
    updatedAt: updatedAt,
    categoryId: categoryId,
    supplierId: supplierId,
    stock: stock,
    producer: producer
  };
}
function makeInputObjectInFilter$1(_in, param) {
  return {
    _in: _in
  };
}
function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}
function makeInputObjectBooleanEqualsFilter$1(_equals, param) {
  return {
    _equals: _equals
  };
}
function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}
function makeInputObjectNullableStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}
function makeInputObjectNumberRangeFilter(_min, _max, _between, param) {
  return {
    _min: _min,
    _max: _max,
    _between: _between
  };
}
function makeInputObjectInputVariantsOrderBy(createdAt, active, name, producer, purchasedPrice, param) {
  return {
    createdAt: createdAt,
    active: active,
    name: name,
    producer: producer,
    purchasedPrice: purchasedPrice
  };
}
function makeInputObjectInputVariantOrderProductsOrderBy(createdAt, receptionFinishedAt, param) {
  return {
    createdAt: createdAt,
    receptionFinishedAt: receptionFinishedAt
  };
}
function makeDefaultVariables$1() {
  return {
    search: undefined,
    filterBy: undefined,
    orderBy: undefined,
    orderByOrderProducts: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined
  };
}
let CatalogListSingleShopQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter$1,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  serializeInputObjectInputVariantsOrderBy: serializeInputObjectInputVariantsOrderBy,
  serializeInputObjectInputVariantOrderProductsOrderBy: serializeInputObjectInputVariantOrderProductsOrderBy,
  makeVariables: makeVariables$1,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter$1,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeInputObjectInputVariantsOrderBy: makeInputObjectInputVariantsOrderBy,
  makeInputObjectInputVariantOrderProductsOrderBy: makeInputObjectInputVariantOrderProductsOrderBy,
  makeDefaultVariables: makeDefaultVariables$1
};
let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});
let use$1 = include$1.use;
let CatalogListSingleShopQuery_refetchQueryDescription = include$1.refetchQueryDescription;
let CatalogListSingleShopQuery_useLazy = include$1.useLazy;
let CatalogListSingleShopQuery_useLazyWithVariables = include$1.useLazyWithVariables;
let CatalogListSingleShopQuery = {
  CatalogListSingleShopQuery_inner: CatalogListSingleShopQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputVariantsQueryFilter: serializeInputObjectInputVariantsQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectBooleanEqualsFilter: serializeInputObjectBooleanEqualsFilter$1,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  serializeInputObjectNullableStringEqualsFilter: serializeInputObjectNullableStringEqualsFilter,
  serializeInputObjectNumberRangeFilter: serializeInputObjectNumberRangeFilter,
  serializeInputObjectInputVariantsOrderBy: serializeInputObjectInputVariantsOrderBy,
  serializeInputObjectInputVariantOrderProductsOrderBy: serializeInputObjectInputVariantOrderProductsOrderBy,
  makeVariables: makeVariables$1,
  makeInputObjectInputVariantsQueryFilter: makeInputObjectInputVariantsQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectBooleanEqualsFilter: makeInputObjectBooleanEqualsFilter$1,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeInputObjectNullableStringEqualsFilter: makeInputObjectNullableStringEqualsFilter,
  makeInputObjectNumberRangeFilter: makeInputObjectNumberRangeFilter,
  makeInputObjectInputVariantsOrderBy: makeInputObjectInputVariantsOrderBy,
  makeInputObjectInputVariantOrderProductsOrderBy: makeInputObjectInputVariantOrderProductsOrderBy,
  makeDefaultVariables: makeDefaultVariables$1,
  refetchQueryDescription: CatalogListSingleShopQuery_refetchQueryDescription,
  use: use$1,
  useLazy: CatalogListSingleShopQuery_useLazy,
  useLazyWithVariables: CatalogListSingleShopQuery_useLazyWithVariables
};
let tableLoadingMultiShopsOperations = [query];
let tableLoadingSingleShopOperations = [query$1];
let Raw$2 = {};
let query$2 = Client.gql(["query PricesQuery($filterBy: InputPricesQueryFilter)  {\nprices(first: 50, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nname  \nenableByDefault  \ntaxIncluded  \n}\n\n}\n\n}\n\n}\n"]);
function parse$2(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  return {
    prices: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            name: value$1.name,
            enableByDefault: value$1.enableByDefault,
            taxIncluded: value$1.taxIncluded
          }
        };
      })
    }
  };
}
function serialize$2(value) {
  let value$1 = value.prices;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.taxIncluded;
    let value$3 = value$1.enableByDefault;
    let value$4 = value$1.name;
    let value$5 = value$1.id;
    let value$6 = value$1.__typename;
    let node = {
      __typename: value$6,
      id: value$5,
      name: value$4,
      enableByDefault: value$3,
      taxIncluded: value$2
    };
    let value$7 = value.__typename;
    return {
      __typename: value$7,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let prices = {
    __typename: value$3,
    edges: edges
  };
  return {
    prices: prices
  };
}
function serializeInputObjectInFilter$2(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}
function serializeInputObjectInputPricesQueryFilter(inp) {
  let a = inp.shopIds;
  let a$1 = inp.archived;
  return {
    shopIds: a !== undefined ? serializeInputObjectInFilter$2(a) : undefined,
    archived: a$1 !== undefined ? a$1 === "ONLY" ? "ONLY" : a$1 === "INCLUDED" ? "INCLUDED" : "EXCLUDED" : undefined
  };
}
function serializeVariables$2(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputPricesQueryFilter(a) : undefined
  };
}
function makeVariables$2(filterBy) {
  return {
    filterBy: filterBy
  };
}
function makeInputObjectInputPricesQueryFilter(shopIds, archived, param) {
  return {
    shopIds: shopIds,
    archived: archived
  };
}
function makeInputObjectInFilter$2(_in, param) {
  return {
    _in: _in
  };
}
function makeDefaultVariables$2() {
  return {
    filterBy: undefined
  };
}
let SingleShopPricesQuery_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  serializeInputObjectInputPricesQueryFilter: serializeInputObjectInputPricesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$2,
  makeVariables: makeVariables$2,
  makeInputObjectInputPricesQueryFilter: makeInputObjectInputPricesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$2,
  makeDefaultVariables: makeDefaultVariables$2
};
let include$2 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});
let use$2 = include$2.use;
let SingleShopPricesQuery_refetchQueryDescription = include$2.refetchQueryDescription;
let SingleShopPricesQuery_useLazy = include$2.useLazy;
let SingleShopPricesQuery_useLazyWithVariables = include$2.useLazyWithVariables;
let SingleShopPricesQuery = {
  SingleShopPricesQuery_inner: SingleShopPricesQuery_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  serializeInputObjectInputPricesQueryFilter: serializeInputObjectInputPricesQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter$2,
  makeVariables: makeVariables$2,
  makeInputObjectInputPricesQueryFilter: makeInputObjectInputPricesQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter$2,
  makeDefaultVariables: makeDefaultVariables$2,
  refetchQueryDescription: SingleShopPricesQuery_refetchQueryDescription,
  use: use$2,
  useLazy: SingleShopPricesQuery_useLazy,
  useLazyWithVariables: SingleShopPricesQuery_useLazyWithVariables
};
function singleShopQueryVariables(shopIds) {
  return {
    filterBy: {
      shopIds: {
        _in: shopIds
      },
      archived: undefined
    }
  };
}
function singleShopQueryResult(queryResult) {
  return queryResult.prices.edges.map(edge => ({
    id: edge.node.id,
    name: edge.node.name,
    enableByDefault: edge.node.enableByDefault,
    taxIncluded: edge.node.taxIncluded
  }));
}
function getCurrentPricelist(pricelists, currentPriceId) {
  return Stdlib_Option.orElse(pricelists.find(pricelist => {
    if (currentPriceId !== undefined) {
      return pricelist.id === currentPriceId;
    } else {
      return false;
    }
  }), pricelists[0]);
}
let CatalogListPricelist = {
  SingleShopPricesQuery: SingleShopPricesQuery,
  singleShopQueryVariables: singleShopQueryVariables,
  singleShopQueryResult: singleShopQueryResult,
  getCurrentPricelist: getCurrentPricelist
};
function keyExtractor(param) {
  return param.id;
}
function decodeFeesJsonToFeesList(feesJson) {
  let initialFeesList = {
    transportAmount: 0,
    taxesAmount: 0,
    otherAmount: 0
  };
  let jsonFees = Json.decodeArray(feesJson);
  if (jsonFees !== undefined) {
    return Stdlib_Array.reduce(jsonFees, initialFeesList, (acc, feeJson) => {
      let kind = Json.flatDecodeDictFieldString(Json.decodeDict(feeJson), "kind");
      let amount = Json.flatDecodeDictFieldFloat(Json.decodeDict(feeJson), "amount");
      if (kind === undefined) {
        return acc;
      }
      switch (kind) {
        case "Other":
          if (amount !== undefined) {
            return {
              transportAmount: acc.transportAmount,
              taxesAmount: acc.taxesAmount,
              otherAmount: PriceCalculator.sumManyCharges([acc.otherAmount, amount])
            };
          } else {
            return acc;
          }
        case "Taxes":
          if (amount !== undefined) {
            return {
              transportAmount: acc.transportAmount,
              taxesAmount: PriceCalculator.sumManyCharges([acc.taxesAmount, amount]),
              otherAmount: acc.otherAmount
            };
          } else {
            return acc;
          }
        case "Transport":
          if (amount !== undefined) {
            return {
              transportAmount: PriceCalculator.sumManyCharges([acc.transportAmount, amount]),
              taxesAmount: acc.taxesAmount,
              otherAmount: acc.otherAmount
            };
          } else {
            return acc;
          }
        default:
          return acc;
      }
    });
  } else {
    return initialFeesList;
  }
}
function computeNetPurchasePrice(value, discount) {
  return PriceCalculator.Purchase.toNetValue(value, discount);
}
function computeFullPurchasePrice(purchasePrice, taxesFeeAmount, otherFeeAmount) {
  let charges = PriceCalculator.sumManyCharges([taxesFeeAmount, otherFeeAmount]);
  return PriceCalculator.Purchase.toValueWithCharges(purchasePrice, charges);
}
function computeAcquisitionCost(purchasePrice, transportFeeAmount, taxesFeeAmount, otherFeeAmount) {
  let charges = PriceCalculator.sumManyCharges([transportFeeAmount, taxesFeeAmount, otherFeeAmount]);
  return PriceCalculator.Purchase.toValueWithCharges(purchasePrice, charges);
}
let CatalogListTableRow = {
  keyExtractor: keyExtractor,
  decodeFeesJsonToFeesList: decodeFeesJsonToFeesList,
  computeNetPurchasePrice: computeNetPurchasePrice,
  computeFullPurchasePrice: computeFullPurchasePrice,
  computeAcquisitionCost: computeAcquisitionCost
};
let make = React.memo(props => {
  let notification = props.notification;
  if (notification === undefined) {
    return null;
  }
  let tmp;
  tmp = notification.TAG === "Ok" ? {
    TAG: "Success",
    _0: notification._0
  } : {
    TAG: "Danger",
    _0: notification._0
  };
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Banner.make, {
      textStatus: tmp,
      onRequestClose: props.onRequestClose
    }),
    spaceX: "large",
    spaceTop: "medium",
    spaceBottom: "xsmall"
  });
});
let CatalogListNotificationBanner = {
  make: make
};
function toString(value) {
  if (value === "Gross") {
    return "gross";
  } else {
    return "net";
  }
}
function fromString(value) {
  switch (value) {
    case "gross":
      return {
        TAG: "Ok",
        _0: "Gross"
      };
    case "net":
      return {
        TAG: "Ok",
        _0: "Net"
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}
let PurchasePriceType = {
  toString: toString,
  fromString: fromString
};
function toString$1(value) {
  switch (value) {
    case "Coefficient":
      return "coefficient";
    case "MarginRate":
      return "margin-rate";
    case "MarkupRate":
      return "markup-rate";
  }
}
function fromString$1(value) {
  switch (value) {
    case "coefficient":
      return {
        TAG: "Ok",
        _0: "Coefficient"
      };
    case "margin-rate":
      return {
        TAG: "Ok",
        _0: "MarginRate"
      };
    case "markup-rate":
      return {
        TAG: "Ok",
        _0: "MarkupRate"
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}
function toLabel(value) {
  switch (value) {
    case "Coefficient":
      return I18n.t("Coefficient");
    case "MarginRate":
      return I18n.t("Margin rate");
    case "MarkupRate":
      return I18n.t("Markup rate");
  }
}
function toShortLabel(value) {
  switch (value) {
    case "Coefficient":
      return I18n.t("Coefficient");
    case "MarginRate":
      return I18n.t("Margin rt");
    case "MarkupRate":
      return I18n.t("Markup rt");
  }
}
let PriceDifferentialIndicator = {
  toString: toString$1,
  fromString: fromString$1,
  toLabel: toLabel,
  toShortLabel: toShortLabel
};
function toLabel$1(value) {
  switch (value) {
    case "PurchasePrice":
      return I18n.t("Purchase price");
    case "FullPurchasePrice":
      return I18n.t("Full purchase price");
    case "AcquisitionCost":
      return I18n.t("Acquisition cost");
  }
}
function toString$2(value) {
  switch (value) {
    case "PurchasePrice":
      return "purchase-price";
    case "FullPurchasePrice":
      return "full-purchase-price";
    case "AcquisitionCost":
      return "acquisition-cost";
  }
}
function fromString$2(value) {
  switch (value) {
    case "acquisition-cost":
      return {
        TAG: "Ok",
        _0: "AcquisitionCost"
      };
    case "full-purchase-price":
      return {
        TAG: "Ok",
        _0: "FullPurchasePrice"
      };
    case "purchase-price":
      return {
        TAG: "Ok",
        _0: "PurchasePrice"
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}
let RetailPriceCalculatingMethod = {
  toLabel: toLabel$1,
  toString: toString$2,
  fromString: fromString$2
};
let initialValue = {
  purchasePriceType: "Gross",
  priceDifferentialIndicator: "Coefficient",
  retailPriceCalculatingMethod: "PurchasePrice"
};
let jsonCodec = JsonCodec.object3(param => [toString(param.purchasePriceType), toString$1(param.priceDifferentialIndicator), toString$2(param.retailPriceCalculatingMethod)], param => {
  let match = fromString(param[0]);
  let match$1 = fromString$1(param[1]);
  let match$2 = fromString$2(param[2]);
  if (match.TAG === "Ok" && match$1.TAG === "Ok" && match$2.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: {
        purchasePriceType: match._0,
        priceDifferentialIndicator: match$1._0,
        retailPriceCalculatingMethod: match$2._0
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: "Could not decode values"
      }
    };
  }
}, JsonCodec.field("purchasePriceType", JsonCodec.string), JsonCodec.field("priceDifferentialIndicator", JsonCodec.string), JsonCodec.field("retailPriceCalculatingMethod", JsonCodec.string));
function encoder(state) {
  return JsonCodec.encodeWith(state, jsonCodec);
}
function decoder(json) {
  return JsonCodec.decodeWith(json, jsonCodec);
}
function read() {
  return UserPreferences.read("catalog-page-settings", decoder);
}
function store(state) {
  UserPreferences.store(state, "catalog-page-settings", encoder);
}
let UserPreferences$1 = {
  jsonCodec: jsonCodec,
  encoder: encoder,
  decoder: decoder,
  read: read,
  store: store
};
let CatalogListPricingSettings = {
  PurchasePriceType: PurchasePriceType,
  PriceDifferentialIndicator: PriceDifferentialIndicator,
  RetailPriceCalculatingMethod: RetailPriceCalculatingMethod,
  initialValue: initialValue,
  UserPreferences: UserPreferences$1
};
let priceDifferentialIndicatorItems = [{
  value: "coefficient",
  title: I18n.t("catalog_list.pricing_settings.section_1.radio_1.title"),
  description: I18n.t("catalog_list.pricing_settings.section_1.radio_1.description")
}, {
  value: "margin-rate",
  title: I18n.t("catalog_list.pricing_settings.section_1.radio_2.title"),
  description: I18n.t("catalog_list.pricing_settings.section_1.radio_2.description")
}, {
  value: "markup-rate",
  title: I18n.t("catalog_list.pricing_settings.section_1.radio_3.title"),
  description: I18n.t("catalog_list.pricing_settings.section_1.radio_3.description")
}];
let purchasePriceTypeItems = [{
  value: "gross",
  title: I18n.t("Gross"),
  description: I18n.t("catalog_list.pricing_settings.section_2.radio_1.description")
}, {
  value: "net",
  title: I18n.t("Net"),
  description: I18n.t("catalog_list.pricing_settings.section_2.radio_2.description")
}];
let retailPriceCalculatingMethodItems = [{
  value: "purchase-price",
  title: I18n.t("Purchase price"),
  tooltip: I18n.t("catalog_list.pricing_settings.section_3.radio_1.tooltip"),
  description: I18n.t("catalog_list.pricing_settings.section_3.radio_1.description")
}, {
  value: "full-purchase-price",
  title: I18n.t("Full purchase price"),
  tooltip: I18n.t("catalog_list.pricing_settings.section_3.radio_2.tooltip"),
  description: I18n.t("catalog_list.pricing_settings.section_3.radio_2.description")
}, {
  value: "acquisition-cost",
  title: I18n.t("Acquisition cost"),
  tooltip: I18n.t("catalog_list.pricing_settings.section_3.radio_3.tooltip"),
  description: I18n.t("catalog_list.pricing_settings.section_3.radio_3.description")
}];
let make$1 = React.memo(props => {
  let __settingsUserPreferencesStore = props.settingsUserPreferencesStore;
  let __settingsUserPreferencesRead = props.settingsUserPreferencesRead;
  let onChange = props.onChange;
  let settingsUserPreferencesRead = __settingsUserPreferencesRead !== undefined ? __settingsUserPreferencesRead : read;
  let settingsUserPreferencesStore = __settingsUserPreferencesStore !== undefined ? __settingsUserPreferencesStore : store;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let match$1 = React.useState(() => Stdlib_Option.getOr(settingsUserPreferencesRead(), initialValue));
  let setInitialSettings = match$1[1];
  let initialSettings = match$1[0];
  let match$2 = React.useState(() => initialSettings);
  let setSettings = match$2[1];
  let settings = match$2[0];
  let captureEvent = SessionTracker.useCaptureEvent();
  React.useEffect(() => {
    onChange(initialSettings);
  }, [initialSettings]);
  React.useEffect(() => {
    setSettings(param => initialSettings);
  }, [popover.isOpen]);
  let onCommitSettings = React.useCallback(() => {
    setInitialSettings(param => settings);
    settingsUserPreferencesStore(settings);
    popover.close();
    captureEvent("catalog_settings_click_save");
  }, [settings]);
  let priceDifferentialIndicatorValue = toString$1(settings.priceDifferentialIndicator);
  let onChangePriceDifferentialIndicatorValue = value => setSettings(prev => ({
    purchasePriceType: prev.purchasePriceType,
    priceDifferentialIndicator: Stdlib_Result.getExn(fromString$1(value), undefined),
    retailPriceCalculatingMethod: prev.retailPriceCalculatingMethod
  }));
  let purchasePriceTypeValue = toString(settings.purchasePriceType);
  let onChangePurchasePriceTypeValue = value => setSettings(prev => ({
    purchasePriceType: Stdlib_Result.getExn(fromString(value), undefined),
    priceDifferentialIndicator: prev.priceDifferentialIndicator,
    retailPriceCalculatingMethod: prev.retailPriceCalculatingMethod
  }));
  let retailPriceCalculatingMethodValue = toString$2(settings.retailPriceCalculatingMethod);
  let onChangeRetailPriceCalculatingMethodValue = value => setSettings(prev => ({
    purchasePriceType: prev.purchasePriceType,
    priceDifferentialIndicator: prev.priceDifferentialIndicator,
    retailPriceCalculatingMethod: Stdlib_Result.getExn(fromString$2(value), undefined)
  }));
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(Button.make, {
      ariaProps: popoverAriaProps.triggerProps,
      tone: {
        NAME: "neutral",
        VAL: {
          quiet: true
        }
      },
      active: popover.isOpen,
      icon: "legacy_settings",
      ref: popoverTriggerRef
    }), popover.isOpen ? JsxRuntime.jsx(Popover.make, {
      children: JsxRuntime.jsxs(Dialog.make, {
        ariaProps: popoverAriaProps.overlayProps,
        children: [JsxRuntime.jsxs(Dialog.Section.make, {
          children: [JsxRuntime.jsx(RadioCardGroup.make, {
            items: priceDifferentialIndicatorItems,
            value: priceDifferentialIndicatorValue,
            onChange: onChangePriceDifferentialIndicatorValue
          }), JsxRuntime.jsx(NextBanner.make, {
            children: JsxRuntime.jsx(NextBanner.Text.make, {
              text: I18n.t("catalog_list.pricing_settings.section_1.banner.text")
            }),
            variation: "info"
          })],
          title: I18n.t("catalog_list.pricing_settings.section_1.title"),
          tooltip: JsxRuntime.jsx(JsxRuntime.Fragment, {
            children: JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.pricing_settings.section_1.tooltip")
            })
          })
        }), JsxRuntime.jsx(Dialog.Section.make, {
          children: JsxRuntime.jsx(RadioCardGroup.make, {
            items: purchasePriceTypeItems,
            value: purchasePriceTypeValue,
            onChange: onChangePurchasePriceTypeValue
          }),
          title: I18n.t("catalog_list.pricing_settings.section_2.title"),
          tooltip: JsxRuntime.jsx(JsxRuntime.Fragment, {
            children: JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.pricing_settings.section_2.tooltip")
            })
          })
        }), JsxRuntime.jsx(Dialog.Section.make, {
          children: JsxRuntime.jsx(RadioCardGroup.make, {
            orientation: "vertical",
            items: retailPriceCalculatingMethodItems,
            value: retailPriceCalculatingMethodValue,
            onChange: onChangeRetailPriceCalculatingMethodValue
          }),
          title: I18n.t("catalog_list.pricing_settings.section_3.title"),
          tooltip: JsxRuntime.jsx(JsxRuntime.Fragment, {
            children: JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.pricing_settings.section_3.tooltip")
            })
          })
        })],
        header: {
          TAG: "Title",
          _0: {
            text: I18n.t("Settings")
          }
        },
        commitDisabled: Primitive_object.equal(settings, initialSettings),
        commitButtonText: I18n.t("Save settings"),
        onRequestCommit: onCommitSettings,
        onRequestDiscard: popover.close
      }),
      triggerRef: popoverTriggerRef,
      state: popover,
      placement: "bottom start",
      modal: false,
      offset: 4
    }) : null]
  });
});
let CatalogListSettingsPopoverButton = {
  priceDifferentialIndicatorItems: priceDifferentialIndicatorItems,
  purchasePriceTypeItems: purchasePriceTypeItems,
  retailPriceCalculatingMethodItems: retailPriceCalculatingMethodItems,
  make: make$1
};
let endpoint = Env.sheetUrl() + "/inventory-export";
function encodeRequestBodyJson(shopIds, variantsActive, variantsArchived, categoryId, supplierId, producer, stock, param) {
  let filterBy = {};
  filterBy["shopIds"] = Json.encodeDict(Object.fromEntries([["_in", Json.encodeArray(shopIds.map(Json.encodeString))]]));
  if (variantsActive !== undefined) {
    filterBy["active"] = Json.encodeDict(Object.fromEntries([["_equals", Json.encodeBoolean(variantsActive)]]));
  }
  if (variantsArchived !== undefined) {
    filterBy["archived"] = Json.encodeString(variantsArchived ? "ONLY" : "EXCLUDED");
  } else {
    filterBy["archived"] = Json.encodeString("INCLUDED");
  }
  if (categoryId !== undefined) {
    let categoryId$1 = Primitive_option.valFromOption(categoryId);
    filterBy["categoryId"] = Json.encodeDict(Object.fromEntries([["_equals", categoryId$1 == null ? null : Json.encodeString(categoryId$1)]]));
  }
  if (supplierId !== undefined) {
    let supplierId$1 = Primitive_option.valFromOption(supplierId);
    filterBy["supplierId"] = Json.encodeDict(Object.fromEntries([["_equals", supplierId$1 == null ? null : Json.encodeString(supplierId$1)]]));
  }
  if (producer !== undefined) {
    filterBy["producer"] = Json.encodeDict(Object.fromEntries([["_equals", Json.encodeString(producer)]]));
  }
  if (stock !== undefined) {
    let max = stock.max;
    let min = stock.min;
    filterBy["stock"] = Json.encodeDict(Object.fromEntries([min !== undefined ? ["_min", Json.encodeNumber(min)] : ["_min", null], max !== undefined ? ["_max", Json.encodeNumber(max)] : ["_max", null]]));
  }
  return Json.encodeDict(Object.fromEntries([["filterBy", Json.encodeDict(filterBy)], ["timeZone", Json.encodeString(I18n.timeZone)]]));
}
function make$2(shopIds, variantsActive, variantsArchived, categoryId, supplierId, producer, stock, param) {
  return Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: encodeRequestBodyJson(shopIds, variantsActive, variantsArchived, categoryId, supplierId, producer, stock, undefined)
  }, undefined, undefined);
}
function mapError(param) {
  return "UnexpectedFailure";
}
function messageFromError(error) {
  return I18n.t("catalog_list_page.inventory_export_request.unexpected_failure");
}
function useDownload(request, shopIds, variantsActive, variantsArchived, categoryId, supplierId, producer, stock, param) {
  let captureEvent = SessionTracker.useCaptureEvent();
  let request$1 = () => {
    captureEvent("download_catalog_inventory_export_file");
    return request(shopIds, variantsActive, variantsArchived, categoryId, supplierId, producer, stock, undefined);
  };
  let match = RequestOpenStorageUrl.use(request$1, undefined, undefined);
  let result = AsyncResult.mapError(match[0], mapError);
  return [result, match[1]];
}
function CatalogListPage$CatalogListInventoryExportRequest$ShortIconButton(props) {
  let onRequestNotification = props.onRequestNotification;
  let __request = props.request;
  let request = __request !== undefined ? __request : make$2;
  let match = useDownload(request, props.shopIds, props.variantsActive, props.variantsArchived, props.categoryId, props.supplierId, props.producer, props.stock, undefined);
  let operationResult = match[0];
  React.useEffect(() => {
    if (typeof operationResult === "object" && operationResult.TAG === "Done") {
      let error = operationResult._0;
      if (error.TAG === "Ok") {
        onRequestNotification({
          TAG: "Ok",
          _0: I18n.template(I18n.t("The {{name}} file has been downloaded successfully."), {
            name: I18n.t("inventory")
          }, undefined)
        });
      } else {
        onRequestNotification({
          TAG: "Error",
          _0: I18n.t("catalog_list_page.inventory_export_request.unexpected_failure")
        });
      }
    }
  }, [AsyncResult.isDone(operationResult)]);
  return JsxRuntime.jsx(Button.make, {
    tone: {
      NAME: "neutral",
      VAL: {
        quiet: true
      }
    },
    pending: AsyncData.isBusy(operationResult),
    icon: "download_v2",
    statusLight: props.activeFilters,
    tooltipText: props.tooltip,
    onPress: match[1]
  });
}
let ShortIconButton = {
  make: CatalogListPage$CatalogListInventoryExportRequest$ShortIconButton
};
let CatalogListInventoryExportRequest = {
  endpoint: endpoint,
  encodeRequestBodyJson: encodeRequestBodyJson,
  make: make$2,
  mapError: mapError,
  messageFromError: messageFromError,
  useDownload: useDownload,
  ShortIconButton: ShortIconButton
};
let endpoint$1 = Env.sheetUrl() + "/variants-price-look-up-codes";
function encodeRequestBodyJson$1(shopId, variantsActive, variantsArchived, param) {
  let body = {};
  body["shopId"] = Json.encodeString(shopId);
  if (variantsActive !== undefined) {
    body["variantsActive"] = Json.encodeBoolean(variantsActive);
  }
  if (variantsArchived !== undefined) {
    body["variantsArchived"] = Json.encodeBoolean(variantsArchived);
  }
  return Json.encodeDict(body);
}
function make$3(shopId, variantsActive, variantsArchived, param) {
  return Request.make(endpoint$1, "POST", {
    TAG: "JsonBody",
    _0: encodeRequestBodyJson$1(shopId, variantsActive, variantsArchived, undefined)
  }, undefined, undefined);
}
function mapError$1(param) {
  return "UnexpectedFailure";
}
let successMessage = I18n.template(I18n.t("The {{name}} file has been downloaded successfully."), {
  name: I18n.t("PLU codes")
}, undefined);
function messageFromError$1(error) {
  return I18n.template(I18n.t("An issue when attempting downloading the {{name}} file occurred."), {
    name: I18n.t("PLU codes")
  }, undefined);
}
function useDownload$1(shopId, variantsActive, variantsArchived, param) {
  let captureEvent = SessionTracker.useCaptureEvent();
  let request = () => {
    captureEvent("download_catalog_plu_export_file");
    return make$3(shopId, variantsActive, variantsArchived, undefined);
  };
  let match = RequestOpenStorageUrl.use(request, undefined, undefined);
  let result = AsyncResult.mapError(match[0], mapError$1);
  return [result, match[1]];
}
let PluExportRequest = {
  endpoint: endpoint$1,
  encodeRequestBodyJson: encodeRequestBodyJson$1,
  make: make$3,
  mapError: mapError$1,
  successMessage: successMessage,
  messageFromError: messageFromError$1,
  useDownload: useDownload$1
};
let endpoint$2 = Env.gatewayUrl() + "/variants-centralization";
function encodeRequestBodyJson$2() {
  return Json.encodeDict({});
}
function decodeRequestResponseJson(json) {
  let decodedIssuesCount = Json.flatDecodeDictField(Json.decodeDict(json), "issuesCount", Json.decodeNumber);
  let decodedPatchesCount = Json.flatDecodeDictField(Json.decodeDict(json), "patchesCount", Json.decodeNumber);
  let decodedFileUrl = Json.flatDecodeDictFieldString(Json.flatDecodeDictField(Json.decodeDict(json), "file", Json.decodeDict), "url");
  if (decodedIssuesCount !== undefined && decodedPatchesCount !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        issuesCount: decodedIssuesCount | 0,
        patchesCount: decodedPatchesCount | 0,
        fileUrl: Stdlib_Option.map(decodedFileUrl, prim => new URL(prim))
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: "MalformedResponse"
    };
  }
}
function renderPatchesText(patchesCount) {
  return JsxRuntime.jsx(TextStyle.make, {
    children: I18n.template("▪ " + I18n.t(I18n.isPlural(patchesCount) ? "{{productCount}} new products have been successfully centralized." : "1 new product has been successfully centralized."), {
      productCount: patchesCount.toString()
    }, undefined),
    variation: "success",
    weight: "medium"
  });
}
function renderIssuesText(issuesCount) {
  return JsxRuntime.jsx(TextStyle.make, {
    children: I18n.template("▪ " + I18n.t(I18n.isPlural(issuesCount) ? "{{productCount}} errors detected, some products could not be centralized." : "1 error detected, a product could not be centralized."), {
      productCount: issuesCount.toString()
    }, undefined),
    variation: "negative",
    weight: "medium"
  });
}
let make$4 = React.memo(props => {
  let onRequestClose = props.onRequestClose;
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Following the launch of the catalog centralization operation, here are the results obtained:")
        }), JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(TextStyle.make, {
            children: "▪ " + I18n.t("no new product has been centralized."),
            weight: "medium"
          }),
          spaceLeft: "small"
        })]
      }), JsxRuntime.jsxs(InlineText.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("To know more about the catalog centralization") + ", "
        }), JsxRuntime.jsx(TextAction.make, {
          text: I18n.t("please visit the help center."),
          highlighted: true,
          onPress: props.onPressHelpCenterText
        })]
      })],
      space: "medium"
    }), JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Close"),
        size: "large",
        onPress: () => onRequestClose()
      }),
      align: "end",
      grow: true
    })],
    space: "xxlarge"
  });
});
let NoIssueNoPatchView = {
  make: make$4
};
let make$5 = React.memo(props => {
  let onRequestDownloadFile = props.onRequestDownloadFile;
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Following the launch of the catalog centralization operation, here are the results obtained:")
        }), JsxRuntime.jsxs(Box.make, {
          children: [JsxRuntime.jsx(TextStyle.make, {
            children: "▪ " + I18n.t("no new product has been centralized."),
            weight: "medium"
          }), renderIssuesText(props.issuesCount)],
          spaceLeft: "small"
        })]
      }), JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("The products could not be centralized because identical SKUs were detected within the same store. Click on the \"Download errors reporting\" button to retrieve the list of products to correct.")
      }), JsxRuntime.jsxs(InlineText.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("To find out what corrections need to be made") + ", "
        }), JsxRuntime.jsx(TextAction.make, {
          text: I18n.t("please visit the help center."),
          highlighted: true,
          onPress: props.onPressHelpCenterText
        })]
      })],
      space: "medium"
    }), JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Download errors reporting"),
        variant: "solid",
        tone: "brand",
        size: "large",
        onPress: () => onRequestDownloadFile()
      }),
      align: "end",
      grow: true
    })],
    space: "xxlarge"
  });
});
let IssueNoPatchView = {
  make: make$5
};
let make$6 = React.memo(props => {
  let onRequestClose = props.onRequestClose;
  return JsxRuntime.jsx(Stack.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("Following the launch of the catalog centralization operation, here are the results obtained:")
          }), JsxRuntime.jsx(Box.make, {
            children: renderPatchesText(props.patchesCount),
            spaceLeft: "small"
          })]
        }), JsxRuntime.jsxs(InlineText.make, {
          children: [JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("To know more about the catalog centralization") + ", "
          }), JsxRuntime.jsx(TextAction.make, {
            text: I18n.t("please visit the help center."),
            highlighted: true,
            onPress: props.onPressHelpCenterText
          })]
        })],
        space: "medium"
      }), JsxRuntime.jsx(Inline.make, {
        children: JsxRuntime.jsx(Button.make, {
          label: I18n.t("Close"),
          size: "large",
          onPress: () => onRequestClose()
        }),
        align: "end",
        grow: true
      })],
      space: "xxlarge"
    }),
    space: "xxlarge"
  });
});
let NoIssuePatchView = {
  make: make$6
};
let make$7 = React.memo(props => {
  let onRequestDownloadFile = props.onRequestDownloadFile;
  return JsxRuntime.jsx(Stack.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("Following the launch of the catalog centralization operation, here are the results obtained:")
          }), JsxRuntime.jsxs(Box.make, {
            children: [renderPatchesText(props.patchesCount), renderIssuesText(props.issuesCount)],
            spaceLeft: "small"
          })]
        }), JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("The products could not be centralized because identical SKUs were detected within the same store. Click on the \"Download errors reporting\" button to retrieve the list of products to correct.")
        }), JsxRuntime.jsxs(InlineText.make, {
          children: [JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("To find out what corrections need to be made") + ", "
          }), JsxRuntime.jsx(TextAction.make, {
            text: I18n.t("please visit the help center."),
            highlighted: true,
            onPress: props.onPressHelpCenterText
          })]
        })],
        space: "medium"
      }), JsxRuntime.jsx(Inline.make, {
        children: JsxRuntime.jsx(Button.make, {
          label: I18n.t("Download errors reporting"),
          variant: "solid",
          tone: "brand",
          size: "large",
          onPress: () => onRequestDownloadFile()
        }),
        align: "end",
        grow: true
      })],
      space: "xxlarge"
    }),
    space: "xxlarge"
  });
});
let IssuePatchView = {
  make: make$7
};
let make$8 = React.memo(props => {
  let onRequestClose = props.onRequestClose;
  let onRequestErrorNotification = props.onRequestErrorNotification;
  let fileUrl = props.fileUrl;
  let patchesCount = props.patchesCount;
  let issuesCount = props.issuesCount;
  let match = React.useState(() => true);
  let setOpened = match[1];
  let onPressHelpCenterText = () => HelpCenter.showArticle(HelpCenter.howCentralizeCatalog);
  let onRequestClose$1 = () => {
    setOpened(param => false);
    onRequestClose();
  };
  let onRequestDownloadFile = () => Stdlib_Option.forEach(fileUrl, url => Future.get(Future.mapError(TriggerDownload.fromUrl(undefined, url), undefined, () => onRequestErrorNotification(I18n.template(I18n.t("An issue when attempting downloading the {{name}} file occurred."), {
    name: I18n.t("errors report")
  }, undefined))), param => {
    setOpened(param => false);
    onRequestClose();
  }));
  let match$1 = issuesCount > 0;
  let match$2 = patchesCount > 0;
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: match$1 ? match$2 ? JsxRuntime.jsx(make$7, {
        issuesCount: issuesCount,
        patchesCount: patchesCount,
        onPressHelpCenterText: onPressHelpCenterText,
        onRequestDownloadFile: onRequestDownloadFile
      }) : JsxRuntime.jsx(make$5, {
        issuesCount: issuesCount,
        onPressHelpCenterText: onPressHelpCenterText,
        onRequestDownloadFile: onRequestDownloadFile
      }) : match$2 ? JsxRuntime.jsx(make$6, {
        patchesCount: patchesCount,
        onPressHelpCenterText: onPressHelpCenterText,
        onRequestClose: onRequestClose$1
      }) : JsxRuntime.jsx(make$4, {
        onPressHelpCenterText: onPressHelpCenterText,
        onRequestClose: onRequestClose$1
      }),
      spaceX: "xlarge",
      spaceY: "xlarge"
    }),
    opened: match[0],
    title: I18n.t("Centralize catalogs"),
    variation: "secondary",
    hideFooter: true,
    onRequestClose: onRequestClose$1
  });
});
let ReportModal = {
  renderPatchesText: renderPatchesText,
  renderIssuesText: renderIssuesText,
  NoIssueNoPatchView: NoIssueNoPatchView,
  IssueNoPatchView: IssueNoPatchView,
  NoIssuePatchView: NoIssuePatchView,
  IssuePatchView: IssuePatchView,
  make: make$8
};
let CentralizeCatalogRequest = {
  endpoint: endpoint$2,
  encodeRequestBodyJson: encodeRequestBodyJson$2,
  decodeRequestResponseJson: decodeRequestResponseJson,
  ReportModal: ReportModal
};
function CatalogListPage$CatalogListMorePageMenuActions(props) {
  let onRequestNotification = props.onRequestNotification;
  let shopId = props.shopId;
  let match = useDownload$1(Stdlib_Option.getOr(shopId, ""), props.variantsActive, props.variantsArchived, undefined);
  let requestPluDownload = match[1];
  let pluResult = match[0];
  let match$1 = React.useState(() => "NotAsked");
  let setCentralizeCatalogAsyncResult = match$1[1];
  let centralizeCatalogAsyncResult = match$1[0];
  React.useEffect(() => {
    if (typeof pluResult === "object" && pluResult.TAG === "Done") {
      let error = pluResult._0;
      if (error.TAG === "Ok") {
        onRequestNotification({
          TAG: "Ok",
          _0: successMessage
        });
      } else {
        onRequestNotification({
          TAG: "Error",
          _0: messageFromError$1(error._0)
        });
      }
    }
  }, [AsyncResult.isDone(pluResult)]);
  React.useEffect(() => {
    if (typeof centralizeCatalogAsyncResult === "object" && centralizeCatalogAsyncResult.TAG === "Done" && centralizeCatalogAsyncResult._0.TAG !== "Ok") {
      onRequestNotification({
        TAG: "Error",
        _0: I18n.t("catalog_list_page.centralize_catalog_request.unexpected_failure")
      });
    }
  }, [centralizeCatalogAsyncResult]);
  let handleCentralizeCatalogRequest = () => {
    setCentralizeCatalogAsyncResult(param => "Loading");
    Future.get(Future.map(Request.make(endpoint$2, "POST", {
      TAG: "JsonBody",
      _0: Json.encodeDict({})
    }, undefined, undefined), undefined, json => Stdlib_Result.flatMap(json, decodeRequestResponseJson)), result => {
      if (result.TAG !== "Ok") {
        return setCentralizeCatalogAsyncResult(param => ({
          TAG: "Done",
          _0: {
            TAG: "Error",
            _0: undefined
          }
        }));
      }
      let data = result._0;
      let heuristicTimeout = 1000 + (data.patchesCount * 175 | 0) | 0;
      setTimeout(() => setCentralizeCatalogAsyncResult(param => ({
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: data
        }
      })), heuristicTimeout);
    });
  };
  let spinnerModalTitle = AsyncData.isBusy(pluResult) ? I18n.t("Export PLU codes") : AsyncResult.isBusy(centralizeCatalogAsyncResult) ? I18n.t("Centralize catalogs") : "";
  let spinnerModalOpened = AsyncData.isBusy(pluResult) || AsyncResult.isBusy(centralizeCatalogAsyncResult);
  let exportPluActionDisabled = Stdlib_Option.isNone(shopId);
  let tmp;
  if (typeof centralizeCatalogAsyncResult !== "object" || centralizeCatalogAsyncResult.TAG !== "Done") {
    tmp = null;
  } else {
    let match$2 = centralizeCatalogAsyncResult._0;
    if (match$2.TAG === "Ok") {
      let match$3 = match$2._0;
      tmp = JsxRuntime.jsx(make$8, {
        issuesCount: match$3.issuesCount,
        patchesCount: match$3.patchesCount,
        fileUrl: match$3.fileUrl,
        onRequestErrorNotification: error => onRequestNotification({
          TAG: "Error",
          _0: error
        }),
        onRequestClose: () => setCentralizeCatalogAsyncResult(param => "NotAsked")
      });
    } else {
      tmp = null;
    }
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(SpinnerModal.make, {
      title: spinnerModalTitle,
      opened: spinnerModalOpened
    }), tmp, JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsxs(MenuActions.make, {
        children: [JsxRuntime.jsxs(MenuActions.Section.make, {
          children: [JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Import inventory"),
            href: CatalogRoutes.inventoryImportRoute,
            icon: "import"
          }), JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Export PLU codes"),
            icon: "export",
            tooltipText: exportPluActionDisabled ? I18n.t("Please select a shop beforehand.") : undefined,
            onAction: () => requestPluDownload()
          }, "export-plu")]
        }), props.organisationAccount ? JsxRuntime.jsx(MenuActions.Section.make, {
          children: JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Centralize catalogs"),
            icon: "sync_circular",
            onAction: handleCentralizeCatalogRequest
          })
        }) : null],
        trigger: {
          TAG: "Compact",
          icon: "more_v2"
        },
        disabledKeys: exportPluActionDisabled ? ["export-plu"] : []
      }),
      arrowed: false,
      placement: "top",
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("More actions...")
      }),
      closeDelay: 0
    })]
  });
}
let CatalogListMorePageMenuActions = {
  PluExportRequest: PluExportRequest,
  CentralizeCatalogRequest: CentralizeCatalogRequest,
  make: CatalogListPage$CatalogListMorePageMenuActions
};
let jsonCodec$1 = JsonCodec.object2(param => [param.id, param.name], param => ({
  TAG: "Ok",
  _0: {
    id: param[0],
    name: param[1]
  }
}), JsonCodec.field("priceId", JsonCodec.string), JsonCodec.field("priceName", JsonCodec.string));
let CatalogListExtraParamsPrice = {
  jsonCodec: jsonCodec$1
};
function selectByPricelists(pricelists, currentPrice) {
  let pricelist = Stdlib_Option.orElse(pricelists.find(current => {
    if (currentPrice !== undefined) {
      return currentPrice.id === current.id;
    } else {
      return false;
    }
  }), pricelists.find(current => {
    if (currentPrice !== undefined) {
      return currentPrice.name.toLowerCase() === current.name.toLowerCase();
    } else {
      return false;
    }
  }));
  let defaultPricelist = Stdlib_Option.orElse(pricelists.find(pricelist => pricelist.enableByDefault), pricelists[0]);
  return Stdlib_Option.orElse(pricelist, defaultPricelist);
}
let make$9 = React.memo(props => {
  let onRequestPriceChange = props.onRequestPriceChange;
  let initialPrice = props.price;
  let pricelistsAsyncResult = props.pricelistsAsyncResult;
  let match = React.useState(() => {});
  let setSelectedPrice = match[1];
  let selectedPrice = match[0];
  let captureEvent = SessionTracker.useCaptureEvent();
  ReactUpdateEffect.use1(() => {
    setSelectedPrice(param => {});
  }, [props.shopId]);
  ReactUpdateEffect.use1(() => {
    if (typeof pricelistsAsyncResult === "object" && pricelistsAsyncResult.TAG === "Done") {
      let pricelists = pricelistsAsyncResult._0;
      if (pricelists.TAG === "Ok" && Stdlib_Option.isNone(selectedPrice)) {
        let pricelist = selectByPricelists(pricelists._0, initialPrice);
        setSelectedPrice(param => pricelist);
      }
    }
  }, [pricelistsAsyncResult]);
  ReactUpdateEffect.use1(() => {
    let initialPriceId = Stdlib_Option.mapOr(initialPrice, "", price => price.id);
    if (selectedPrice !== undefined && selectedPrice.id !== initialPriceId) {
      onRequestPriceChange({
        id: selectedPrice.id,
        name: selectedPrice.name
      });
    }
  }, [selectedPrice]);
  let tmp;
  if (typeof pricelistsAsyncResult !== "object") {
    tmp = [];
  } else if (pricelistsAsyncResult.TAG === "Done") {
    let pricelists = pricelistsAsyncResult._0;
    if (pricelists.TAG === "Ok") {
      let sortedPricelists = pricelists._0.toSorted((current, next) => Primitive_float.compare(next.enableByDefault ? 1 : 0, current.enableByDefault ? 1 : 0));
      tmp = sortedPricelists.map(item => ({
        TAG: "Option",
        key: item.id,
        label: item.name,
        value: item
      }));
    } else {
      tmp = [];
    }
  } else {
    tmp = [];
  }
  let sections = [{
    items: tmp
  }];
  let renderTrigger = param => JsxRuntime.jsx(LegacyIcon.make, {
    name: "settings_bold",
    fill: param.hovered || param.active ? "#25243a" : "#797885",
    size: 12
  });
  let renderItem = param => {
    let item = param.item;
    if (item.TAG !== "Option") {
      return null;
    }
    let value = item.value;
    let enableByDefault = Stdlib_Option.mapOr(value, false, value => value.enableByDefault);
    let formattedLabel = item.label + (enableByDefault ? " *" : "");
    let tmp;
    if (value !== undefined) {
      let taxTypename = I18n.t(value.taxIncluded ? "VAT incl." : "VAT excl.");
      tmp = JsxRuntime.jsx(Badge.make, {
        children: taxTypename,
        size: "small",
        variation: "neutral"
      });
    } else {
      tmp = null;
    }
    return JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx("span", {
          children: formattedLabel
        }), tmp],
        space: "normal",
        align: "spaceBetween"
      }),
      placement: "start",
      offset: 2,
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("By default")
      }),
      disabled: !enableByDefault,
      closeDelay: 0
    });
  };
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Price list"),
    noResultFoundText: I18n.t("No price list found"),
    preset: {
      NAME: "inputField",
      VAL: {
        required: false
      }
    },
    renderTrigger: renderTrigger,
    renderItem: renderItem,
    sections: sections,
    value: {
      TAG: "Single",
      _0: selectedPrice
    },
    onChange: change => {
      if (change.TAG !== "Single") {
        return;
      }
      let value = change._0;
      setSelectedPrice(param => value);
      captureEvent("catalog_pricelist_select");
    }
  });
});
let CatalogListTableHeaderActionPricelistSelect = {
  selectByPricelists: selectByPricelists,
  make: make$9
};
let initialStockValue = {
  kind: "DELIVERY",
  quantity: undefined,
  lossReason: "LOSS",
  comment: ""
};
let Raw$3 = {};
let query$3 = Client.gql(["fragment MutationsVariantFragment on Variant   {\n__typename  \nid  \nstock  {\n__typename  \nformattedShopsNames  \nformattedQuantity  \nstate  \n}\n\nmaxStockThreshold  \nminStockThreshold  \nstockOrderTriggerThreshold  \n}\n"]);
function parse$3(value) {
  let value$1 = value.stock;
  let value$2 = value$1.formattedShopsNames;
  let value$3 = value$1.formattedQuantity;
  let value$4 = value$1.state;
  let tmp;
  if (value$4 == null) {
    tmp = undefined;
  } else {
    let tmp$1;
    switch (value$4) {
      case "ALERT":
        tmp$1 = "ALERT";
        break;
      case "DANGER":
        tmp$1 = "DANGER";
        break;
      case "OK":
        tmp$1 = "OK";
        break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$4
        };
    }
    tmp = tmp$1;
  }
  let value$5 = value.maxStockThreshold;
  let value$6 = value.minStockThreshold;
  let value$7 = value.stockOrderTriggerThreshold;
  return {
    __typename: value.__typename,
    id: value.id,
    stock: {
      __typename: value$1.__typename,
      formattedShopsNames: !(value$2 == null) ? value$2 : undefined,
      formattedQuantity: !(value$3 == null) ? value$3 : undefined,
      state: tmp
    },
    maxStockThreshold: !(value$5 == null) ? value$5 : undefined,
    minStockThreshold: !(value$6 == null) ? value$6 : undefined,
    stockOrderTriggerThreshold: !(value$7 == null) ? value$7 : undefined
  };
}
function serialize$3(value) {
  let value$1 = value.stockOrderTriggerThreshold;
  let stockOrderTriggerThreshold = value$1 !== undefined ? value$1 : null;
  let value$2 = value.minStockThreshold;
  let minStockThreshold = value$2 !== undefined ? value$2 : null;
  let value$3 = value.maxStockThreshold;
  let maxStockThreshold = value$3 !== undefined ? value$3 : null;
  let value$4 = value.stock;
  let value$5 = value$4.state;
  let state = value$5 !== undefined ? typeof value$5 === "object" ? value$5.VAL : value$5 === "OK" ? "OK" : value$5 === "ALERT" ? "ALERT" : "DANGER" : null;
  let value$6 = value$4.formattedQuantity;
  let formattedQuantity = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.formattedShopsNames;
  let formattedShopsNames = value$7 !== undefined ? value$7 : null;
  let value$8 = value$4.__typename;
  let stock = {
    __typename: value$8,
    formattedShopsNames: formattedShopsNames,
    formattedQuantity: formattedQuantity,
    state: state
  };
  let value$9 = value.id;
  let value$10 = value.__typename;
  return {
    __typename: value$10,
    id: value$9,
    stock: stock,
    maxStockThreshold: maxStockThreshold,
    minStockThreshold: minStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
}
function verifyArgsAndParse(_MutationsVariantFragment, value) {
  return parse$3(value);
}
function verifyName(_fragmentName) {}
let MutationsVariantFragment = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};
let Raw$4 = {};
let query$4 = Client.gql(["mutation CatalogListPage_StockActivityMutation($input: InputCreateStockActivity!)  {\ncreateStockActivity(input: $input)  {\n__typename  \nvariant  {\n...MutationsVariantFragment   \n}\n\n}\n\n}\n", ""], query$3);
function parse$4(value) {
  let value$1 = value.createStockActivity;
  let value$2 = value$1.variant;
  return {
    createStockActivity: {
      __typename: value$1.__typename,
      variant: !(value$2 == null) ? parse$3(value$2) : undefined
    }
  };
}
function serialize$4(value) {
  let value$1 = value.createStockActivity;
  let value$2 = value$1.variant;
  let variant = value$2 !== undefined ? serialize$3(value$2) : null;
  let value$3 = value$1.__typename;
  let createStockActivity = {
    __typename: value$3,
    variant: variant
  };
  return {
    createStockActivity: createStockActivity
  };
}
function serializeInputObjectInputCreateStockActivity(inp) {
  let a = inp.kind;
  let a$1 = inp.comment;
  let a$2 = inp.reason;
  let a$3 = inp.stockKeepingUnit;
  let a$4 = inp.capacityUnit;
  let a$5 = inp.capacityPrecision;
  return {
    kind: a === "DELIVERY_RECEIPT" ? "DELIVERY_RECEIPT" : a === "RESET" ? "RESET" : a === "INCOMING_TRANSFER" ? "INCOMING_TRANSFER" : a === "DELIVERY" ? "DELIVERY" : a === "REFUND" ? "REFUND" : a === "LOSS" ? "LOSS" : a === "CREDIT_MEMO" ? "CREDIT_MEMO" : a === "SALE" ? "SALE" : a === "RECEPTION" ? "RECEPTION" : "OUTGOING_TRANSFER",
    quantity: inp.quantity,
    comment: a$1 !== undefined ? a$1 : undefined,
    reason: a$2 !== undefined ? a$2 === "DAMAGE" ? "DAMAGE" : a$2 === "OUTDATED_DLUO" ? "OUTDATED_DLUO" : a$2 === "SALE_BY_GLASS" ? "SALE_BY_GLASS" : a$2 === "THEFT" ? "THEFT" : a$2 === "TASTING" ? "TASTING" : a$2 === "LOSS" ? "LOSS" : a$2 === "OTHER" ? "OTHER" : a$2 === "TRADE_IN_SUPPLIER" ? "TRADE_IN_SUPPLIER" : "CORKY" : undefined,
    stockKeepingUnit: a$3 !== undefined ? a$3 : undefined,
    capacityUnit: a$4 !== undefined ? a$4 : undefined,
    capacityPrecision: a$5 !== undefined ? a$5 : undefined,
    variantId: inp.variantId,
    deviceId: inp.deviceId,
    shopId: inp.shopId
  };
}
function serializeVariables$3(inp) {
  return {
    input: serializeInputObjectInputCreateStockActivity(inp.input)
  };
}
function makeVariables$3(input, param) {
  return {
    input: input
  };
}
function makeInputObjectInputCreateStockActivity(kind, quantity, comment, reason, stockKeepingUnit, capacityUnit, capacityPrecision, variantId, deviceId, shopId, param) {
  return {
    kind: kind,
    quantity: quantity,
    comment: comment,
    reason: reason,
    stockKeepingUnit: stockKeepingUnit,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    variantId: variantId,
    deviceId: deviceId,
    shopId: shopId
  };
}
let StockActivityMutation_inner = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$3,
  serializeInputObjectInputCreateStockActivity: serializeInputObjectInputCreateStockActivity,
  makeVariables: makeVariables$3,
  makeInputObjectInputCreateStockActivity: makeInputObjectInputCreateStockActivity
};
let include$3 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$4,
  Raw: Raw$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$3
});
let use$3 = include$3.use;
let StockActivityMutation_useWithVariables = include$3.useWithVariables;
let StockActivityMutation = {
  StockActivityMutation_inner: StockActivityMutation_inner,
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  serializeVariables: serializeVariables$3,
  serializeInputObjectInputCreateStockActivity: serializeInputObjectInputCreateStockActivity,
  makeVariables: makeVariables$3,
  makeInputObjectInputCreateStockActivity: makeInputObjectInputCreateStockActivity,
  use: use$3,
  useWithVariables: StockActivityMutation_useWithVariables
};
let Raw$5 = {};
let query$5 = Client.gql(["mutation CatalogListPage_VariantStockThresholdsMutation($id: ID!, $input: InputUpdateVariant!)  {\nupdateVariant(id: $id, input: $input)  {\n...MutationsVariantFragment   \n}\n\n}\n", ""], query$3);
function parse$5(value) {
  let value$1 = value.updateVariant;
  return {
    updateVariant: parse$3(value$1)
  };
}
function serialize$5(value) {
  let value$1 = value.updateVariant;
  let updateVariant = serialize$3(value$1);
  return {
    updateVariant: updateVariant
  };
}
function serializeInputObjectInputUpdateVariantMetaData(inp) {
  let a = inp.shopifyVariantId;
  return {
    shopifyVariantId: a !== undefined ? a : undefined
  };
}
function serializeInputObjectInputUpdateVariant(inp) {
  let a = inp.stockKeepingUnit;
  let a$1 = inp.name;
  let a$2 = inp.purchasedPrice;
  let a$3 = inp.year;
  let a$4 = inp.capacityValue;
  let a$5 = inp.capacityUnit;
  let a$6 = inp.capacityPrecision;
  let a$7 = inp.alcoholVolume;
  let a$8 = inp.ean13;
  let a$9 = inp.internalNote;
  let a$10 = inp.metadata;
  let a$11 = inp.tastingNote;
  let a$12 = inp.packaging;
  let a$13 = inp.internalCode;
  let a$14 = inp.priceLookUpCode;
  let a$15 = inp.supplierId;
  let a$16 = inp.minStockThreshold;
  let a$17 = inp.maxStockThreshold;
  let a$18 = inp.stockOrderTriggerThreshold;
  return {
    stockKeepingUnit: a !== undefined ? a : undefined,
    name: a$1 !== undefined ? a$1 : undefined,
    purchasedPrice: a$2 !== undefined ? a$2 : undefined,
    year: a$3 !== undefined ? a$3 : undefined,
    capacityValue: a$4 !== undefined ? a$4 : undefined,
    capacityUnit: a$5 !== undefined ? a$5 : undefined,
    capacityPrecision: a$6 !== undefined ? a$6 : undefined,
    alcoholVolume: a$7 !== undefined ? a$7 : undefined,
    ean13: a$8 !== undefined ? a$8 : undefined,
    internalNote: a$9 !== undefined ? a$9 : undefined,
    metadata: a$10 !== undefined ? serializeInputObjectInputUpdateVariantMetaData(a$10) : undefined,
    tastingNote: a$11 !== undefined ? a$11 : undefined,
    packaging: a$12 !== undefined ? a$12 : undefined,
    internalCode: a$13 !== undefined ? a$13 : undefined,
    priceLookUpCode: a$14 !== undefined ? a$14 : undefined,
    supplierId: a$15 !== undefined ? a$15 : undefined,
    minStockThreshold: a$16 !== undefined ? a$16 : undefined,
    maxStockThreshold: a$17 !== undefined ? a$17 : undefined,
    stockOrderTriggerThreshold: a$18 !== undefined ? a$18 : undefined
  };
}
function serializeVariables$4(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateVariant(inp.input)
  };
}
function makeVariables$4(id, input, param) {
  return {
    id: id,
    input: input
  };
}
function makeInputObjectInputUpdateVariant(stockKeepingUnit, name, purchasedPrice, year, capacityValue, capacityUnit, capacityPrecision, alcoholVolume, ean13, internalNote, metadata, tastingNote, packaging, internalCode, priceLookUpCode, supplierId, minStockThreshold, maxStockThreshold, stockOrderTriggerThreshold, param) {
  return {
    stockKeepingUnit: stockKeepingUnit,
    name: name,
    purchasedPrice: purchasedPrice,
    year: year,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    internalNote: internalNote,
    metadata: metadata,
    tastingNote: tastingNote,
    packaging: packaging,
    internalCode: internalCode,
    priceLookUpCode: priceLookUpCode,
    supplierId: supplierId,
    minStockThreshold: minStockThreshold,
    maxStockThreshold: maxStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
}
function makeInputObjectInputUpdateVariantMetaData(shopifyVariantId, param) {
  return {
    shopifyVariantId: shopifyVariantId
  };
}
let VariantStockThresholdsMutation_inner = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$4,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables$4,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData
};
let include$4 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$5,
  Raw: Raw$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$4
});
let use$4 = include$4.use;
let VariantStockThresholdsMutation_useWithVariables = include$4.useWithVariables;
let VariantStockThresholdsMutation = {
  VariantStockThresholdsMutation_inner: VariantStockThresholdsMutation_inner,
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  serializeVariables: serializeVariables$4,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables$4,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData,
  use: use$4,
  useWithVariables: VariantStockThresholdsMutation_useWithVariables
};
function createStockActivityInput(variantId, shopId, deviceId, bulkUnit, stockValue) {
  let capacityPrecision = Stdlib_Option.isSome(bulkUnit) ? 3 : undefined;
  let reason = stockValue.kind === "LOSS" ? stockValue.lossReason : undefined;
  let quantity = StockQuantity.toRawValue(capacityPrecision, Stdlib_Option.getOr(stockValue.quantity, 0));
  let comment = stockValue.comment.length > 0 ? stockValue.comment : undefined;
  return makeInputObjectInputCreateStockActivity(stockValue.kind, quantity, comment, reason, undefined, bulkUnit, capacityPrecision, variantId, deviceId, shopId, undefined);
}
function variantStockThresholdsMutationInput(thresholdsValue) {
  return makeInputObjectInputUpdateVariant(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, thresholdsValue.minStock | 0, thresholdsValue.maxStock | 0, thresholdsValue.stockOrderTrigger | 0, undefined);
}
function useMutations() {
  let match = use$3(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutateCreateStockActivity = match[0];
  let match$1 = use$4(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutateStockThresholds = match$1[0];
  let mutateCreateStockActivity$1 = (variantId, shopId, deviceId, bulkUnit, stockValue) => Future.mapError(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutateCreateStockActivity(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    input: createStockActivityInput(variantId, shopId, deviceId, bulkUnit, stockValue)
  })), undefined, param => {}), undefined, param => {});
  let mutateStockThresholds$1 = (variantId, thresholdsValue) => Future.mapError(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutateStockThresholds(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    id: variantId,
    input: variantStockThresholdsMutationInput(thresholdsValue)
  })), undefined, param => {}), undefined, param => {});
  return [mutateCreateStockActivity$1, mutateStockThresholds$1];
}
let items = StockActivityReason.values.map(reason => ({
  TAG: "Option",
  key: StockActivityReason.toString(reason),
  label: StockActivityReason.toLabel(reason),
  value: reason
}));
let selectReasonSections = [{
  items: items
}];
let make$10 = React.memo(props => {
  let onRequestStockValueChange = props.onRequestStockValueChange;
  let bulkUnit = props.bulkUnit;
  let stockValue = props.stockValue;
  let match = stockValue.kind;
  let labelColor = match === "DELIVERY" ? "#009F5D" : "#D92964";
  let deliverySelected = stockValue.kind === "DELIVERY";
  let lossSelected = stockValue.kind === "LOSS";
  let quantityInputAppender = Stdlib_Option.map(bulkUnit, unit => ({
    TAG: "Custom",
    _0: unit
  }));
  let bulk = Stdlib_Option.isSome(bulkUnit);
  return JsxRuntime.jsxs(Dialog.Section.make, {
    children: [JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsx(Button.make, {
        label: StockActivityKind.toLabel("DELIVERY"),
        variant: {
          NAME: "ghost",
          VAL: {
            bordered: deliverySelected
          }
        },
        tone: "success",
        grow: true,
        onPress: () => onRequestStockValueChange({
          kind: "DELIVERY",
          quantity: stockValue.quantity,
          lossReason: stockValue.lossReason,
          comment: stockValue.comment
        })
      }), JsxRuntime.jsx(Button.make, {
        label: StockActivityKind.toLabel("LOSS"),
        variant: {
          NAME: "ghost",
          VAL: {
            bordered: lossSelected
          }
        },
        tone: "danger",
        grow: true,
        onPress: () => onRequestStockValueChange({
          kind: "LOSS",
          quantity: stockValue.quantity,
          lossReason: stockValue.lossReason,
          comment: stockValue.comment
        })
      })],
      spaceX: "normal",
      spaceY: "normal"
    }), JsxRuntime.jsx(CanarySurface.make, {
      tone: deliverySelected ? "success" : "danger",
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx(Label.make, {
              text: I18n.t("Quantity") + " *",
              color: labelColor
            }), JsxRuntime.jsx(InputOptionalNumberField.make, {
              value: stockValue.quantity,
              minValue: bulk ? 0.001 : 1,
              precision: bulk ? 3 : 0,
              placeholder: bulk ? "1,000" : "1",
              appender: quantityInputAppender,
              autoFocused: true,
              onChange: value => onRequestStockValueChange({
                kind: stockValue.kind,
                quantity: value,
                lossReason: stockValue.lossReason,
                comment: stockValue.comment
              })
            })],
            space: "none"
          }), stockValue.kind === "LOSS" ? JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx(Label.make, {
              text: I18n.t("Loss reason"),
              color: labelColor
            }), JsxRuntime.jsx(Select.make, {
              preset: {
                NAME: "inputField",
                VAL: {
                  required: true
                }
              },
              sections: selectReasonSections,
              value: {
                TAG: "Single",
                _0: stockValue.lossReason
              },
              onChange: change => {
                if (change.TAG === "Single") {
                  return onRequestStockValueChange({
                    kind: stockValue.kind,
                    quantity: stockValue.quantity,
                    lossReason: change._0,
                    comment: stockValue.comment
                  });
                }
              }
            })],
            space: "none"
          }) : null, JsxRuntime.jsxs(Stack.make, {
            children: [JsxRuntime.jsx(Label.make, {
              text: I18n.t("Comment"),
              color: labelColor
            }), JsxRuntime.jsx(InputTextAreaField.make, {
              value: stockValue.comment,
              onChange: value => onRequestStockValueChange({
                kind: stockValue.kind,
                quantity: stockValue.quantity,
                lossReason: stockValue.lossReason,
                comment: value
              })
            })],
            space: "none"
          })],
          space: "normal"
        }),
        spaceX: "normal",
        spaceY: "normal"
      })
    })]
  });
});
let CatalogListStockCellStockTabSection = {
  selectReasonSections: selectReasonSections,
  make: make$10
};
let make$11 = React.memo(props => {
  let onRequestThresholdsValueChange = props.onRequestThresholdsValueChange;
  let thresholdsValue = props.thresholdsValue;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsxs(Dialog.Section.make, {
      children: [JsxRuntime.jsxs(Group.make, {
        children: [JsxRuntime.jsx(InputOptionalNumberField.make, {
          value: thresholdsValue.minStock > 0 ? thresholdsValue.minStock : undefined,
          minValue: 0,
          precision: 0,
          label: I18n.t("Minimum threshold"),
          tooltip: JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.stock_cell.thresholds_tab.minimum_threshold_input.tooltip_content_1")
            }), JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.stock_cell.thresholds_tab.minimum_threshold_input.tooltip_bold_1"),
              bold: true
            }), JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.stock_cell.thresholds_tab.minimum_threshold_input.tooltip_content_2")
            })]
          }),
          placeholder: "0",
          required: false,
          onChange: value => onRequestThresholdsValueChange({
            stockOrderTrigger: thresholdsValue.stockOrderTrigger,
            minStock: Stdlib_Option.getOr(value, 0),
            maxStock: thresholdsValue.maxStock
          })
        }), JsxRuntime.jsx(InputNumberField.make, {
          value: thresholdsValue.maxStock,
          minValue: thresholdsValue.minStock > 0 ? Math.max(0, thresholdsValue.minStock + 1) : 0,
          precision: 0,
          label: I18n.t("Maximum threshold"),
          tooltip: JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_content_1")
            }), JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_italic_1"),
              italic: true
            }), JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_content_2")
            }), JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_bold_1"),
              bold: true
            }), JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_content_3")
            }), JsxRuntime.jsx(Tooltip.Gap.make, {
              space: "xsmall"
            }), JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("catalog_list.stock_cell.thresholds_tab.maximum_threshold_input.tooltip_content_4")
            })]
          }),
          placeholder: "0",
          required: false,
          allowsSideEffectChange: true,
          onChange: value => onRequestThresholdsValueChange({
            stockOrderTrigger: thresholdsValue.stockOrderTrigger,
            minStock: thresholdsValue.minStock,
            maxStock: value
          })
        })]
      }), JsxRuntime.jsx(InputNumberField.make, {
        value: thresholdsValue.stockOrderTrigger,
        minValue: thresholdsValue.minStock > 0 ? Math.max(0, thresholdsValue.minStock) : 0,
        maxValue: Math.max(0, thresholdsValue.maxStock - 1),
        precision: 0,
        label: I18n.t("Threshold triggering the order"),
        tooltip: JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [JsxRuntime.jsx(Tooltip.Span.make, {
            text: I18n.t("catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_content_1")
          }), JsxRuntime.jsx(Tooltip.Span.make, {
            text: I18n.t("catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_italic_1"),
            italic: true
          }), JsxRuntime.jsx(Tooltip.Span.make, {
            text: I18n.t("catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_content_2")
          }), JsxRuntime.jsx(Tooltip.Span.make, {
            text: I18n.t("catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_bold_1"),
            bold: true
          }), JsxRuntime.jsx(Tooltip.Span.make, {
            text: I18n.t("catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_content_3")
          }), JsxRuntime.jsx(Tooltip.Gap.make, {
            space: "xsmall"
          }), JsxRuntime.jsx(Tooltip.Span.make, {
            text: I18n.t("catalog_list.stock_cell.thresholds_tab.triggering_threshold_input.tooltip_content_4")
          })]
        }),
        placeholder: "0",
        required: false,
        disabled: thresholdsValue.stockOrderTrigger >= thresholdsValue.maxStock,
        allowsSideEffectChange: true,
        onChange: value => onRequestThresholdsValueChange({
          stockOrderTrigger: value,
          minStock: thresholdsValue.minStock,
          maxStock: thresholdsValue.maxStock
        })
      })]
    }), JsxRuntime.jsx(Dialog.Section.make, {
      children: JsxRuntime.jsxs(NextBanner.make, {
        children: [JsxRuntime.jsx(NextBanner.Text.make, {
          text: I18n.t("catalog_list.stock_cell.thresholds_tab.info_banner.text_content_1")
        }), JsxRuntime.jsx(NextBanner.Text.make, {
          text: "≤",
          bold: true
        }), JsxRuntime.jsx(NextBanner.Text.make, {
          text: I18n.t("catalog_list.stock_cell.thresholds_tab.info_banner.text_content_2")
        }), JsxRuntime.jsx(NextBanner.Text.make, {
          text: I18n.t("catalog_list.stock_cell.thresholds_tab.info_banner.text_italic_1"),
          italic: true
        }), JsxRuntime.jsx(NextBanner.Text.make, {
          text: I18n.t("catalog_list.stock_cell.thresholds_tab.info_banner.text_content_3")
        }), JsxRuntime.jsx(NextBanner.Text.make, {
          text: I18n.t("catalog_list.stock_cell.thresholds_tab.info_banner.text_italic_2"),
          italic: true
        }), JsxRuntime.jsx(NextBanner.Gap.make, {
          space: "xnormal"
        }), JsxRuntime.jsx(NextBanner.Text.make, {
          text: "➔ " + I18n.t("Learn more"),
          onPress: () => HelpCenter.showArticle(HelpCenter.useAutomaticOrderFeature)
        })],
        variation: "info",
        title: I18n.t("Automatic order"),
        maxLines: 1
      })
    })]
  });
});
let CatalogListStockCellThresholdsTabSection = {
  make: make$11
};
let make$12 = React.memo(props => {
  let mutateStockThresholds = props.mutateStockThresholds;
  let mutateCreateStockActivity = props.mutateCreateStockActivity;
  let bulkUnit = props.bulkUnit;
  let deviceId = props.deviceId;
  let shopId = props.shopId;
  let variantId = props.variantId;
  let captureEvent = SessionTracker.useCaptureEvent();
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let initialThresholdsValue_stockOrderTrigger = props.stockOrderTriggerThreshold;
  let initialThresholdsValue_minStock = props.minStockThreshold;
  let initialThresholdsValue_maxStock = props.maxStockThreshold;
  let initialThresholdsValue = {
    stockOrderTrigger: initialThresholdsValue_stockOrderTrigger,
    minStock: initialThresholdsValue_minStock,
    maxStock: initialThresholdsValue_maxStock
  };
  let match$1 = React.useState(() => initialStockValue);
  let setStockValue = match$1[1];
  let stockValue = match$1[0];
  let match$2 = React.useState(() => initialThresholdsValue);
  let setThresholdsValue = match$2[1];
  let thresholdsValue = match$2[0];
  let match$3 = React.useState(() => false);
  let setMutationLoading = match$3[1];
  let mutationLoading = match$3[0];
  ReactUpdateEffect.use1(() => {
    if (!mutationLoading) {
      popover.close();
    }
  }, [mutationLoading]);
  ReactUpdateEffect.use1(() => {
    setStockValue(param => initialStockValue);
    setThresholdsValue(param => initialThresholdsValue);
  }, [popover.isOpen]);
  let stockValueValid = Primitive_object.greaterthan(stockValue.quantity, 0);
  let thresholdsValueValid = Primitive_object.notequal(initialThresholdsValue, thresholdsValue) && thresholdsValue.maxStock > 0;
  let commitDisabled = !stockValueValid && !thresholdsValueValid;
  let thresholdsDisabled = Stdlib_Option.isSome(bulkUnit);
  let tabsDisabledKeys = thresholdsDisabled ? ["thresholds"] : undefined;
  let onCommit = React.useCallback(() => {
    setMutationLoading(param => true);
    let mutationsResults = thresholdsValueValid ? Future.flatMap(mutateStockThresholds(variantId, thresholdsValue), undefined, param => {
      if (stockValueValid) {
        return mutateCreateStockActivity(variantId, shopId, deviceId, bulkUnit, stockValue);
      } else {
        return Future.value({
          TAG: "Ok",
          _0: undefined
        });
      }
    }) : stockValueValid ? mutateCreateStockActivity(variantId, shopId, deviceId, bulkUnit, stockValue) : Future.value({
      TAG: "Ok",
      _0: undefined
    });
    Future.get(mutationsResults, param => {
      if (stockValueValid) {
        captureEvent("catalog_stockcell_report_click_save");
      }
      if (thresholdsValueValid) {
        captureEvent("catalog_stockcell_thresholds_edit_click_save");
      }
      setMutationLoading(param => false);
      popover.close();
    });
  }, [stockValue, thresholdsValue]);
  let onRequestStockValueChange = value => setStockValue(param => value);
  let onRequestThresholdsValueChange = value => setThresholdsValue(param => value);
  let thresholdsTabTooltipText = Stdlib_Option.flatMap(tabsDisabledKeys, keys => {
    if (keys.some(key => key === "thresholds")) {
      return I18n.t("catalog_list.stock_cell.thresholds_button_tab.disabled_tooltip_text");
    }
  });
  let newrecord = {
    ...popoverAriaProps.triggerProps
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(OpeningButton.make, {
      children: JsxRuntime.jsx(ProductStockTableCell.make, {
        value: props.formattedStockQuantity,
        state: props.stockIndicator,
        size: "xsmall"
      }),
      ariaProps: (newrecord["aria-label"] = "Stock cell", newrecord),
      opened: popover.isOpen,
      ref: popoverTriggerRef
    }), popover.isOpen ? JsxRuntime.jsx(Popover.make, {
      children: JsxRuntime.jsxs(Dialog.make, {
        ariaProps: popoverAriaProps.overlayProps,
        children: [JsxRuntime.jsx(ReactStately.Item, {
          children: JsxRuntime.jsx(make$10, {
            stockValue: stockValue,
            bulkUnit: bulkUnit,
            onRequestStockValueChange: onRequestStockValueChange
          }),
          title: I18n.t("Movements")
        }, "stock"), JsxRuntime.jsx(ReactStately.Item, {
          children: JsxRuntime.jsx(make$11, {
            thresholdsValue: thresholdsValue,
            onRequestThresholdsValueChange: onRequestThresholdsValueChange
          }),
          title: I18n.t("Thresholds"),
          tooltipText: thresholdsTabTooltipText
        }, "thresholds")],
        width: 308,
        header: {
          TAG: "Tabs",
          _0: {
            disabledKeys: tabsDisabledKeys
          }
        },
        commitDisabled: commitDisabled,
        commitLoading: mutationLoading,
        onRequestCommit: onCommit,
        onRequestDiscard: popover.close
      }),
      triggerRef: popoverTriggerRef,
      state: popover,
      placement: "bottom start",
      modal: false
    }) : null]
  });
});
let CatalogListStockCell = {
  initialStockValue: initialStockValue,
  MutationsVariantFragment: MutationsVariantFragment,
  StockActivityMutation: StockActivityMutation,
  VariantStockThresholdsMutation: VariantStockThresholdsMutation,
  createStockActivityInput: createStockActivityInput,
  variantStockThresholdsMutationInput: variantStockThresholdsMutationInput,
  useMutations: useMutations,
  CatalogListStockCellStockTabSection: CatalogListStockCellStockTabSection,
  CatalogListStockCellThresholdsTabSection: CatalogListStockCellThresholdsTabSection,
  make: make$12
};
let Raw$6 = {};
let query$6 = Client.gql(["mutation updatePurchasePrice($id: ID!, $input: InputUpdateVariant!)  {\nupdateVariant(id: $id, input: $input)  {\n__typename  \nid  \npurchasedPrice  \n}\n\n}\n"]);
function parse$6(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.purchasedPrice;
  return {
    updateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      purchasedPrice: !(value$2 == null) ? value$2 : undefined
    }
  };
}
function serialize$6(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.purchasedPrice;
  let purchasedPrice = value$2 !== undefined ? value$2 : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let updateVariant = {
    __typename: value$4,
    id: value$3,
    purchasedPrice: purchasedPrice
  };
  return {
    updateVariant: updateVariant
  };
}
function serializeInputObjectInputUpdateVariantMetaData$1(inp) {
  let a = inp.shopifyVariantId;
  return {
    shopifyVariantId: a !== undefined ? a : undefined
  };
}
function serializeInputObjectInputUpdateVariant$1(inp) {
  let a = inp.stockKeepingUnit;
  let a$1 = inp.name;
  let a$2 = inp.purchasedPrice;
  let a$3 = inp.year;
  let a$4 = inp.capacityValue;
  let a$5 = inp.capacityUnit;
  let a$6 = inp.capacityPrecision;
  let a$7 = inp.alcoholVolume;
  let a$8 = inp.ean13;
  let a$9 = inp.internalNote;
  let a$10 = inp.metadata;
  let a$11 = inp.tastingNote;
  let a$12 = inp.packaging;
  let a$13 = inp.internalCode;
  let a$14 = inp.priceLookUpCode;
  let a$15 = inp.supplierId;
  let a$16 = inp.minStockThreshold;
  let a$17 = inp.maxStockThreshold;
  let a$18 = inp.stockOrderTriggerThreshold;
  return {
    stockKeepingUnit: a !== undefined ? a : undefined,
    name: a$1 !== undefined ? a$1 : undefined,
    purchasedPrice: a$2 !== undefined ? a$2 : undefined,
    year: a$3 !== undefined ? a$3 : undefined,
    capacityValue: a$4 !== undefined ? a$4 : undefined,
    capacityUnit: a$5 !== undefined ? a$5 : undefined,
    capacityPrecision: a$6 !== undefined ? a$6 : undefined,
    alcoholVolume: a$7 !== undefined ? a$7 : undefined,
    ean13: a$8 !== undefined ? a$8 : undefined,
    internalNote: a$9 !== undefined ? a$9 : undefined,
    metadata: a$10 !== undefined ? serializeInputObjectInputUpdateVariantMetaData$1(a$10) : undefined,
    tastingNote: a$11 !== undefined ? a$11 : undefined,
    packaging: a$12 !== undefined ? a$12 : undefined,
    internalCode: a$13 !== undefined ? a$13 : undefined,
    priceLookUpCode: a$14 !== undefined ? a$14 : undefined,
    supplierId: a$15 !== undefined ? a$15 : undefined,
    minStockThreshold: a$16 !== undefined ? a$16 : undefined,
    maxStockThreshold: a$17 !== undefined ? a$17 : undefined,
    stockOrderTriggerThreshold: a$18 !== undefined ? a$18 : undefined
  };
}
function serializeVariables$5(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateVariant$1(inp.input)
  };
}
function makeVariables$5(id, input, param) {
  return {
    id: id,
    input: input
  };
}
function makeInputObjectInputUpdateVariant$1(stockKeepingUnit, name, purchasedPrice, year, capacityValue, capacityUnit, capacityPrecision, alcoholVolume, ean13, internalNote, metadata, tastingNote, packaging, internalCode, priceLookUpCode, supplierId, minStockThreshold, maxStockThreshold, stockOrderTriggerThreshold, param) {
  return {
    stockKeepingUnit: stockKeepingUnit,
    name: name,
    purchasedPrice: purchasedPrice,
    year: year,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    internalNote: internalNote,
    metadata: metadata,
    tastingNote: tastingNote,
    packaging: packaging,
    internalCode: internalCode,
    priceLookUpCode: priceLookUpCode,
    supplierId: supplierId,
    minStockThreshold: minStockThreshold,
    maxStockThreshold: maxStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
}
function makeInputObjectInputUpdateVariantMetaData$1(shopifyVariantId, param) {
  return {
    shopifyVariantId: shopifyVariantId
  };
}
let Mutation_inner = {
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$5,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant$1,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData$1,
  makeVariables: makeVariables$5,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant$1,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData$1
};
let include$5 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$6,
  Raw: Raw$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$5
});
let use$5 = include$5.use;
let Mutation_useWithVariables = include$5.useWithVariables;
let Mutation = {
  Mutation_inner: Mutation_inner,
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  serializeVariables: serializeVariables$5,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant$1,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData$1,
  makeVariables: makeVariables$5,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant$1,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData$1,
  use: use$5,
  useWithVariables: Mutation_useWithVariables
};
function useMutation(variantId) {
  let match = use$5(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return purchasePrice => {
    let input = makeInputObjectInputUpdateVariant$1(undefined, undefined, purchasePrice, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    return Future.mapError(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: variantId,
      input: input
    })), undefined, param => {}), undefined, param => {});
  };
}
let amountInputNumberAppender = {
  TAG: "Custom",
  _0: I18n.toCurrencySymbol("EUR")
};
function priceInputNumberAppender(bulkUnit) {
  return {
    TAG: "Custom",
    _0: I18n.toCurrencySymbol("EUR") + Stdlib_Option.mapOr(bulkUnit, "", unit => ` / ` + unit)
  };
}
let make$13 = React.memo(props => {
  let priceInputAppender = priceInputNumberAppender(props.bulkUnit);
  return JsxRuntime.jsx(Dialog.Section.make, {
    children: JsxRuntime.jsx(Stack.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: props.value,
          minValue: 0,
          precision: 3,
          label: props.priceIsNet ? I18n.t("Net purchase price") : I18n.t("Gross purchase price"),
          appender: priceInputAppender,
          autoFocused: true,
          strongStyle: true,
          onChange: props.onChange
        }),
        spaceTop: "xxsmall"
      }),
      space: "medium"
    }),
    title: I18n.t("catalog_list.purchase_price_cell.dialog.section_final")
  });
});
let PurchasePriceCalculatingMethodDialogSections = {
  make: make$13
};
let make$14 = React.memo(props => {
  let feesList = props.feesList;
  let otherFeeAmount = feesList.otherAmount;
  let taxesFeeAmount = feesList.taxesAmount;
  let onChange = props.onChange;
  let purchasePrice = props.value;
  let priceIsNet = props.priceIsNet;
  let fullPurchasePrice = computeFullPurchasePrice(purchasePrice, taxesFeeAmount, otherFeeAmount);
  let onFullPurchasePriceChange = fullPurchasePrice => {
    let charges = PriceCalculator.sumManyCharges([taxesFeeAmount, otherFeeAmount]);
    onChange(PriceCalculator.Purchase.fromValueWithCharges(fullPurchasePrice, charges));
  };
  let priceInputAppender = priceInputNumberAppender(props.bulkUnit);
  let chargesSectionDefaultCollapsed = taxesFeeAmount === 0 && otherFeeAmount === 0;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(Dialog.Section.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: purchasePrice,
          minValue: 0,
          precision: 3,
          label: I18n.t("catalog_list.purchase_price_cell.dialog.section_before_charges.input_label" + (priceIsNet ? ".net" : ".gross")),
          appender: priceInputAppender,
          onChange: onChange
        }),
        spaceTop: "xxsmall"
      }),
      title: I18n.t("catalog_list.purchase_price_cell.dialog.section_before_charges"),
      collapsable: true,
      defaultCollapsed: true
    }), JsxRuntime.jsx(Dialog.Section.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(InputNumberField.make, {
            value: taxesFeeAmount,
            precision: 3,
            label: I18n.t("catalog_list.purchase_price_cell.dialog.section_charges.taxes_fee.input_label"),
            appender: amountInputNumberAppender,
            disabled: true,
            hideStepper: true,
            onChange: param => {}
          }), JsxRuntime.jsx(InputNumberField.make, {
            value: otherFeeAmount,
            precision: 3,
            label: I18n.t("catalog_list.purchase_price_cell.dialog.section_charges.other_fee.input_label"),
            appender: amountInputNumberAppender,
            disabled: true,
            hideStepper: true,
            onChange: param => {}
          })],
          spaceX: "normal"
        }),
        spaceTop: "xxsmall"
      }),
      title: I18n.t("catalog_list.price_cell.dialog.section_charges"),
      collapsable: true,
      defaultCollapsed: chargesSectionDefaultCollapsed
    }), JsxRuntime.jsx(Dialog.Section.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: fullPurchasePrice,
          minValue: fullPurchasePrice - purchasePrice,
          precision: 3,
          label: I18n.t("catalog_list.purchase_price_cell.full_purchase_price_calculating_method_dialog.section_final.input_label" + (priceIsNet ? ".net" : ".gross")),
          appender: priceInputAppender,
          autoFocused: true,
          strongStyle: true,
          onChange: onFullPurchasePriceChange
        }),
        spaceTop: "xxsmall"
      }),
      title: I18n.t("catalog_list.purchase_price_cell.dialog.section_final"),
      collapsable: true
    })]
  });
});
let FullPurchasePriceCalculatingMethodDialogSections = {
  make: make$14
};
let make$15 = React.memo(props => {
  let feesList = props.feesList;
  let otherFeeAmount = feesList.otherAmount;
  let taxesFeeAmount = feesList.taxesAmount;
  let transportFeeAmount = feesList.transportAmount;
  let onChange = props.onChange;
  let purchasePrice = props.value;
  let priceIsNet = props.priceIsNet;
  let onAcquisitionCostChange = acquisitionCost => {
    let charges = PriceCalculator.sumManyCharges([transportFeeAmount, taxesFeeAmount, otherFeeAmount]);
    onChange(PriceCalculator.Purchase.fromValueWithCharges(acquisitionCost, charges));
  };
  let acquisitionCost = computeAcquisitionCost(purchasePrice, transportFeeAmount, taxesFeeAmount, otherFeeAmount);
  let priceInputAppender = priceInputNumberAppender(props.bulkUnit);
  let chargesSectionDefaultCollapsed = transportFeeAmount === 0 && taxesFeeAmount === 0 && otherFeeAmount === 0;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(Dialog.Section.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: purchasePrice,
          minValue: 0,
          precision: 3,
          label: I18n.t("catalog_list.purchase_price_cell.dialog.section_before_charges.input_label" + (priceIsNet ? ".net" : ".gross")),
          appender: priceInputAppender,
          onChange: onChange
        }),
        spaceTop: "xxsmall"
      }),
      title: I18n.t("catalog_list.purchase_price_cell.dialog.section_before_charges"),
      collapsable: true,
      defaultCollapsed: true
    }), JsxRuntime.jsx(Dialog.Section.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(InputNumberField.make, {
            value: transportFeeAmount,
            precision: 3,
            label: I18n.t("catalog_list.purchase_price_cell.dialog.section_charges.transport_fee.input_label"),
            appender: amountInputNumberAppender,
            disabled: true,
            hideStepper: true,
            onChange: param => {}
          }), JsxRuntime.jsx(InputNumberField.make, {
            value: taxesFeeAmount,
            precision: 3,
            label: I18n.t("catalog_list.purchase_price_cell.dialog.section_charges.taxes_fee.input_label"),
            appender: amountInputNumberAppender,
            disabled: true,
            hideStepper: true,
            onChange: param => {}
          }), JsxRuntime.jsx(InputNumberField.make, {
            value: otherFeeAmount,
            precision: 3,
            label: I18n.t("catalog_list.purchase_price_cell.dialog.section_charges.other_fee.input_label"),
            appender: amountInputNumberAppender,
            disabled: true,
            hideStepper: true,
            onChange: param => {}
          })],
          spaceX: "normal"
        }),
        spaceTop: "xxsmall"
      }),
      title: I18n.t("catalog_list.price_cell.dialog.section_charges"),
      collapsable: true,
      defaultCollapsed: chargesSectionDefaultCollapsed
    }), JsxRuntime.jsx(Dialog.Section.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: acquisitionCost,
          minValue: acquisitionCost - purchasePrice,
          precision: 3,
          label: I18n.t("catalog_list.purchase_price_cell.acquisition_cost_calculating_method_dialog.section_final.input_label" + (priceIsNet ? ".net" : ".gross")),
          appender: priceInputAppender,
          autoFocused: true,
          strongStyle: true,
          onChange: onAcquisitionCostChange
        }),
        spaceTop: "xxsmall"
      }),
      title: I18n.t("catalog_list.purchase_price_cell.dialog.section_final"),
      collapsable: true
    })]
  });
});
let AcquisitionCostPriceCalculatingMethodDialogSections = {
  make: make$15
};
let make$16 = React.memo(props => {
  let __useMutation = props.useMutation;
  let initialValue = props.value;
  let calculatingMethod = props.calculatingMethod;
  let discount = props.discount;
  let feesList = props.feesList;
  let bulkUnit = props.bulkUnit;
  let useMutation$1 = __useMutation !== undefined ? __useMutation : useMutation;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let match$1 = React.useState(() => false);
  let setMutationLoading = match$1[1];
  let mutate = useMutation$1(props.variantId);
  let match$2;
  match$2 = props.purchasePriceType === "Gross" ? [initialValue, false] : [PriceCalculator.Purchase.toNetValue(initialValue, discount), true];
  let priceIsNet = match$2[1];
  let initialValue$1 = match$2[0];
  let match$3 = React.useState(() => initialValue$1);
  let setValue = match$3[1];
  let value = match$3[0];
  ReactUpdateEffect.use1(() => {
    if (popover.isOpen) {
      setValue(param => initialValue$1);
    }
  }, [popover.isOpen]);
  let onCommit = React.useCallback(() => {
    if (value === initialValue$1) {
      return popover.close();
    }
    setMutationLoading(param => true);
    let rawPurchasePrice = priceIsNet ? PriceCalculator.Purchase.fromNetValue(value, discount) : value;
    Future.get(mutate(rawPurchasePrice), param => {
      setMutationLoading(param => false);
      popover.toggle();
    });
  }, [value, initialValue$1]);
  let dialogTitle = toLabel$1(calculatingMethod);
  let commitDisabled = initialValue$1 === value;
  let computedInitialValue;
  switch (calculatingMethod) {
    case "PurchasePrice":
      computedInitialValue = initialValue$1;
      break;
    case "FullPurchasePrice":
      computedInitialValue = computeFullPurchasePrice(initialValue$1, feesList.taxesAmount, feesList.otherAmount);
      break;
    case "AcquisitionCost":
      computedInitialValue = computeAcquisitionCost(initialValue$1, feesList.transportAmount, feesList.taxesAmount, feesList.otherAmount);
      break;
  }
  let formattedValue = I18n.currencyFormat(undefined, "EUR", 3, 3, computedInitialValue);
  let tmp;
  if (popover.isOpen) {
    let tmp$1;
    switch (calculatingMethod) {
      case "PurchasePrice":
        tmp$1 = JsxRuntime.jsx(make$13, {
          priceIsNet: priceIsNet,
          bulkUnit: bulkUnit,
          value: value,
          onChange: value => setValue(param => value)
        });
        break;
      case "FullPurchasePrice":
        tmp$1 = JsxRuntime.jsx(make$14, {
          priceIsNet: priceIsNet,
          feesList: feesList,
          bulkUnit: bulkUnit,
          value: value,
          onChange: value => setValue(param => value)
        });
        break;
      case "AcquisitionCost":
        tmp$1 = JsxRuntime.jsx(make$15, {
          priceIsNet: priceIsNet,
          feesList: feesList,
          bulkUnit: bulkUnit,
          value: value,
          onChange: value => setValue(param => value)
        });
        break;
    }
    tmp = JsxRuntime.jsx(Popover.make, {
      children: JsxRuntime.jsx(Dialog.make, {
        ariaProps: popoverAriaProps.overlayProps,
        children: tmp$1,
        width: 385,
        header: {
          TAG: "Title",
          _0: {
            text: dialogTitle
          }
        },
        commitDisabled: commitDisabled,
        commitLoading: match$1[0],
        commitButtonText: I18n.t("catalog_list.purchase_price_cell.dialog.commit_button_text"),
        onRequestCommit: onCommit,
        onRequestDiscard: popover.close
      }),
      triggerRef: popoverTriggerRef,
      state: popover,
      placement: "bottom end",
      modal: false
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(OpeningButton.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: formattedValue,
        size: "xsmall"
      }),
      ariaProps: popoverAriaProps.triggerProps,
      opened: popover.isOpen,
      onPress: param => popover.toggle(),
      ref: popoverTriggerRef
    }), tmp]
  });
});
let CatalogListPurchasePriceCell = {
  Mutation: Mutation,
  useMutation: useMutation,
  amountInputNumberAppender: amountInputNumberAppender,
  priceInputNumberAppender: priceInputNumberAppender,
  PurchasePriceCalculatingMethodDialogSections: PurchasePriceCalculatingMethodDialogSections,
  FullPurchasePriceCalculatingMethodDialogSections: FullPurchasePriceCalculatingMethodDialogSections,
  AcquisitionCostPriceCalculatingMethodDialogSections: AcquisitionCostPriceCalculatingMethodDialogSections,
  make: make$16
};
let styles = {
  CatalogListRetailPriceCell_InputContainer_root: {
    "backgroundColor-kWkggS": "backgroundColor-x1srn7af",
    "borderRadius-kaIpWk": "borderRadius-x12oqio5",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "padding-kmVPX3": "padding-xc7ga6q",
    $$css: "wino-gc:src/app/Catalog/CatalogListPage.res.js:4713"
  }
};
function styleProps() {
  return {
    className: "backgroundColor-x1srn7af borderRadius-x12oqio5 display-x78zum5 flexDirection-xdt5ytf padding-xc7ga6q",
    "data-style-src": "wino-gc:src/app/Catalog/CatalogListPage.res.js:4713"
  };
}
let make$17 = React.memo(props => {
  let match = {
    className: "backgroundColor-x1srn7af borderRadius-x12oqio5 display-x78zum5 flexDirection-xdt5ytf padding-xc7ga6q",
    "data-style-src": "wino-gc:src/app/Catalog/CatalogListPage.res.js:4713"
  };
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: match.className,
    style: match.style
  });
});
let InputContainer = {
  styles: styles,
  styleProps: styleProps,
  make: make$17
};
let make$18 = React.memo(props => {
  let onChange = props.onChange;
  let __totalChargesAmount = props.totalChargesAmount;
  let purchasePrice = props.purchasePrice;
  let taxRate = props.taxRate;
  let kind = props.rateType;
  let totalChargesAmount = __totalChargesAmount !== undefined ? __totalChargesAmount : 0;
  let value = PriceCalculator.Retail.Rate.apply(props.priceExcludingTaxValue, kind, purchasePrice, totalChargesAmount, taxRate);
  let onChange$1 = value => {
    let priceValue = Stdlib_Option.flatMap(value, v => PriceCalculator.Retail.Rate.undo(v, kind, purchasePrice, totalChargesAmount, taxRate));
    if (priceValue !== undefined) {
      return onChange(priceValue);
    }
  };
  return JsxRuntime.jsx(Dialog.Section.make, {
    children: JsxRuntime.jsx(InputOptionalNumberField.make, {
      value: value,
      minValue: kind !== "Coefficient" ? 0 : 1,
      maxValue: kind === "MarginRate" ? 99 : undefined,
      minPrecision: 0,
      precision: 4,
      label: toLabel(kind),
      placeholder: Placeholder.NC.text,
      appender: kind !== "Coefficient" ? "Percent" : undefined,
      disabled: purchasePrice === 0,
      onChange: onChange$1
    })
  });
});
let PriceDifferentialIndicatorSection = {
  make: make$18
};
let Raw$7 = {};
let query$7 = Client.gql(["mutation createOrUpdateVariantPrice($input: inputCreateOrUpdateVariantPriceTypeDef!)  {\ncreateOrUpdateVariantPrice(input: $input)  {\n__typename  \nid  \nvalueExcludingTax  \nvalueIncludingTax  \nprice  {\n__typename  \nid  \n}\n\nvariant  {\n__typename  \nid  \nvariantPrices  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);
function parse$7(value) {
  let value$1 = value.createOrUpdateVariantPrice;
  let value$2 = value$1.price;
  let value$3 = value$1.variant;
  let tmp;
  if (value$3 == null) {
    tmp = undefined;
  } else {
    let value$4 = value$3.variantPrices;
    let value$5 = value$4.edges;
    tmp = {
      __typename: value$3.__typename,
      id: value$3.id,
      variantPrices: {
        __typename: value$4.__typename,
        edges: value$5.map(value => {
          let value$1 = value.node;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              id: value$1.id
            }
          };
        })
      }
    };
  }
  return {
    createOrUpdateVariantPrice: {
      __typename: value$1.__typename,
      id: value$1.id,
      valueExcludingTax: value$1.valueExcludingTax,
      valueIncludingTax: value$1.valueIncludingTax,
      price: !(value$2 == null) ? {
        __typename: value$2.__typename,
        id: value$2.id
      } : undefined,
      variant: tmp
    }
  };
}
function serialize$7(value) {
  let value$1 = value.createOrUpdateVariantPrice;
  let value$2 = value$1.variant;
  let variant;
  if (value$2 !== undefined) {
    let value$3 = value$2.variantPrices;
    let value$4 = value$3.edges;
    let edges = value$4.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.id;
      let value$3 = value$1.__typename;
      let node = {
        __typename: value$3,
        id: value$2
      };
      let value$4 = value.__typename;
      return {
        __typename: value$4,
        node: node
      };
    });
    let value$5 = value$3.__typename;
    let variantPrices = {
      __typename: value$5,
      edges: edges
    };
    let value$6 = value$2.id;
    let value$7 = value$2.__typename;
    variant = {
      __typename: value$7,
      id: value$6,
      variantPrices: variantPrices
    };
  } else {
    variant = null;
  }
  let value$8 = value$1.price;
  let price;
  if (value$8 !== undefined) {
    let value$9 = value$8.id;
    let value$10 = value$8.__typename;
    price = {
      __typename: value$10,
      id: value$9
    };
  } else {
    price = null;
  }
  let value$11 = value$1.valueIncludingTax;
  let value$12 = value$1.valueExcludingTax;
  let value$13 = value$1.id;
  let value$14 = value$1.__typename;
  let createOrUpdateVariantPrice = {
    __typename: value$14,
    id: value$13,
    valueExcludingTax: value$12,
    valueIncludingTax: value$11,
    price: price,
    variant: variant
  };
  return {
    createOrUpdateVariantPrice: createOrUpdateVariantPrice
  };
}
function serializeInputObjectinputCreateOrUpdateVariantPriceTypeDef(inp) {
  return {
    valueIncludingTax: inp.valueIncludingTax,
    valueExcludingTax: inp.valueExcludingTax,
    priceId: inp.priceId,
    variantId: inp.variantId,
    shopId: inp.shopId
  };
}
function serializeVariables$6(inp) {
  return {
    input: serializeInputObjectinputCreateOrUpdateVariantPriceTypeDef(inp.input)
  };
}
function makeVariables$6(input, param) {
  return {
    input: input
  };
}
function makeInputObjectinputCreateOrUpdateVariantPriceTypeDef(valueIncludingTax, valueExcludingTax, priceId, variantId, shopId, param) {
  return {
    valueIncludingTax: valueIncludingTax,
    valueExcludingTax: valueExcludingTax,
    priceId: priceId,
    variantId: variantId,
    shopId: shopId
  };
}
let Mutation_inner$1 = {
  Raw: Raw$7,
  query: query$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$6,
  serializeInputObjectinputCreateOrUpdateVariantPriceTypeDef: serializeInputObjectinputCreateOrUpdateVariantPriceTypeDef,
  makeVariables: makeVariables$6,
  makeInputObjectinputCreateOrUpdateVariantPriceTypeDef: makeInputObjectinputCreateOrUpdateVariantPriceTypeDef
};
let include$6 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$7,
  Raw: Raw$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$6
});
let use$6 = include$6.use;
let Mutation_useWithVariables$1 = include$6.useWithVariables;
let Mutation$1 = {
  Mutation_inner: Mutation_inner$1,
  Raw: Raw$7,
  query: query$7,
  parse: parse$7,
  serialize: serialize$7,
  serializeVariables: serializeVariables$6,
  serializeInputObjectinputCreateOrUpdateVariantPriceTypeDef: serializeInputObjectinputCreateOrUpdateVariantPriceTypeDef,
  makeVariables: makeVariables$6,
  makeInputObjectinputCreateOrUpdateVariantPriceTypeDef: makeInputObjectinputCreateOrUpdateVariantPriceTypeDef,
  use: use$6,
  useWithVariables: Mutation_useWithVariables$1
};
function useMutation$1(variantId, priceId, shopId) {
  let match = use$6(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return (valueIncludingTax, valueExcludingTax) => {
    let input = makeInputObjectinputCreateOrUpdateVariantPriceTypeDef(valueIncludingTax, valueExcludingTax, priceId, variantId, shopId, undefined);
    return Future.mapError(Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      input: input
    })), undefined, param => {}), undefined, param => {});
  };
}
let amountInputNumberAppender$1 = {
  TAG: "Custom",
  _0: I18n.toCurrencySymbol("EUR")
};
function priceInputNumberAppender$1(bulkUnit) {
  return {
    TAG: "Custom",
    _0: I18n.toCurrencySymbol("EUR") + Stdlib_Option.mapOr(bulkUnit, "", unit => ` / ` + unit)
  };
}
let make$19 = React.memo(props => {
  let onChange = props.onChange;
  let value = props.value;
  let purchasePrice = props.purchasePrice;
  let taxRate = props.taxRate;
  let taxIncluded = props.taxIncluded;
  let bulkUnit = props.bulkUnit;
  let feesList = props.feesList;
  let otherFeeAmountValue = feesList.otherAmount;
  let taxesFeeAmountValue = feesList.taxesAmount;
  let transportFeeAmountValue = feesList.transportAmount;
  let charges = PriceCalculator.sumManyCharges([transportFeeAmountValue, taxesFeeAmountValue, otherFeeAmountValue]);
  let priceExcludingChargesAndTaxValue = PriceCalculator.Retail.Charges.remove(value, charges);
  let priceIncludingChargesAndTaxValue = PriceCalculator.Retail.Tax.add(priceExcludingChargesAndTaxValue, taxRate);
  let onPriceExcludingChargesAndTaxChange = value => onChange(PriceCalculator.Retail.Charges.addBack(value, charges));
  let onPriceIncludingChargesAndTaxChange = value => onChange(PriceCalculator.Retail.Charges.addBack(PriceCalculator.Retail.Tax.removeBack(value, taxRate), charges));
  let marginExcludingChargesAndTaxValue = PriceCalculator.Retail.Margin.compute(priceExcludingChargesAndTaxValue, purchasePrice);
  let priceIncludingTaxValue = PriceCalculator.Retail.Tax.add(value, taxRate);
  let onPriceExcludingTaxChange = value => onChange(value);
  let onPriceIncludingTaxChange = value => onChange(PriceCalculator.Retail.Tax.removeBack(value, taxRate));
  let chargesSectionDefaultCollapsed = transportFeeAmountValue === 0 && taxesFeeAmountValue === 0 && otherFeeAmountValue === 0;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(make$18, {
      rateType: props.rateType,
      taxRate: taxRate,
      purchasePrice: purchasePrice,
      priceExcludingTaxValue: value,
      totalChargesAmount: charges,
      onChange: onChange
    }), JsxRuntime.jsxs(Dialog.Section.make, {
      children: [JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: priceExcludingChargesAndTaxValue,
          minValue: 0,
          precision: 3,
          label: I18n.t("catalog_list.retail_price_cell.dialog.section_before_charges.price_excluding_tax.input_label"),
          appender: priceInputNumberAppender$1(bulkUnit),
          onChange: onPriceExcludingChargesAndTaxChange
        }),
        spaceTop: "xsmall"
      }), taxIncluded ? JsxRuntime.jsx(InputNumberField.make, {
        value: priceIncludingChargesAndTaxValue,
        minValue: 0,
        precision: 3,
        label: I18n.t("catalog_list.retail_price_cell.dialog.section_before_charges.price_including_tax.input_label"),
        appender: priceInputNumberAppender$1(bulkUnit),
        strongStyle: true,
        onChange: onPriceIncludingChargesAndTaxChange
      }) : null],
      title: I18n.t("catalog_list.retail_price_cell.dialog.section_before_charges"),
      collapsable: true,
      defaultCollapsed: true
    }), JsxRuntime.jsx(Dialog.Section.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(InputNumberField.make, {
            value: transportFeeAmountValue,
            precision: 3,
            label: I18n.t("catalog_list.retail_price_cell.dialog.section_charges.transport_fee.input_label.shorten"),
            appender: amountInputNumberAppender$1,
            disabled: true,
            hideStepper: true,
            onChange: param => {}
          }), JsxRuntime.jsx(InputNumberField.make, {
            value: taxesFeeAmountValue,
            precision: 3,
            label: I18n.t("catalog_list.retail_price_cell.dialog.section_charges.taxes_fee.input_label"),
            appender: amountInputNumberAppender$1,
            disabled: true,
            hideStepper: true,
            onChange: param => {}
          }), JsxRuntime.jsx(InputNumberField.make, {
            value: otherFeeAmountValue,
            precision: 3,
            label: I18n.t("catalog_list.retail_price_cell.dialog.section_charges.other_fee.input_label"),
            appender: amountInputNumberAppender$1,
            disabled: true,
            hideStepper: true,
            onChange: param => {}
          })],
          spaceX: "normal"
        }),
        spaceTop: "xxsmall"
      }),
      title: I18n.t("catalog_list.price_cell.dialog.section_charges"),
      collapsable: true,
      defaultCollapsed: chargesSectionDefaultCollapsed
    }), JsxRuntime.jsxs(Dialog.Section.make, {
      children: [taxIncluded ? JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: value,
          minValue: 0,
          precision: 2,
          label: I18n.t("catalog_list.retail_price_cell.dialog.section_final.price_excluding_tax.input_label"),
          appender: priceInputNumberAppender$1(bulkUnit),
          strongStyle: !taxIncluded,
          onChange: onPriceExcludingTaxChange
        }),
        spaceTop: "xsmall"
      }) : null, JsxRuntime.jsx(make$17, {
        children: JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(InputNumberField.make, {
            value: priceIncludingTaxValue,
            minValue: 0,
            precision: 2,
            label: I18n.t(taxIncluded ? "catalog_list.retail_price_cell.dialog.section_final.price_including_tax.input_label" : "catalog_list.retail_price_cell.dialog.section_final.price_excluding_tax.input_label"),
            appender: priceInputNumberAppender$1(bulkUnit),
            autoFocused: props.finalPriceInputAutoFocused,
            strongStyle: true,
            onChange: onPriceIncludingTaxChange
          }), JsxRuntime.jsx(InputNumberField.make, {
            value: marginExcludingChargesAndTaxValue,
            precision: 2,
            label: I18n.t("Margin"),
            appender: priceInputNumberAppender$1(bulkUnit),
            disabled: true,
            strongStyle: true,
            hideStepper: true,
            onChange: param => {}
          })],
          grid: ["auto", Stdlib_Option.isSome(bulkUnit) ? "165px" : "120px"],
          wrap: false,
          spaceX: "normal"
        })
      })],
      title: I18n.t("catalog_list.retail_price_cell.dialog.section_final"),
      collapsable: true
    })]
  });
});
let PurchasePriceCalculatingMethodDialogSections$1 = {
  make: make$19
};
let make$20 = React.memo(props => {
  let onChange = props.onChange;
  let value = props.value;
  let purchasePrice = props.purchasePrice;
  let taxRate = props.taxRate;
  let taxIncluded = props.taxIncluded;
  let bulkUnit = props.bulkUnit;
  let transportFeeAmountValue = props.feesList.transportAmount;
  let priceExcludingChargesAndTaxValue = PriceCalculator.Retail.Charges.remove(value, transportFeeAmountValue);
  let priceIncludingChargesAndTaxValue = PriceCalculator.Retail.Tax.add(priceExcludingChargesAndTaxValue, taxRate);
  let onPriceExcludingChargesAndTaxChange = value => onChange(PriceCalculator.Retail.Charges.addBack(value, transportFeeAmountValue));
  let onPriceIncludingChargesAndTaxChange = value => onChange(PriceCalculator.Retail.Charges.addBack(PriceCalculator.Retail.Tax.removeBack(value, taxRate), transportFeeAmountValue));
  let marginExcludingChargesAndTaxValue = PriceCalculator.Retail.Margin.compute(priceExcludingChargesAndTaxValue, purchasePrice);
  let priceIncludingTaxValue = PriceCalculator.Retail.Tax.add(value, taxRate);
  let onPriceExcludingTaxChange = value => onChange(value);
  let onPriceIncludingTaxChange = value => onChange(PriceCalculator.Retail.Tax.removeBack(value, taxRate));
  let chargesSectionDefaultCollapsed = transportFeeAmountValue === 0;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(make$18, {
      rateType: props.rateType,
      taxRate: taxRate,
      purchasePrice: purchasePrice,
      priceExcludingTaxValue: value,
      totalChargesAmount: transportFeeAmountValue,
      onChange: onChange
    }), JsxRuntime.jsxs(Dialog.Section.make, {
      children: [JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: priceExcludingChargesAndTaxValue,
          minValue: 0,
          precision: 3,
          label: I18n.t("catalog_list.retail_price_cell.dialog.section_before_charges.price_excluding_tax.input_label"),
          appender: priceInputNumberAppender$1(bulkUnit),
          onChange: onPriceExcludingChargesAndTaxChange
        }),
        spaceTop: "xsmall"
      }), taxIncluded ? JsxRuntime.jsx(InputNumberField.make, {
        value: priceIncludingChargesAndTaxValue,
        minValue: 0,
        precision: 3,
        label: I18n.t("catalog_list.retail_price_cell.dialog.section_before_charges.price_including_tax.input_label"),
        appender: priceInputNumberAppender$1(bulkUnit),
        strongStyle: true,
        onChange: onPriceIncludingChargesAndTaxChange
      }) : null],
      title: I18n.t("catalog_list.retail_price_cell.dialog.section_before_charges"),
      collapsable: true,
      defaultCollapsed: true
    }), JsxRuntime.jsx(Dialog.Section.make, {
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: transportFeeAmountValue,
          precision: 3,
          label: I18n.t("catalog_list.retail_price_cell.dialog.section_charges.transport_fee.input_label"),
          appender: amountInputNumberAppender$1,
          disabled: true,
          hideStepper: true,
          onChange: param => {}
        }),
        spaceTop: "xxsmall"
      }),
      title: I18n.t("catalog_list.price_cell.dialog.section_charges"),
      collapsable: true,
      defaultCollapsed: chargesSectionDefaultCollapsed
    }), JsxRuntime.jsxs(Dialog.Section.make, {
      children: [taxIncluded ? JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: value,
          minValue: 0,
          precision: 2,
          label: I18n.t("catalog_list.retail_price_cell.dialog.section_final.price_excluding_tax.input_label"),
          appender: priceInputNumberAppender$1(bulkUnit),
          strongStyle: !taxIncluded,
          onChange: onPriceExcludingTaxChange
        }),
        spaceTop: "xsmall"
      }) : null, JsxRuntime.jsx(make$17, {
        children: JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(InputNumberField.make, {
            value: priceIncludingTaxValue,
            minValue: 0,
            precision: 2,
            label: I18n.t(taxIncluded ? "catalog_list.retail_price_cell.dialog.section_final.price_including_tax.input_label" : "catalog_list.retail_price_cell.dialog.section_final.price_excluding_tax.input_label"),
            appender: priceInputNumberAppender$1(bulkUnit),
            autoFocused: props.finalPriceInputAutoFocused,
            strongStyle: true,
            onChange: onPriceIncludingTaxChange
          }), JsxRuntime.jsx(InputNumberField.make, {
            value: marginExcludingChargesAndTaxValue,
            precision: 2,
            label: I18n.t("Margin"),
            appender: priceInputNumberAppender$1(bulkUnit),
            disabled: true,
            strongStyle: true,
            hideStepper: true,
            onChange: param => {}
          })],
          grid: ["auto", Stdlib_Option.isSome(bulkUnit) ? "165px" : "120px"],
          wrap: false,
          spaceX: "normal"
        })
      })],
      title: I18n.t("catalog_list.retail_price_cell.dialog.section_final"),
      collapsable: true
    })]
  });
});
let FullPurchasePriceCalculatingMethodDialogSections$1 = {
  make: make$20
};
let make$21 = React.memo(props => {
  let onChange = props.onChange;
  let value = props.value;
  let purchasePrice = props.purchasePrice;
  let taxRate = props.taxRate;
  let taxIncluded = props.taxIncluded;
  let bulkUnit = props.bulkUnit;
  let marginExcludingTaxValue = PriceCalculator.Retail.Margin.compute(value, purchasePrice);
  let priceIncludingTaxValue = PriceCalculator.Retail.Tax.add(value, taxRate);
  let onPriceExcludingTaxChange = value => onChange(value);
  let onPriceIncludingTaxChange = value => onChange(PriceCalculator.Retail.Tax.removeBack(value, taxRate));
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(make$18, {
      rateType: props.rateType,
      taxRate: taxRate,
      purchasePrice: purchasePrice,
      priceExcludingTaxValue: value,
      onChange: onChange
    }), JsxRuntime.jsxs(Dialog.Section.make, {
      children: [taxIncluded ? JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(InputNumberField.make, {
          value: value,
          minValue: 0,
          precision: 2,
          label: I18n.t("catalog_list.retail_price_cell.dialog.section_final.price_excluding_tax.input_label"),
          appender: priceInputNumberAppender$1(bulkUnit),
          strongStyle: !taxIncluded,
          onChange: onPriceExcludingTaxChange
        }),
        spaceTop: "xsmall"
      }) : null, JsxRuntime.jsx(make$17, {
        children: JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(InputNumberField.make, {
            value: priceIncludingTaxValue,
            minValue: 0,
            precision: 2,
            label: I18n.t(taxIncluded ? "catalog_list.retail_price_cell.dialog.section_final.price_including_tax.input_label" : "catalog_list.retail_price_cell.dialog.section_final.price_excluding_tax.input_label"),
            appender: priceInputNumberAppender$1(bulkUnit),
            autoFocused: props.finalPriceInputAutoFocused,
            strongStyle: true,
            onChange: onPriceIncludingTaxChange
          }), JsxRuntime.jsx(InputNumberField.make, {
            value: marginExcludingTaxValue,
            precision: 2,
            label: I18n.t("Margin"),
            appender: priceInputNumberAppender$1(bulkUnit),
            disabled: true,
            strongStyle: true,
            hideStepper: true,
            onChange: param => {}
          })],
          grid: ["auto", Stdlib_Option.isSome(bulkUnit) ? "165px" : "120px"],
          wrap: false,
          spaceX: "normal"
        })
      })],
      title: I18n.t("catalog_list.retail_price_cell.dialog.section_final")
    })]
  });
});
let AcquisitionCostCalculatingMethodDialogSection = {
  make: make$21
};
let styles$1 = {
  root: {
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "gap-kOIVth": "gap-x195vfkc",
    $$css: "wino-gc:src/app/Catalog/CatalogListPage.res.js:5346"
  }
};
function styleProps$1() {
  return {
    className: "display-x78zum5 flexDirection-xdt5ytf gap-x195vfkc",
    "data-style-src": "wino-gc:src/app/Catalog/CatalogListPage.res.js:5346"
  };
}
let make$22 = React.memo(props => {
  let __useMutation = props.useMutation;
  let value = props.value;
  let purchasePrice = props.purchasePrice;
  let rateType = props.rateType;
  let feesList = props.feesList;
  let taxRate = props.taxRate;
  let bulkUnit = props.bulkUnit;
  let pricelist = props.pricelist;
  let useMutation$2 = __useMutation !== undefined ? __useMutation : useMutation$1;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let captureEvent = SessionTracker.useCaptureEvent();
  let taxIncluded = pricelist.taxIncluded;
  let match$1 = React.useState(() => false);
  let setMutationLoading = match$1[1];
  let mutate = useMutation$2(props.variantId, pricelist.id, props.shopId);
  let priceExists = Stdlib_Option.isSome(value);
  let match$2 = Stdlib_Option.getOr(value, {
    valueExcludingTax: 0,
    valueIncludingTax: 0
  });
  let initialValueExcludingTax = match$2.valueExcludingTax;
  let match$3 = React.useState(() => initialValueExcludingTax);
  let setValue = match$3[1];
  let value$1 = match$3[0];
  ReactUpdateEffect.use1(() => {
    if (popover.isOpen) {
      setValue(param => initialValueExcludingTax);
    }
  }, [popover.isOpen]);
  let onCommit = React.useCallback(() => {
    let valueIncludingTax = PriceCalculator.Retail.Tax.add(value$1, taxRate);
    if (value$1 !== initialValueExcludingTax) {
      setMutationLoading(param => true);
      Future.get(mutate(valueIncludingTax, value$1), param => {
        setMutationLoading(param => false);
        popover.toggle();
      });
      captureEvent("catalog_retailprice_click_save");
      if (feesList.transportAmount !== 0 || feesList.taxesAmount !== 0 || feesList.otherAmount !== 0) {
        return captureEvent("catalog_retailprice_with_charges_click_save");
      } else {
        return;
      }
    } else {
      return popover.close();
    }
  }, [value$1, initialValueExcludingTax]);
  let match$4 = {
    className: "display-x78zum5 flexDirection-xdt5ytf gap-x195vfkc",
    "data-style-src": "wino-gc:src/app/Catalog/CatalogListPage.res.js:5346"
  };
  let taxTypename = I18n.t(taxIncluded ? "VAT incl." : "VAT excl.");
  let dialogTitleStartElement = JsxRuntime.jsx(Badge.make, {
    children: taxTypename,
    size: "small",
    variation: "neutral"
  });
  let formattedRetailPriceExcludingTax = I18n.currencyFormat(undefined, "EUR", undefined, undefined, initialValueExcludingTax);
  let formattedRetailPriceIncludingTax = I18n.currencyFormat(undefined, "EUR", undefined, undefined, match$2.valueIncludingTax);
  let taxRate$1 = taxIncluded ? taxRate : 0;
  let finalPriceInputAutoFocused = initialValueExcludingTax === value$1;
  let commitDisabled = initialValueExcludingTax === value$1;
  let tmp;
  if (popover.isOpen) {
    let tmp$1;
    switch (props.calculatingMethod) {
      case "PurchasePrice":
        tmp$1 = JsxRuntime.jsx(make$19, {
          finalPriceInputAutoFocused: finalPriceInputAutoFocused,
          feesList: feesList,
          bulkUnit: bulkUnit,
          rateType: rateType,
          taxIncluded: taxIncluded,
          taxRate: taxRate$1,
          purchasePrice: purchasePrice,
          value: value$1,
          onChange: value => setValue(param => value)
        });
        break;
      case "FullPurchasePrice":
        tmp$1 = JsxRuntime.jsx(make$20, {
          finalPriceInputAutoFocused: finalPriceInputAutoFocused,
          feesList: feesList,
          bulkUnit: bulkUnit,
          rateType: rateType,
          taxIncluded: taxIncluded,
          taxRate: taxRate$1,
          purchasePrice: purchasePrice,
          value: value$1,
          onChange: value => setValue(param => value)
        });
        break;
      case "AcquisitionCost":
        tmp$1 = JsxRuntime.jsx(make$21, {
          finalPriceInputAutoFocused: finalPriceInputAutoFocused,
          bulkUnit: bulkUnit,
          rateType: rateType,
          taxIncluded: taxIncluded,
          taxRate: taxRate$1,
          purchasePrice: purchasePrice,
          value: value$1,
          onChange: value => setValue(param => value)
        });
        break;
    }
    tmp = JsxRuntime.jsx(Popover.make, {
      children: JsxRuntime.jsx(Dialog.make, {
        ariaProps: popoverAriaProps.overlayProps,
        children: tmp$1,
        width: 385,
        header: {
          TAG: "Title",
          _0: {
            text: pricelist.name,
            titleStartElement: dialogTitleStartElement
          }
        },
        commitDisabled: commitDisabled,
        commitLoading: match$1[0],
        commitButtonText: I18n.t("catalog_list.retail_price_cell.dialog.commit_button_text"),
        onRequestCommit: onCommit,
        onRequestDiscard: popover.close
      }),
      triggerRef: popoverTriggerRef,
      state: popover,
      placement: "bottom end",
      modal: false
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(OpeningButton.make, {
      children: taxIncluded && priceExists ? JsxRuntime.jsxs("div", {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: formattedRetailPriceIncludingTax,
          weight: "strong",
          size: "xxsmall"
        }), JsxRuntime.jsx(TextStyle.make, {
          children: formattedRetailPriceExcludingTax + " " + I18n.t("excl. tax"),
          variation: "normal",
          size: "tiny",
          lineHeight: "xnormal"
        })],
        className: match$4.className,
        style: match$4.style
      }) : priceExists ? JsxRuntime.jsx(TextStyle.make, {
        children: formattedRetailPriceExcludingTax,
        weight: "strong",
        size: "xxsmall"
      }) : JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Undefined"),
        variation: "subdued",
        size: "xsmall"
      }),
      ariaProps: popoverAriaProps.triggerProps,
      opened: popover.isOpen,
      onPress: param => popover.toggle(),
      ref: popoverTriggerRef
    }), tmp]
  });
});
let CatalogListRetailPriceCell = {
  InputContainer: InputContainer,
  PriceDifferentialIndicatorSection: PriceDifferentialIndicatorSection,
  Mutation: Mutation$1,
  useMutation: useMutation$1,
  amountInputNumberAppender: amountInputNumberAppender$1,
  priceInputNumberAppender: priceInputNumberAppender$1,
  PurchasePriceCalculatingMethodDialogSections: PurchasePriceCalculatingMethodDialogSections$1,
  FullPurchasePriceCalculatingMethodDialogSections: FullPurchasePriceCalculatingMethodDialogSections$1,
  AcquisitionCostCalculatingMethodDialogSection: AcquisitionCostCalculatingMethodDialogSection,
  styles: styles$1,
  styleProps: styleProps$1,
  make: make$22
};
let coefficientIcon = JsxRuntime.jsx(Svg.make, {
  children: JsxRuntime.jsx(Svg.Path.make, {
    d: "M2.39354 9.182C2.27638 9.29916 2.27638 9.48911 2.39354 9.60626C2.5107 9.72342 2.70065 9.72342 2.8178 9.60626L5.99978 6.42429L9.18176 9.60627C9.29891 9.72342 9.48886 9.72342 9.60602 9.60627C9.72318 9.48911 9.72318 9.29916 9.60602 9.182L6.42404 6.00003L9.60603 2.81804C9.72319 2.70088 9.72319 2.51093 9.60603 2.39378C9.48887 2.27662 9.29892 2.27662 9.18177 2.39378L5.99978 5.57576L2.8178 2.39378C2.70064 2.27662 2.51069 2.27662 2.39353 2.39378C2.27637 2.51093 2.27637 2.70088 2.39353 2.81804L5.57552 6.00003L2.39354 9.182Z",
    fill: "#767589"
  }),
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
});
function CatalogListPage$CatalogListPriceDifferentialIndicatorCell(props) {
  let rateType = props.rateType;
  let rate = PriceCalculator.Retail.Rate.apply(props.retailPriceExcludingTax, rateType, props.purchasePrice, props.totalChargesAmount, props.taxRate);
  let formattedRate = Stdlib_Option.map(rate, rate => I18n.decimalFormat(undefined, 0, 2, undefined, rate) + (rateType === "Coefficient" ? "" : " %"));
  switch (rateType) {
    case "Coefficient":
      if (formattedRate !== undefined) {
        return JsxRuntime.jsxs(Inline.make, {
          children: [Stdlib_Option.isSome(rate) ? JsxRuntime.jsx(Offset.make, {
            children: coefficientIcon,
            top: -2.5,
            width: 12,
            height: 12
          }) : null, JsxRuntime.jsx(TextStyle.make, {
            children: formattedRate,
            size: "xsmall"
          })],
          space: "xsmall"
        });
      } else {
        return JsxRuntime.jsx(Placeholder.NC.make, {});
      }
    case "MarginRate":
    case "MarkupRate":
      break;
  }
  if (formattedRate !== undefined) {
    return JsxRuntime.jsx(TextStyle.make, {
      children: formattedRate,
      size: "xsmall"
    });
  } else {
    return JsxRuntime.jsx(Placeholder.NC.make, {});
  }
}
let CatalogListPriceDifferentialIndicatorCell = {
  coefficientIcon: coefficientIcon,
  make: CatalogListPage$CatalogListPriceDifferentialIndicatorCell
};
let jsonCodec$2 = JsonCodec.object1(param => param.price, price => ({
  TAG: "Ok",
  _0: {
    price: price
  }
}), JsonCodec.field("price", jsonCodec$1));
let CatalogListExtraParams = {
  jsonCodec: jsonCodec$2
};
let allStatuses = ["Active", "Inactive", {
  TAG: "Archived",
  _0: undefined
}];
function isArchived(status) {
  return typeof status === "object";
}
function encodeValues(values) {
  if (values.length !== 0) {
    return values;
  }
}
function unionConstraint(statuses, toValue) {
  return Stdlib_Option.getOr(Stdlib_Array.reduce(statuses, undefined, (acc, status) => {
    if (acc === undefined) {
      return Primitive_option.some(toValue(status));
    }
    let value = Primitive_option.valFromOption(acc);
    return Primitive_option.some(Primitive_object.equal(value, toValue(status)) ? value : undefined);
  }), undefined);
}
function activeFromStatuses(statuses) {
  return unionConstraint(statuses, status => {
    if (typeof status === "object") {
      return;
    }
    switch (status) {
      case "Active":
        return true;
      case "Inactive":
        return false;
      case "Unarchived":
        return;
    }
  });
}
function archivedFromStatuses(statuses) {
  return unionConstraint(statuses, status => isArchived(status));
}
let supplier = JsonCodec.object2(param => [Stdlib_Option.getOr(Primitive_option.fromNullable(param.id), "null"), param.name], param => {
  let id = param[0];
  return {
    TAG: "Ok",
    _0: {
      id: id === "null" ? null : id,
      name: param[1]
    }
  };
}, JsonCodec.field("id", JsonCodec.string), JsonCodec.field("name", JsonCodec.string));
let category = JsonCodec.object2(param => [Stdlib_Option.getOr(Primitive_option.fromNullable(param.id), "null"), param.name], param => {
  let id = param[0];
  return {
    TAG: "Ok",
    _0: {
      id: id === "null" ? null : id,
      name: param[1]
    }
  };
}, JsonCodec.field("id", JsonCodec.string), JsonCodec.field("name", JsonCodec.string));
let stock = JsonCodec.object2(param => [param.min, param.max], param => ({
  TAG: "Ok",
  _0: {
    min: param[0],
    max: param[1]
  }
}), JsonCodec.optional(JsonCodec.field("min", JsonCodec.float)), JsonCodec.optional(JsonCodec.field("max", JsonCodec.float)));
function jsonCodec$3(shops) {
  return JsonCodec.object6(param => [Stdlib_Option.map(param.shop, shop => shop.id), encodeValues(param.statuses.map(CatalogProduct.Status.toString)), param.category, param.supplier, param.producer, param.stock], param => {
    let shopId = param[0];
    return {
      TAG: "Ok",
      _0: {
        shop: shops.find(shop => shop.id === shopId),
        statuses: Stdlib_Array.filterMap(Stdlib_Option.getOr(param[1], []), status => {
          let status$1 = CatalogProduct.Status.fromString(status);
          if (status$1.TAG === "Ok") {
            return status$1._0;
          }
        }),
        category: param[2],
        supplier: param[3],
        producer: param[4],
        stock: param[5]
      }
    };
  }, JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("statuses", JsonCodec.array(JsonCodec.string))), JsonCodec.optional(JsonCodec.field("category", category)), JsonCodec.optional(JsonCodec.field("supplier", supplier)), JsonCodec.optional(JsonCodec.field("producer", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("stock", stock)));
}
let Raw$8 = {};
let query$8 = Client.gql(["query productRegions($country: String)  {\nproductRegions(country: $country)  \n}\n"]);
function parse$8(value) {
  let value$1 = value.productRegions;
  return {
    productRegions: value$1.map(value => value)
  };
}
function serialize$8(value) {
  let value$1 = value.productRegions;
  let productRegions = value$1.map(value => value);
  return {
    productRegions: productRegions
  };
}
function serializeVariables$7(inp) {
  let a = inp.country;
  return {
    country: a !== undefined ? a : undefined
  };
}
function makeVariables$7(country) {
  return {
    country: country
  };
}
function makeDefaultVariables$3() {
  return {
    country: undefined
  };
}
let Query_inner = {
  Raw: Raw$8,
  query: query$8,
  parse: parse$8,
  serialize: serialize$8,
  serializeVariables: serializeVariables$7,
  makeVariables: makeVariables$7,
  makeDefaultVariables: makeDefaultVariables$3
};
let include$7 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$8,
  Raw: Raw$8,
  parse: parse$8,
  serialize: serialize$8,
  serializeVariables: serializeVariables$7
});
let use$7 = include$7.use;
let Query_refetchQueryDescription = include$7.refetchQueryDescription;
let Query_useLazy = include$7.useLazy;
let Query_useLazyWithVariables = include$7.useLazyWithVariables;
let Query = {
  Query_inner: Query_inner,
  Raw: Raw$8,
  query: query$8,
  parse: parse$8,
  serialize: serialize$8,
  serializeVariables: serializeVariables$7,
  makeVariables: makeVariables$7,
  makeDefaultVariables: makeDefaultVariables$3,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use$7,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};
function CatalogListPage$CatalogListFilters$RegionSelect(props) {
  let onChange = props.onChange;
  let disabled = props.disabled;
  let results = use$7(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
    country: "France"
  });
  let match = results.data;
  let items = match !== undefined ? match.productRegions.filter(suggestion => suggestion !== "").map(productRegions => ({
    TAG: "Option",
    key: productRegions,
    label: productRegions,
    value: productRegions
  })) : [];
  let defaultItem_1 = I18n.t("All");
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined,
    exclusive: defaultItem_4
  };
  let sections = [{
    items: [defaultItem]
  }, {
    items: items,
    title: I18n.t("Regions")
  }];
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Select.make, {
      label: I18n.t("Regions"),
      preset: "filter",
      size: "compact",
      disabled: disabled,
      sections: sections,
      value: {
        TAG: "Single",
        _0: props.value
      },
      onChange: change => {
        if (change.TAG === "Single") {
          return onChange(change._0);
        }
      }
    }),
    placement: "top",
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.t("Please select a shop beforehand.")
    }),
    disabled: !disabled,
    delay: 350
  });
}
let RegionSelect = {
  Query: Query,
  make: CatalogListPage$CatalogListFilters$RegionSelect
};
let CatalogListFilters = {
  allStatuses: allStatuses,
  isArchived: isArchived,
  encodeValues: encodeValues,
  unionConstraint: unionConstraint,
  activeFromStatuses: activeFromStatuses,
  archivedFromStatuses: archivedFromStatuses,
  supplier: supplier,
  category: category,
  stock: stock,
  jsonCodec: jsonCodec$3,
  RegionSelect: RegionSelect
};
let make$23 = React.memo(props => {
  let onChange = props.onChange;
  let value = props.value;
  let defaultItem_1 = I18n.t("All");
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: undefined,
    exclusive: defaultItem_4
  };
  let items = allStatuses.map(value => ({
    TAG: "Option",
    key: CatalogProduct.Status.toString(value),
    label: CatalogProduct.Status.toLabel(value),
    value: value
  }));
  return JsxRuntime.jsx(Select.make, {
    label: I18n.t("Status"),
    preset: "filter",
    size: "compact",
    highlighted: Primitive_object.notequal(value, ["Active"]),
    shouldSelectTogether: (value, other) => {
      if (Stdlib_Option.mapOr(value, false, isArchived)) {
        return false;
      } else {
        return !Stdlib_Option.mapOr(other, false, isArchived);
      }
    },
    renderValue: param => {
      let selectedItems = param.selectedItems;
      let exit = 0;
      let len = selectedItems.length;
      if (len !== 1) {
        exit = len !== 0 ? 1 : 2;
      } else {
        let match = selectedItems[0];
        if (match.TAG === "Option") {
          let status = match.value;
          if (status !== undefined) {
            return JsxRuntime.jsx(Inline.make, {
              children: JsxRuntime.jsx(CatalogProduct.Status.Badge.make, {
                value: status,
                size: "normal"
              })
            });
          }
          exit = 2;
        } else {
          exit = 1;
        }
      }
      switch (exit) {
        case 1:
          return JsxRuntime.jsx(CountBadge.make, {
            children: selectedItems.length.toString(),
            size: "small",
            tone: "brand"
          });
        case 2:
          return JsxRuntime.jsx("span", {
            children: I18n.t("All")
          });
      }
    },
    renderItem: param => {
      let item = param.item;
      if (item.TAG !== "Option") {
        return null;
      }
      let status = item.value;
      if (status !== undefined) {
        return JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(CatalogProduct.Status.Badge.make, {
            value: status
          })
        });
      } else {
        return JsxRuntime.jsx("span", {
          children: I18n.t("All")
        });
      }
    },
    sections: [{
      items: [defaultItem]
    }, {
      items: items,
      title: I18n.t("Statuses")
    }],
    value: {
      TAG: "Multiple",
      _0: value.length !== 0 ? value.map(status => status) : [undefined]
    },
    onChange: change => {
      if (change.TAG === "Single") {
        return;
      } else {
        return onChange(Stdlib_Array.filterMap(change._0, value => value));
      }
    }
  });
});
let CatalogListFilterStatusSelect = {
  make: make$23
};
function toSortDescriptor(sort) {
  switch (sort.TAG) {
    case "Name":
      return {
        column: "reference",
        direction: sort._0
      };
    case "Producer":
      return {
        column: "producer",
        direction: sort._0
      };
    case "PurchasePrice":
      return {
        column: "purchase-price",
        direction: sort._0
      };
    case "CreatedAt":
      return {
        column: "created-at",
        direction: sort._0
      };
  }
}
function fromSortDescriptor(sort) {
  switch (sort.column) {
    case "created-at":
      return {
        TAG: "Ok",
        _0: {
          TAG: "CreatedAt",
          _0: sort.direction
        }
      };
    case "producer":
      return {
        TAG: "Ok",
        _0: {
          TAG: "Producer",
          _0: sort.direction
        }
      };
    case "purchase-price":
      return {
        TAG: "Ok",
        _0: {
          TAG: "PurchasePrice",
          _0: sort.direction
        }
      };
    case "reference":
      return {
        TAG: "Ok",
        _0: {
          TAG: "Name",
          _0: sort.direction
        }
      };
    default:
      return {
        TAG: "Error",
        _0: undefined
      };
  }
}
let jsonCodec$4 = JsonCodec.object2(sort => [toSortDescriptor(sort).column, toSortDescriptor(sort).direction], param => {
  let direction = param[1] === "descending" ? "descending" : "ascending";
  let ok = fromSortDescriptor({
    column: param[0],
    direction: direction
  });
  if (ok.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: ok._0
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: "Invalid sort descriptor"
      }
    };
  }
}, JsonCodec.field("column", JsonCodec.string), JsonCodec.field("direction", JsonCodec.string));
let CatalogListSorting = {
  toSortDescriptor: toSortDescriptor,
  fromSortDescriptor: fromSortDescriptor,
  jsonCodec: jsonCodec$4
};
function makeFromFilters(filters) {
  let statuses = filters.statuses;
  let shopId = Stdlib_Option.map(filters.shop, param => param.id);
  let variantsActive = activeFromStatuses(statuses);
  let variantsArchived = archivedFromStatuses(statuses);
  let categoryId = Stdlib_Option.map(filters.category, category => category.id);
  let supplierId = Stdlib_Option.map(filters.supplier, supplier => supplier.id);
  return {
    shopId: shopId,
    variantsActive: variantsActive,
    variantsArchived: variantsArchived,
    categoryId: categoryId,
    supplierId: supplierId,
    producer: filters.producer,
    stock: filters.stock
  };
}
let CatalogListSheetExportInput = {
  makeFromFilters: makeFromFilters
};
function catalogListMultiShopsTableRowsFromQueryResult(queryResult) {
  return queryResult.variantsDistinctOnCku.edges.map(edge => {
    let match = edge.node.formattedStatus;
    let match$1 = edge.node.capacityUnit;
    let match$2 = Stdlib_Option.getOr(edge.node.bulk, false);
    return {
      cku: edge.node.cku,
      id: edge.node.id,
      createdAt: edge.node.createdAt,
      productId: edge.node.product.id,
      name: edge.node.name,
      productName: edge.node.product.name,
      productKind: edge.node.product.kind,
      productTaxRate: edge.node.product.tax.value,
      designation: edge.node.product.designation,
      family: edge.node.product.family,
      wineType: edge.node.product.wineType,
      whiteWineType: edge.node.product.whiteWineType,
      beerType: edge.node.product.beerType,
      color: edge.node.product.color,
      producer: edge.node.product.producer,
      categoryName: Stdlib_Option.getOr(edge.node.formattedCategory, nonApplicableStringLiteral),
      supplierName: Stdlib_Option.map(edge.node.supplier, supplier => supplier.companyName),
      region: edge.node.product.region,
      country: edge.node.product.country,
      feesList: {
        transportAmount: 0,
        taxesAmount: 0,
        otherAmount: 0
      },
      purchasePrice: Stdlib_Option.getOr(edge.node.purchasedPrice, 0),
      purchasePriceDiscount: 0,
      retailPrice: undefined,
      stockKeepingUnit: edge.node.stockKeepingUnit,
      priceLookUpCode: edge.node.priceLookUpCode,
      internalCode: edge.node.internalCode,
      stockQuantity: edge.node.stock.formattedQuantity,
      stockState: Stdlib_Option.getOr(edge.node.stock.state, "ALERT"),
      formattedShopsNames: edge.node.stock.formattedShopsNames,
      status: match === "INACTIVE" ? "Inactive" : match === "ARCHIVED" ? {
        TAG: "Archived",
        _0: edge.node.archivedAt
      } : match === "ACTIVE" ? "Active" : undefined,
      bulkUnit: match$1 !== undefined && match$2 ? match$1 : undefined,
      maxStockThreshold: Stdlib_Option.getOr(edge.node.maxStockThreshold, 0),
      minStockThreshold: Stdlib_Option.getOr(edge.node.minStockThreshold, 0),
      stockOrderTriggerThreshold: Stdlib_Option.getOr(edge.node.stockOrderTriggerThreshold, 0),
      bulk: Stdlib_Option.getOr(edge.node.bulk, false),
      alcoholVolume: edge.node.alcoholVolume
    };
  });
}
function catalogListSingleShopTableRowsFromQueryResult(queryResult, currentPriceId) {
  return queryResult.variants.edges.map(edge => {
    let latestOrderProduct = Stdlib_Option.map(edge.node.orderProducts.edges[0], edge => edge.node);
    let latestOrderProduct$1 = Stdlib_Option.map(edge.node.orderProducts.edges[0], edge => edge.node);
    let match = edge.node.formattedStatus;
    let match$1 = edge.node.capacityUnit;
    let match$2 = Stdlib_Option.getOr(edge.node.bulk, false);
    return {
      cku: edge.node.cku,
      id: edge.node.id,
      createdAt: edge.node.createdAt,
      productId: edge.node.product.id,
      name: edge.node.name,
      productName: edge.node.product.name,
      productKind: edge.node.product.kind,
      productTaxRate: edge.node.product.tax.value,
      designation: edge.node.product.designation,
      family: edge.node.product.family,
      wineType: edge.node.product.wineType,
      whiteWineType: edge.node.product.whiteWineType,
      beerType: edge.node.product.beerType,
      color: edge.node.product.color,
      producer: edge.node.product.producer,
      categoryName: Stdlib_Option.getOr(edge.node.formattedCategory, nonApplicableStringLiteral),
      supplierName: Stdlib_Option.map(edge.node.supplier, supplier => supplier.companyName),
      region: edge.node.product.region,
      country: edge.node.product.country,
      feesList: latestOrderProduct !== undefined ? decodeFeesJsonToFeesList(latestOrderProduct.fees) : {
        transportAmount: 0,
        taxesAmount: 0,
        otherAmount: 0
      },
      purchasePrice: Stdlib_Option.getOr(edge.node.purchasedPrice, 0),
      purchasePriceDiscount: latestOrderProduct$1 !== undefined ? latestOrderProduct$1.totalLocalDiscounts / latestOrderProduct$1.quantity : 0,
      retailPrice: Stdlib_Option.map(edge.node.variantPrices.edges.find(variantPrice => {
        let match = variantPrice.node.price;
        if (match !== undefined && currentPriceId !== undefined) {
          return match.id === currentPriceId;
        } else {
          return false;
        }
      }), variantPrice => ({
        valueExcludingTax: variantPrice.node.valueExcludingTax,
        valueIncludingTax: variantPrice.node.valueIncludingTax
      })),
      stockKeepingUnit: edge.node.stockKeepingUnit,
      priceLookUpCode: edge.node.priceLookUpCode,
      internalCode: edge.node.internalCode,
      stockQuantity: edge.node.stock.formattedQuantity,
      stockState: Stdlib_Option.getOr(edge.node.stock.state, "ALERT"),
      formattedShopsNames: edge.node.stock.formattedShopsNames,
      status: match === "INACTIVE" ? "Inactive" : match === "ARCHIVED" ? {
        TAG: "Archived",
        _0: edge.node.archivedAt
      } : match === "ACTIVE" ? "Active" : undefined,
      bulkUnit: match$1 !== undefined && match$2 ? match$1 : undefined,
      maxStockThreshold: Stdlib_Option.getOr(edge.node.maxStockThreshold, 0),
      minStockThreshold: Stdlib_Option.getOr(edge.node.minStockThreshold, 0),
      stockOrderTriggerThreshold: Stdlib_Option.getOr(edge.node.stockOrderTriggerThreshold, 0),
      bulk: Stdlib_Option.getOr(edge.node.bulk, false),
      alcoholVolume: edge.node.alcoholVolume
    };
  });
}
function catalogListMultiShopsQueryVariablesFilterBy(param) {
  let statuses = param.statuses;
  let shop = param.shop;
  let active = activeFromStatuses(statuses);
  let match = archivedFromStatuses(statuses);
  return {
    shopIds: shop !== undefined ? {
      _in: [shop.id]
    } : undefined,
    active: active !== undefined ? {
      _equals: active
    } : undefined,
    archived: match !== undefined ? match ? "ONLY" : "EXCLUDED" : "INCLUDED"
  };
}
function catalogListMultiShopsQueryVariablesOrderBy(sort) {
  let toRawDirection = direction => {
    if (direction === "ascending") {
      return "ASC";
    } else {
      return "DESC";
    }
  };
  switch (sort.TAG) {
    case "Name":
      return {
        createdAt: undefined,
        active: undefined,
        name: toRawDirection(sort._0),
        producer: undefined,
        purchasedPrice: undefined
      };
    case "Producer":
      return {
        createdAt: undefined,
        active: undefined,
        name: undefined,
        producer: toRawDirection(sort._0),
        purchasedPrice: undefined
      };
    case "PurchasePrice":
      return {
        createdAt: undefined,
        active: undefined,
        name: undefined,
        producer: undefined,
        purchasedPrice: toRawDirection(sort._0)
      };
    case "CreatedAt":
      return {
        createdAt: toRawDirection(sort._0),
        active: undefined,
        name: undefined,
        producer: undefined,
        purchasedPrice: undefined
      };
  }
}
function catalogListSingleShopQueryVariablesFilterBy(param) {
  let stock = param.stock;
  let producer = param.producer;
  let supplier = param.supplier;
  let category = param.category;
  let statuses = param.statuses;
  let shop = param.shop;
  let active = activeFromStatuses(statuses);
  let match = archivedFromStatuses(statuses);
  let tmp;
  if (category !== undefined) {
    let categoryId = category.id;
    tmp = {
      _equals: categoryId == null ? null : categoryId
    };
  } else {
    tmp = undefined;
  }
  let tmp$1;
  if (supplier !== undefined) {
    let supplierId = supplier.id;
    tmp$1 = {
      _equals: supplierId == null ? null : supplierId
    };
  } else {
    tmp$1 = undefined;
  }
  return {
    shopIds: shop !== undefined ? {
      _in: [shop.id]
    } : undefined,
    stockKeepingUnit: undefined,
    ean13: undefined,
    active: active !== undefined ? {
      _equals: active
    } : undefined,
    archived: match !== undefined ? match ? "ONLY" : "EXCLUDED" : "INCLUDED",
    createdAt: undefined,
    updatedAt: undefined,
    categoryId: tmp,
    supplierId: tmp$1,
    stock: stock !== undefined ? {
      _min: stock.min,
      _max: stock.max,
      _between: undefined
    } : undefined,
    producer: producer !== undefined ? {
      _equals: producer
    } : undefined
  };
}
function catalogListSingleShopQueryVariablesOrderBy(sort) {
  let toRawDirection = direction => {
    if (direction === "ascending") {
      return "ASC";
    } else {
      return "DESC";
    }
  };
  switch (sort.TAG) {
    case "Name":
      return {
        createdAt: undefined,
        active: undefined,
        name: toRawDirection(sort._0),
        producer: undefined,
        purchasedPrice: undefined
      };
    case "Producer":
      return {
        createdAt: undefined,
        active: undefined,
        name: undefined,
        producer: toRawDirection(sort._0),
        purchasedPrice: undefined
      };
    case "PurchasePrice":
      return {
        createdAt: undefined,
        active: undefined,
        name: undefined,
        producer: undefined,
        purchasedPrice: toRawDirection(sort._0)
      };
    case "CreatedAt":
      return {
        createdAt: toRawDirection(sort._0),
        active: undefined,
        name: undefined,
        producer: undefined,
        purchasedPrice: undefined
      };
  }
}
function catalogListMultiShopsQueryVariables(param) {
  let match = param.connectionArguments;
  return {
    search: param.searchQuery,
    filterBy: catalogListMultiShopsQueryVariablesFilterBy(param.filters),
    orderBy: [catalogListMultiShopsQueryVariablesOrderBy(param.sorting)],
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last
  };
}
function catalogListSingleShopQueryVariables(param) {
  let match = param.connectionArguments;
  return {
    search: param.searchQuery,
    filterBy: catalogListSingleShopQueryVariablesFilterBy(param.filters),
    orderBy: [catalogListSingleShopQueryVariablesOrderBy(param.sorting)],
    orderByOrderProducts: [{
      createdAt: undefined,
      receptionFinishedAt: "DESC"
    }],
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last
  };
}
function CatalogListPage(props) {
  let variantIdfromLabelEditSettings = props.variantIdfromLabelEditSettings;
  let shops = Auth.useShops();
  let authScope = Auth.useScope();
  let activeShop = Auth.useActiveShop();
  let match = Auth.useScope();
  let organisationAccount;
  organisationAccount = match.TAG === "Organisation";
  let initialFilters_statuses = ["Active"];
  let initialFilters = {
    shop: activeShop,
    statuses: initialFilters_statuses,
    category: undefined,
    supplier: undefined,
    producer: undefined,
    stock: undefined
  };
  let initialState = ResourceList.initialState(ResourceList.defaultEdgesPerPage, initialFilters, {
    TAG: "Name",
    _0: "ascending"
  }, undefined, undefined);
  let filtersJsonCodec = jsonCodec$3(shops);
  let resourceListPropState = ResourceList.use(initialState, filtersJsonCodec, jsonCodec$4, Primitive_option.some(jsonCodec$2), undefined);
  let dispatch = resourceListPropState[1];
  let state = resourceListPropState[0];
  let match$1 = React.useState(() => {});
  let setPrinterStatusResult = match$1[1];
  let match$2 = React.useState(() => {});
  let setNotification = match$2[1];
  let match$3 = React.useState(() => initialValue);
  let setPricingSettings = match$3[1];
  let pricingSettings = match$3[0];
  let queryMultiShopsAsyncResult = ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, Stdlib_Option.isSome(state.filters.shop), undefined, catalogListMultiShopsQueryVariables(state)));
  let querySingleShopAsyncResult = ApolloHelpers.queryResultToAsyncResult(use$1(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, Stdlib_Option.isNone(state.filters.shop), undefined, catalogListSingleShopQueryVariables(state)));
  let pricelistsAsyncResult = AsyncResult.mapError(AsyncResult.mapOk(ApolloHelpers.queryResultToAsyncResult(use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Stdlib_Option.isNone(state.filters.shop), undefined, singleShopQueryVariables(Stdlib_Option.mapOr(state.filters.shop, [], shop => [shop.id])))), singleShopQueryResult), param => {});
  let currentPricelist = AsyncResult.map(pricelistsAsyncResult, result => {
    if (result.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
    let currentPriceId = Stdlib_Option.map(state.extra, extra => extra.price.id);
    let currentPricelist = getCurrentPricelist(result._0, currentPriceId);
    return Stdlib_Option.mapOr(currentPricelist, {
      TAG: "Error",
      _0: undefined
    }, x => ({
      TAG: "Ok",
      _0: x
    }));
  });
  let onRequestPaginate = React.useCallback(action => {
    let startCursor;
    let endCursor;
    let totalCount;
    let exit = 0;
    let exit$1 = 0;
    let exit$2 = 0;
    if (typeof queryMultiShopsAsyncResult !== "object" || queryMultiShopsAsyncResult.TAG !== "Reloading") {
      exit$2 = 4;
    } else {
      let match = queryMultiShopsAsyncResult._0;
      if (match.TAG === "Ok") {
        let match$1 = match._0.variantsDistinctOnCku;
        let match$2 = match$1.pageInfo;
        startCursor = match$2.startCursor;
        endCursor = match$2.endCursor;
        totalCount = match$1.totalCount;
      } else {
        exit$2 = 4;
      }
    }
    if (exit$2 === 4) {
      if (typeof querySingleShopAsyncResult !== "object" || querySingleShopAsyncResult.TAG !== "Reloading") {
        exit$1 = 3;
      } else {
        let match$3 = querySingleShopAsyncResult._0;
        if (match$3.TAG === "Ok") {
          let match$4 = match$3._0.variants;
          let match$5 = match$4.pageInfo;
          startCursor = match$5.startCursor;
          endCursor = match$5.endCursor;
          totalCount = match$4.totalCount;
        } else {
          exit$1 = 3;
        }
      }
    }
    if (exit$1 === 3) {
      if (typeof queryMultiShopsAsyncResult !== "object" || queryMultiShopsAsyncResult.TAG !== "Done") {
        exit = 2;
      } else {
        let match$6 = queryMultiShopsAsyncResult._0;
        if (match$6.TAG === "Ok") {
          let match$7 = match$6._0.variantsDistinctOnCku;
          let match$8 = match$7.pageInfo;
          startCursor = match$8.startCursor;
          endCursor = match$8.endCursor;
          totalCount = match$7.totalCount;
        } else {
          exit = 2;
        }
      }
    }
    if (exit === 2) {
      if (typeof querySingleShopAsyncResult !== "object") {
        return;
      }
      if (querySingleShopAsyncResult.TAG !== "Done") {
        return;
      }
      let match$9 = querySingleShopAsyncResult._0;
      if (match$9.TAG !== "Ok") {
        return;
      }
      let match$10 = match$9._0.variants;
      let match$11 = match$10.pageInfo;
      startCursor = match$11.startCursor;
      endCursor = match$11.endCursor;
      totalCount = match$10.totalCount;
    }
    let totalPages = ResourceList.totalPages(totalCount, ResourceList.defaultEdgesPerPage);
    let nextPage = ResourceList.nextPage(state, action, totalPages);
    let cursors = [startCursor, endCursor];
    if (nextPage !== undefined) {
      return dispatch({
        TAG: "Navigated",
        nextPage: nextPage,
        totalCount: totalCount,
        cursors: cursors
      });
    }
  }, [state.currentPage, queryMultiShopsAsyncResult, querySingleShopAsyncResult]);
  let onTableSortChange = sortDescriptor => {
    let sort = fromSortDescriptor(sortDescriptor);
    if (sort.TAG === "Ok") {
      return dispatch({
        TAG: "SortingUpdated",
        _0: sort._0
      });
    }
  };
  React.useEffect(() => {
    if (state.filters.shop !== activeShop) {
      dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: activeShop,
          statuses: prev.statuses,
          category: prev.category,
          supplier: prev.supplier,
          producer: prev.producer,
          stock: prev.stock
        })
      });
    }
  }, []);
  React.useEffect(() => {
    let match = state.filters.shop;
    if (match === undefined) {
      return;
    }
    let future = CatalogLabel.Print.DefaultPrinterRequest.make(match.id);
    Future.map(future, undefined, result => setPrinterStatusResult(param => result));
    return () => Future.cancel(future);
  }, [state.filters.shop]);
  ReactUpdateEffect.use1(() => {
    dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        statuses: prev.statuses,
        category: undefined,
        supplier: undefined,
        producer: prev.producer,
        stock: prev.stock
      })
    });
  }, [state.filters.shop]);
  let match$4 = useMutations();
  let mutateStockThresholds = match$4[1];
  let mutateCreateStockActivity = match$4[0];
  let showCatalogLabelQuickPrintButton = Stdlib_Option.isSome(state.filters.shop) && Stdlib_Option.mapOr(match$1[0], false, Stdlib_Result.isOk);
  let actionsColumnWidth = showCatalogLabelQuickPrintButton ? 84 : 48;
  let match$5 = pricingSettings.purchasePriceType;
  let match$6 = pricingSettings.retailPriceCalculatingMethod;
  let tmp;
  if (match$5 === "Gross") {
    switch (match$6) {
      case "PurchasePrice":
        tmp = I18n.t("Gross purchase price");
        break;
      case "FullPurchasePrice":
        tmp = I18n.t("Gross full PP");
        break;
      case "AcquisitionCost":
        tmp = I18n.t("Gross acq. cost");
        break;
    }
  } else {
    switch (match$6) {
      case "PurchasePrice":
        tmp = I18n.t("Net purchase price");
        break;
      case "FullPurchasePrice":
        tmp = I18n.t("Net full PP");
        break;
      case "AcquisitionCost":
        tmp = I18n.t("Net acq. cost");
        break;
    }
  }
  let match$7 = state.extra;
  let match$8 = state.filters.shop;
  let tableColumns = [{
    key: "reference",
    name: I18n.t("Name & description"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 405
      },
      width: {
        NAME: "pct",
        VAL: 35
      },
      sticky: true
    },
    allowsSorting: true,
    render: param => {
      let data = param.data;
      let redirectRoute = CatalogRoutes.variantRoute(data.cku);
      let productKind = data.productKind;
      let information_productName = data.productName;
      let information_variantName = data.name;
      let information_sku = data.stockKeepingUnit;
      let information_plu = Stdlib_Option.map(data.priceLookUpCode, plu => plu.toString());
      let information_color = data.color;
      let information_producerName = data.producer;
      let information_designation = data.designation;
      let information_productFamily = data.family;
      let information_region = data.region;
      let information_country = Stdlib_Option.getOr(data.country, nonApplicableStringLiteral);
      let information_categoryName = data.categoryName;
      let information_supplierName = data.supplierName;
      let information_alcoholVolume = Stdlib_Option.map(data.alcoholVolume, alcoholVolume => I18n.decimalFormat(undefined, undefined, 1, undefined, alcoholVolume) + "°");
      let information = {
        productName: information_productName,
        variantName: information_variantName,
        sku: information_sku,
        plu: information_plu,
        color: information_color,
        producerName: information_producerName,
        designation: information_designation,
        productFamily: information_productFamily,
        region: information_region,
        country: information_country,
        categoryName: information_categoryName,
        supplierName: information_supplierName,
        alcoholVolume: information_alcoholVolume
      };
      return JsxRuntime.jsx(ProductReferenceTableCell.make, {
        redirectRoute: redirectRoute,
        productKind: productKind,
        information: information,
        hideProducerAndSupplier: true
      });
    }
  }, {
    key: "producer",
    name: I18n.t("Producer & Supplier"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 120
      },
      width: {
        NAME: "pct",
        VAL: 20
      },
      margin: "medium"
    },
    allowsSorting: true,
    render: param => {
      let match = param.data;
      let supplierName = match.supplierName;
      let label = Stdlib_Option.getOr(match.producer, nonApplicableStringLiteral);
      let sublabel = Stdlib_Option.getOr(supplierName, I18n.t("Not specified"));
      let sublabelVariation = Stdlib_Option.isSome(supplierName) ? "normal" : "subdued";
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: label,
        sublabel: sublabel,
        sublabelVariation: sublabelVariation,
        showCopyButton: true
      });
    }
  }, {
    key: "category",
    name: I18n.t("Category"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 140
      },
      width: {
        NAME: "pct",
        VAL: 16
      },
      margin: "medium"
    },
    render: param => {
      let match = param.data;
      let categoryName = match.categoryName;
      let tmp;
      let exit = 0;
      let exit$1 = 0;
      switch (categoryName) {
        case "Non classé":
          if (authScope.TAG === "Organisation" && authScope.activeShop === undefined) {
            tmp = JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Not classified"),
              variation: "subdued",
              size: "xsmall"
            });
          } else {
            exit$1 = 2;
          }
          break;
        case "VARIABLE":
          if (authScope.TAG === "Organisation" && authScope.activeShop === undefined) {
            tmp = JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Differing"),
              variation: "subdued",
              size: "xsmall"
            });
          } else {
            exit$1 = 2;
          }
          break;
        default:
          exit$1 = 2;
      }
      if (exit$1 === 2) {
        if (authScope.TAG === "Organisation" && authScope.activeShop === undefined) {
          tmp = JsxRuntime.jsx(LabelTableCell.make, {
            label: categoryName,
            textDirection: "rtl"
          });
        } else {
          exit = 1;
        }
      }
      if (exit === 1) {
        tmp = JsxRuntime.jsx(CatalogCategoryEditCell.make, {
          compact: true,
          value: categoryName,
          productId: match.productId
        });
      }
      return JsxRuntime.jsx(JsxRuntime.Fragment, {
        children: tmp
      });
    }
  }, {
    key: "stock",
    name: I18n.t("Stock"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 100
      },
      width: {
        NAME: "px",
        VAL: 175
      },
      margin: "small"
    },
    render: param => {
      let match = param.data;
      let stockIndicator = match.stockState;
      let formattedStockQuantity = match.stockQuantity;
      if (activeShop !== undefined && formattedStockQuantity !== undefined) {
        return JsxRuntime.jsx(make$12, {
          variantId: match.id,
          shopId: activeShop.id,
          deviceId: activeShop.activeWebDeviceId,
          bulkUnit: match.bulkUnit,
          formattedStockQuantity: formattedStockQuantity,
          stockIndicator: stockIndicator,
          stockOrderTriggerThreshold: match.stockOrderTriggerThreshold,
          minStockThreshold: match.minStockThreshold,
          maxStockThreshold: match.maxStockThreshold,
          mutateCreateStockActivity: mutateCreateStockActivity,
          mutateStockThresholds: mutateStockThresholds
        });
      }
      return JsxRuntime.jsx(ProductStockTableCell.make, {
        value: formattedStockQuantity,
        state: stockIndicator,
        size: "xsmall",
        formattedShopsNames: match.formattedShopsNames
      });
    }
  }, {
    key: "purchase-price",
    name: tmp,
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 125
      },
      width: {
        NAME: "px",
        VAL: 170
      }
    },
    allowsSorting: true,
    render: param => {
      let match = param.data;
      if (Stdlib_Option.isSome(activeShop)) {
        return JsxRuntime.jsx(make$16, {
          variantId: match.id,
          bulkUnit: match.bulkUnit,
          feesList: match.feesList,
          discount: match.purchasePriceDiscount,
          purchasePriceType: pricingSettings.purchasePriceType,
          calculatingMethod: pricingSettings.retailPriceCalculatingMethod,
          value: match.purchasePrice
        });
      } else {
        return nonApplicableValueCellElement;
      }
    }
  }, {
    key: "price-differential-indicator",
    name: toShortLabel(pricingSettings.priceDifferentialIndicator),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 82
      },
      width: {
        NAME: "px",
        VAL: 160
      }
    },
    render: param => {
      let match = param.data;
      let retailPrice = match.retailPrice;
      let purchasePrice = match.purchasePrice;
      let match$1 = match.feesList;
      let otherAmount = match$1.otherAmount;
      let taxesAmount = match$1.taxesAmount;
      let transportAmount = match$1.transportAmount;
      if (!Stdlib_Option.isSome(activeShop)) {
        return nonApplicableValueCellElement;
      }
      if (retailPrice !== undefined) {
        if (typeof currentPricelist === "object" && currentPricelist.TAG === "Done") {
          let match$2 = currentPricelist._0;
          if (match$2.TAG === "Ok") {
            let match$3 = pricingSettings.purchasePriceType;
            let netOrGrossPurchasePrice;
            netOrGrossPurchasePrice = match$3 === "Gross" ? purchasePrice : PriceCalculator.Purchase.toNetValue(purchasePrice, match.purchasePriceDiscount);
            let match$4 = pricingSettings.retailPriceCalculatingMethod;
            let computedPurchasePrice;
            switch (match$4) {
              case "PurchasePrice":
                computedPurchasePrice = netOrGrossPurchasePrice;
                break;
              case "FullPurchasePrice":
                computedPurchasePrice = computeFullPurchasePrice(netOrGrossPurchasePrice, taxesAmount, otherAmount);
                break;
              case "AcquisitionCost":
                computedPurchasePrice = computeAcquisitionCost(netOrGrossPurchasePrice, transportAmount, taxesAmount, otherAmount);
                break;
            }
            let match$5 = pricingSettings.retailPriceCalculatingMethod;
            let totalChargesAmount;
            switch (match$5) {
              case "PurchasePrice":
                totalChargesAmount = PriceCalculator.sumManyCharges([transportAmount, taxesAmount, otherAmount]);
                break;
              case "FullPurchasePrice":
                totalChargesAmount = transportAmount;
                break;
              case "AcquisitionCost":
                totalChargesAmount = 0;
                break;
            }
            let taxRate = match$2._0.taxIncluded ? match.productTaxRate : 0;
            return JsxRuntime.jsx(CatalogListPage$CatalogListPriceDifferentialIndicatorCell, {
              rateType: pricingSettings.priceDifferentialIndicator,
              taxRate: taxRate,
              purchasePrice: computedPurchasePrice,
              retailPriceExcludingTax: retailPrice.valueExcludingTax,
              totalChargesAmount: totalChargesAmount
            });
          }
        }
      } else if (typeof currentPricelist === "object" && currentPricelist.TAG === "Done" && currentPricelist._0.TAG === "Ok") {
        return JsxRuntime.jsx(Placeholder.NC.make, {});
      }
      if (typeof currentPricelist !== "object" || currentPricelist.TAG !== "Done") {
        return JsxRuntime.jsx(Spinner.make, {
          size: 16
        });
      } else {
        return JsxRuntime.jsx(Placeholder.NC.make, {});
      }
    }
  }, {
    key: "retail-price",
    name: match$7 !== undefined ? match$7.price.name : I18n.t("Retail price"),
    layout: {
      headerActionComponent: match$8 !== undefined ? JsxRuntime.jsx(make$9, {
        shopId: match$8.id,
        pricelistsAsyncResult: pricelistsAsyncResult,
        price: Stdlib_Option.map(state.extra, extra => extra.price),
        onRequestPriceChange: value => dispatch({
          TAG: "ExtraUpdated",
          _0: {
            price: value
          }
        })
      }) : null,
      minWidth: Stdlib_Option.isSome(activeShop) ? {
        NAME: "px",
        VAL: 110
      } : {
        NAME: "px",
        VAL: 80
      },
      width: {
        NAME: "px",
        VAL: 170
      }
    },
    render: param => {
      let match = param.data;
      let purchasePrice = match.purchasePrice;
      let feesList = match.feesList;
      let otherAmount = feesList.otherAmount;
      let taxesAmount = feesList.taxesAmount;
      if (activeShop === undefined) {
        return nonApplicableValueCellElement;
      }
      if (typeof currentPricelist === "object" && currentPricelist.TAG === "Done") {
        let pricelist = currentPricelist._0;
        if (pricelist.TAG === "Ok") {
          let match$1 = pricingSettings.purchasePriceType;
          let netOrGrossPurchasePrice;
          netOrGrossPurchasePrice = match$1 === "Gross" ? purchasePrice : PriceCalculator.Purchase.toNetValue(purchasePrice, match.purchasePriceDiscount);
          let match$2 = pricingSettings.retailPriceCalculatingMethod;
          let computedPurchasePrice;
          switch (match$2) {
            case "PurchasePrice":
              computedPurchasePrice = netOrGrossPurchasePrice;
              break;
            case "FullPurchasePrice":
              computedPurchasePrice = computeFullPurchasePrice(netOrGrossPurchasePrice, taxesAmount, otherAmount);
              break;
            case "AcquisitionCost":
              computedPurchasePrice = computeAcquisitionCost(netOrGrossPurchasePrice, feesList.transportAmount, taxesAmount, otherAmount);
              break;
          }
          return JsxRuntime.jsx(make$22, {
            variantId: match.id,
            shopId: activeShop.id,
            pricelist: pricelist._0,
            bulkUnit: match.bulkUnit,
            taxRate: match.productTaxRate,
            feesList: feesList,
            rateType: pricingSettings.priceDifferentialIndicator,
            calculatingMethod: pricingSettings.retailPriceCalculatingMethod,
            purchasePrice: computedPurchasePrice,
            value: match.retailPrice
          });
        }
      }
      if (typeof currentPricelist !== "object" || currentPricelist.TAG !== "Done") {
        return JsxRuntime.jsx(Spinner.make, {
          size: 16
        });
      } else {
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: Placeholder.NC.text,
          labelVariation: "subdued"
        });
      }
    }
  }, {
    key: "created-at",
    name: I18n.t("Creation date"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 80
      },
      width: {
        NAME: "px",
        VAL: 140
      }
    },
    allowsSorting: true,
    render: param => {
      let createdAt = param.data.createdAt;
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: DateHelpers.formateToShortDate(createdAt),
        sublabel: DateHelpers.formateToShortTime(undefined, createdAt)
      });
    }
  }, {
    key: "status",
    name: I18n.t("Status"),
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 100
      },
      width: {
        NAME: "px",
        VAL: 120
      },
      margin: "large"
    },
    render: param => {
      let status = param.data.status;
      if (status !== undefined) {
        return JsxRuntime.jsx(CatalogProduct.Status.Badge.make, {
          value: status
        });
      } else {
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: I18n.t("Differing"),
          labelVariation: "subdued"
        });
      }
    }
  }, {
    key: "actions",
    layout: {
      minWidth: {
        NAME: "px",
        VAL: actionsColumnWidth
      },
      width: {
        NAME: "px",
        VAL: actionsColumnWidth
      },
      alignX: "flexEnd",
      sticky: true
    },
    render: param => {
      let match = param.data;
      let id = match.id;
      let tmp;
      if (showCatalogLabelQuickPrintButton) {
        let match$1 = state.filters.shop;
        tmp = match$1 !== undefined ? JsxRuntime.jsx(CatalogLabelQuickPrintButton.make, {
          variation: "shortButton",
          fromEditRedirection: variantIdfromLabelEditSettings === id,
          variantId: id,
          shopId: match$1.id,
          requestBarcodeCompletion: CatalogLabel.BarcodeCompletionRequest.make,
          requestLabelsPrinting: CatalogLabel.Print.LabelsRequest.make,
          onRequestNotification: value => setNotification(param => value)
        }) : null;
      } else {
        tmp = null;
      }
      return JsxRuntime.jsx(Offset.make, {
        children: JsxRuntime.jsxs(Inline.make, {
          children: [tmp, JsxRuntime.jsx(CatalogTableActions.make, {
            cku: match.cku,
            id: id,
            status: match.status
          })]
        }),
        right: -10,
        width: actionsColumnWidth,
        height: 32
      });
    }
  }];
  let shopFilter = organisationAccount ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {
    variation: "secondary",
    value: state.filters.shop,
    hideLabel: true,
    truncateItemLabel: true,
    onChange: shop => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: shop,
        statuses: prev.statuses,
        category: prev.category,
        supplier: prev.supplier,
        producer: prev.producer,
        stock: prev.stock
      })
    })
  }) : null;
  let filters = [JsxRuntime.jsx(make$23, {
    value: state.filters.statuses,
    onChange: statuses => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        statuses: statuses,
        category: prev.category,
        supplier: prev.supplier,
        producer: prev.producer,
        stock: prev.stock
      })
    })
  }), JsxRuntime.jsx(CatalogCategorySelectFilter.make, {
    shopId: Stdlib_Option.map(activeShop, shop => shop.id),
    value: state.filters.category,
    onChange: category => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        statuses: prev.statuses,
        category: category,
        supplier: prev.supplier,
        producer: prev.producer,
        stock: prev.stock
      })
    })
  }), JsxRuntime.jsx(SupplierSelect.make, {
    size: "compact",
    label: I18n.t("Supplier"),
    preset: "filter",
    showDefaultItems: true,
    hideOverlayFooter: true,
    shopId: Stdlib_Option.map(activeShop, shop => shop.id),
    value: state.filters.supplier,
    onChange: supplier => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        statuses: prev.statuses,
        category: prev.category,
        supplier: supplier,
        producer: prev.producer,
        stock: prev.stock
      })
    })
  }), JsxRuntime.jsx(CatalogProducerSelect.make, {
    shopId: Stdlib_Option.map(activeShop, shop => shop.id),
    value: state.filters.producer,
    onChange: producer => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        statuses: prev.statuses,
        category: prev.category,
        supplier: prev.supplier,
        producer: producer,
        stock: prev.stock
      })
    })
  }), JsxRuntime.jsx(CatalogStockRangeSelect.make, {
    disabled: Stdlib_Option.isNone(activeShop),
    value: state.filters.stock,
    onChange: stock => dispatch({
      TAG: "FiltersUpdated",
      _0: prev => ({
        shop: prev.shop,
        statuses: prev.statuses,
        category: prev.category,
        supplier: prev.supplier,
        producer: prev.producer,
        stock: stock
      })
    })
  })];
  let match$9 = state.filters;
  let activeFiltersCount = [Primitive_object.notequal(match$9.statuses, ["Active"]), Stdlib_Option.isSome(match$9.category), Stdlib_Option.isSome(match$9.supplier), Stdlib_Option.isSome(match$9.producer), Stdlib_Option.isSome(match$9.stock)].filter(active => active).length;
  let handleFilterReset = activeFiltersCount > 0 ? () => dispatch({
    TAG: "FiltersUpdated",
    _0: param => initialState.filters
  }) : undefined;
  let mainAction = JsxRuntime.jsx(make$1, {
    onChange: value => setPricingSettings(param => value)
  });
  let match$10 = makeFromFilters(state.filters);
  let variantsArchived = match$10.variantsArchived;
  let variantsActive = match$10.variantsActive;
  let shopId = match$10.shopId;
  let match$11 = Auth.useShops();
  let shopIds = match$11.length !== 0 ? shopId !== undefined ? [shopId] : match$11.map(shop => shop.id) : undefined;
  let menuActionsItemHref = productKind => CatalogRoutes.productCreateRoute + "?" + CatalogProductEditUrlQueryString.CreateProduct.encode({
    productKind: productKind
  });
  let actions = JsxRuntime.jsxs(Inline.make, {
    children: [shopIds !== undefined ? JsxRuntime.jsx(CatalogListPage$CatalogListInventoryExportRequest$ShortIconButton, {
      tooltip: activeFiltersCount === 0 ? I18n.t("Export inventory") : I18n.t("Export filtered inventory"),
      shopIds: shopIds,
      activeFilters: activeFiltersCount > 0,
      variantsActive: variantsActive,
      variantsArchived: variantsArchived,
      categoryId: match$10.categoryId,
      supplierId: match$10.supplierId,
      producer: match$10.producer,
      stock: match$10.stock,
      onRequestNotification: result => setNotification(param => result)
    }) : null, JsxRuntime.jsx(Button.make, {
      tone: {
        NAME: "neutral",
        VAL: {
          quiet: true
        }
      },
      icon: "label_v1",
      tooltipText: I18n.t("Generate labels"),
      href: CatalogRoutes.labelsCreateRoute
    }), JsxRuntime.jsx(CatalogListPage$CatalogListMorePageMenuActions, {
      shopId: shopId,
      variantsActive: variantsActive,
      variantsArchived: variantsArchived,
      organisationAccount: organisationAccount,
      onRequestNotification: result => setNotification(param => result)
    }), JsxRuntime.jsx(CanarySeparator.make, {}), JsxRuntime.jsxs(MenuActions.make, {
      children: [JsxRuntime.jsx(MenuActions.Item.make, {
        title: CatalogProduct.Kind.toLabel(true, undefined, "SIMPLE"),
        href: menuActionsItemHref("SIMPLE"),
        icon: "simple_product"
      }, "simple"), JsxRuntime.jsxs(MenuActions.Section.make, {
        children: [JsxRuntime.jsx(MenuActions.Item.make, {
          title: CatalogProduct.Kind.toLabel(true, undefined, "WINE"),
          href: menuActionsItemHref("WINE"),
          icon: "wine_product"
        }), JsxRuntime.jsx(MenuActions.Item.make, {
          title: CatalogProduct.Kind.toLabel(true, undefined, "SPIRITUOUS"),
          href: menuActionsItemHref("SPIRITUOUS"),
          icon: "spirit_product"
        }), JsxRuntime.jsx(MenuActions.Item.make, {
          title: CatalogProduct.Kind.toLabel(true, undefined, "BEER"),
          href: menuActionsItemHref("BEER"),
          icon: "beer_product"
        })]
      })],
      trigger: {
        TAG: "Normal",
        label: I18n.t("New reference"),
        variant: "solid",
        tone: "brand"
      }
    })],
    space: "small"
  });
  let searchBar = JsxRuntime.jsx(ResourceListPage.ResourceListSearchBar.make, {
    placeholder: I18n.t("Search") + "...",
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let tableEmptyState;
  let exit = 0;
  if (state.currentPage !== 1 || state.searchQuery !== "") {
    exit = 1;
  } else {
    let match$12 = state.filters;
    if (match$12.category !== undefined || match$12.supplier !== undefined || match$12.producer !== undefined || match$12.shop !== activeShop || match$12.statuses.length !== 0) {
      exit = 1;
    } else {
      tableEmptyState = JsxRuntime.jsx(EmptyState.make, {
        illustration: Illustration.create,
        title: I18n.t("Welcome to the catalog space.")
      });
    }
  }
  if (exit === 1) {
    tableEmptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword/filter or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query and filters"),
        onPress: () => dispatch({
          TAG: "Reset",
          _0: initialState
        })
      })
    });
  }
  let paginationCurrentPage = state.currentPage;
  let match$13;
  let exit$1 = 0;
  let totalCount;
  let exit$2 = 0;
  let exit$3 = 0;
  let exit$4 = 0;
  if (typeof queryMultiShopsAsyncResult !== "object" || queryMultiShopsAsyncResult.TAG !== "Done") {
    exit$4 = 4;
  } else {
    let match$14 = queryMultiShopsAsyncResult._0;
    if (match$14.TAG === "Ok") {
      totalCount = match$14._0.variantsDistinctOnCku.totalCount;
      exit$1 = 1;
    } else {
      exit$4 = 4;
    }
  }
  if (exit$4 === 4) {
    if (typeof querySingleShopAsyncResult !== "object" || querySingleShopAsyncResult.TAG !== "Done") {
      exit$3 = 3;
    } else {
      let match$15 = querySingleShopAsyncResult._0;
      if (match$15.TAG === "Ok") {
        totalCount = match$15._0.variants.totalCount;
        exit$1 = 1;
      } else {
        exit$3 = 3;
      }
    }
  }
  if (exit$3 === 3) {
    if (typeof queryMultiShopsAsyncResult !== "object" || queryMultiShopsAsyncResult.TAG !== "Reloading") {
      exit$2 = 2;
    } else {
      let match$16 = queryMultiShopsAsyncResult._0;
      if (match$16.TAG === "Ok") {
        totalCount = match$16._0.variantsDistinctOnCku.totalCount;
        exit$1 = 1;
      } else {
        exit$2 = 2;
      }
    }
  }
  if (exit$2 === 2) {
    if (typeof querySingleShopAsyncResult !== "object" || querySingleShopAsyncResult.TAG !== "Reloading") {
      match$13 = [0, 1];
    } else {
      let match$17 = querySingleShopAsyncResult._0;
      if (match$17.TAG === "Ok") {
        totalCount = match$17._0.variants.totalCount;
        exit$1 = 1;
      } else {
        match$13 = [0, 1];
      }
    }
  }
  if (exit$1 === 1) {
    match$13 = [totalCount, ResourceList.totalPages(totalCount, ResourceList.defaultEdgesPerPage)];
  }
  let paginationLoading = AsyncResult.isReloading(queryMultiShopsAsyncResult) || AsyncResult.isReloading(querySingleShopAsyncResult);
  let match$18 = state.connectionArguments;
  let paginationLastDirection = match$18.last !== undefined ? "Backward" : "Forward";
  let tableData = Stdlib_Option.isNone(state.filters.shop) ? AsyncResult.mapError(AsyncResult.mapOk(queryMultiShopsAsyncResult, catalogListMultiShopsTableRowsFromQueryResult), param => {}) : AsyncResult.mapError(AsyncResult.mapOk(querySingleShopAsyncResult, result => catalogListSingleShopTableRowsFromQueryResult(result, Stdlib_Option.map(state.extra, extra => extra.price.id))), param => {});
  let tableLoadingOperations = Stdlib_Option.isNone(state.filters.shop) ? tableLoadingMultiShopsOperations : tableLoadingSingleShopOperations;
  let tableHeader = JsxRuntime.jsx(make, {
    notification: match$2[0],
    onRequestClose: () => setNotification(param => {})
  });
  let tableLoadingInteraction = ResourceList.useLoadingInteraction(state, undefined);
  return JsxRuntime.jsx(ResourceListPage.make, {
    title: I18n.t("Catalog"),
    shopFilter: shopFilter,
    filters: filters,
    activeFiltersCount: activeFiltersCount,
    mainAction: mainAction,
    actions: actions,
    searchBar: searchBar,
    tableHeader: tableHeader,
    tableData: tableData,
    tableColumns: tableColumns,
    tableKeyExtractor: keyExtractor,
    tableEmptyState: tableEmptyState,
    paginationCurrentPage: paginationCurrentPage,
    paginationTotalCount: match$13[0],
    paginationTotalPages: match$13[1],
    paginationLoading: paginationLoading,
    paginationLastDirection: paginationLastDirection,
    tableSortDescriptor: toSortDescriptor(state.sorting),
    tableLoadingOperations: tableLoadingOperations,
    tableLoadingInteraction: tableLoadingInteraction,
    onTableSortChange: onTableSortChange,
    onRequestPaginate: onRequestPaginate,
    onRequestResetFilters: handleFilterReset
  });
}
let make$24 = React.memo(CatalogListPage);
export { nonApplicableStringLiteral, nonApplicableValueCellElement, CatalogListMultiShopsQuery, CatalogListSingleShopQuery, tableLoadingMultiShopsOperations, tableLoadingSingleShopOperations, CatalogListPricelist, CatalogListTableRow, CatalogListNotificationBanner, CatalogListPricingSettings, CatalogListSettingsPopoverButton, CatalogListInventoryExportRequest, CatalogListMorePageMenuActions, CatalogListExtraParamsPrice, CatalogListTableHeaderActionPricelistSelect, CatalogListStockCell, CatalogListPurchasePriceCell, CatalogListRetailPriceCell, CatalogListPriceDifferentialIndicatorCell, CatalogListExtraParams, CatalogListFilters, CatalogListFilterStatusSelect, CatalogListSorting, CatalogListSheetExportInput, catalogListMultiShopsTableRowsFromQueryResult, catalogListSingleShopTableRowsFromQueryResult, catalogListMultiShopsQueryVariablesFilterBy, catalogListMultiShopsQueryVariablesOrderBy, catalogListSingleShopQueryVariablesFilterBy, catalogListSingleShopQueryVariablesOrderBy, catalogListMultiShopsQueryVariables, catalogListSingleShopQueryVariables, make$24 as make };
/* nonApplicableValueCellElement Not a pure module */